import React, {
  useState,
  useEffect,
  createRef,
  useLayoutEffect,
  useRef,
} from "react";
import { Link, useLocation, useHistory } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import { TabContent, TabPane, Nav, NavItem, NavLink, Alert } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Dropzone from "react-dropzone-uploader";
import { videoTagString, VideoTag } from "react-video-tag";
import ReactTags from "react-tag-autocomplete";
import Config from "../../Config.js";
import swal from "sweetalert";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "antd/dist/antd.css";
import ReactTagInput from "@pathofdev/react-tag-input";
import "@pathofdev/react-tag-input/build/index.css";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { editorConfiguration } from "components/EditorConfiguration.js";
import Moment from "moment";
import {
  CheckQRCodeCategoriesManagementEnabled,
  CheckBulkQRcodecount,
  CheckCheckAPDynamicQrCodeCountenabled,
} from "../../api/packageApi";
import {
  GetDominUrl
} from "../../api/apiconfiguration.js";
import QRCode from "qrcode.react";
import jsPDF from "jspdf";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";
import { NumericFormat } from "react-number-format";
import TextareaAutosize from "react-textarea-autosize";
import { SkuDelete } from "../../api/articleproductApi";
import { CheckStorageLimit } from "../../api/packageApi";
function Addnew(props) {
  const location = useLocation();
  let history = useHistory();

  const [isrefresh, setisrefresh] = useState(false);
  const [EditArticleDetailsCallDone, setEditArticleDetailsCallDone] =
    useState(false);
  const [modalQrcode, setmodalQrcode] = useState(false);
  const [batchnumberisOpen, setBatchnumberisOpen] = useState(false);
  const [modalvendor, setmodalvendor] = useState(false);


  const [isArticleDisable, setisArticleDisable] = useState(false);
  const [ArticleName, setArticleName] = useState("");
  const [categoryModalisOpen, setcategoryModalisOpen] = useState(false);

  const [LableModelisOpen, setLableModelisOpen] = useState(false);

  const [SegmentModalisOpen, setSegmentModalisOpen] = useState(false);
  const [SegmentEditisOpen, setSegmentEditisOpen] = useState(false);
  const [SegmentEditDetailsisOpen, setSegmentEditDetailsisOpen] =
    useState(false);
  const [
    ArticleSegmentDocumentEditNameisOpen,
    setArticleSegmentDocumentEditNameisOpen,
  ] = useState(false);

  const [IsNameAndCatDisplay, setIsNameAndCatDisplay] = useState(true);
  const [IsPriceDisplay, setIsPriceDisplay] = useState(true);
  const [IsLabelDisplay, setIsLabelDisplay] = useState(true);
  const [IsSKUDisplay, setIsSKUDisplay] = useState(false);
  const [IsSizeTabelDisplay, setIsSizeTabelDisplay] = useState(true);
  const [IsArticleTypeDisplay, setIsArticleTypeDisplay] = useState(false);
  const [IsArticleImageDisplay, setIsArticleImageDisplay] = useState(true);
  const [IsArticleSegmentImageDisplay, setIsArticleSegmentImageDisplay] =
    useState(true);
  const [
    IsArticleSegmentDescriptionDisplay,
    setIsArticleSegmentDescriptionDisplay,
  ] = useState(true);
  const [IsArticleSegmentVideoDisplay, setIsArticleSegmentVideoDisplay] =
    useState(true);
  const [IsArticleSegmentWebLinkDisplay, setIsArticleSegmentWebLinkDisplay] =
    useState(true);
  const [IsArticleSegmentDocumentDisplay, setIsArticleSegmentDocumentDisplay] =
    useState(true);
  const [IsArticleDescriptionDisplay, setIsArticleDescriptionDisplay] =
    useState(true);
  const [isSubcategoryMaltiple, setisSubcategoryMaltiple] = useState(false);
  const [Isloading, setIsloading] = useState(false);
  //  Arrey
  const [searchArticlenumber, setsearchArticlenumber] = useState([]);
  const [CategoryList, setCategoryList] = useState([]);
  const [SubCategoryList, setSubCategoryList] = useState([]);
  const [ArticlesTypeList, setArticlesTypeList] = useState([]);
  const [ArticleAttributeList, setArticleAttributeList] = useState([]);
  const [LabelList, setLabelList] = useState([]);
  const [CurrencyDetailsList, setCurrencyDetailsList] = useState([]);
  const [ArticleSegmentDocumentlist, setArticleSegmentDocumentlist] = useState(
    []
  );
  const [ArticleSegmentDocumentlistTemp, setArticleSegmentDocumentlistTemp] =
    useState([]);
  const [articleSegmentList, setarticleSegmentList] = useState([]);
  const [articleSegmentWebLinkList, setarticleSegmentWebLinkList] = useState(
    []
  );
  const [subcategorylistnew, setsubcategorylistnew] = useState([]);
  const [selectedAttributeList, setselectedAttributeList] = useState([]);
  const [CombinationList, setCombinationList] = useState([]);
  const [ArticlePicsImageList, setArticlePicsImageList] = useState([]);
  const [ArticlePicsImageListTemp, setArticlePicsImageListTemp] = useState([]);
  const [ArticleSegmentImageLists, setArticleSegmentImageLists] = useState([]);
  const [ArticleSegmentImageListsTemp, setArticleSegmentImageListsTemp] =
    useState([]);
  const [ArticleDocumentList, setArticleDocumentList] = useState([]);
  const [VideosegmentList, setVideosegmentList] = useState([]);
  const [VideosegmentListTemp, setVideosegmentListTemp] = useState([]);
  const [LogoFile, setLogoFile] = useState([]);
  const [IsCertificateDisplay, setIsCertificateDisplay] = useState(true);
  const [batchNumberList, setbatchNumberList] = useState([]);

  //Empty
  const [ArticleNumber, setArticleNumber] = useState("");
  const [SubCategoryError, setSubCategoryError] = useState("");
  const [SubCategoryAddtimeError, setSubCategoryAddtimeError] = useState("");
  const [ArticleNameError, setArticleNameError] = useState("");
  const [SizetablefilePath, setSizetablefilePath] = useState("");
  const [SizeTabel, setSizeTabel] = useState("");
  const [ArticleID, setArticleID] = useState("");
  const [ArticleDocumentID, setArticleDocumentID] = useState("");
  const [ArticleSegmentID, setArticleSegmentID] = useState("");
  const [LogoPath, setLogoPath] = useState("");
  const [LogoPathError, setLogoPathError] = useState("");
  const [SegmentDescription, setSegmentDescription] = useState("");
  const [SegmentDescriptionError, setSegmentDescriptionError] = useState("");
  const [LableDescription, setLableDescription] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const [MainCategory, setMainCategory] = useState("");
  const [MainCategoryError, setMainCategoryError] = useState("");
  const [CategoryId, setCategoryId] = useState("");
  const [Categoryselectname, setCategoryselectname] = useState("");
  const [subCategoryselectname, setsubCategoryselectname] = useState("");
  const [CategoryError, setCategoryError] = useState("");
  const [ArticleTypeError, setArticleTypeError] = useState("");
  const [ArticleSKU, setArticleSKU] = useState("");
  const [OldArticleSKU, setOldArticleSKU] = useState("");
  const [ArticleSKUError, setArticleSKUError] = useState("");
  const [ArticleUploadSegmentImagesError, setArticleUploadSegmentImagesError] =
    useState("");
  const [SubCategoryId, setSubCategoryId] = useState("");
  const [ArticlesTypeId, setArticlesTypeId] = useState("");
  const [LabelId, setLabelId] = useState("");
  const [LabelError, setLabelError] = useState("");
  const [LabelName, setLabelName] = useState("");
  const [LabelNameError, setLabelNameError] = useState("");
  const [CurrencyName, setCurrencyName] = useState("");
  const [CurrencyNameError, setCurrencyNameError] = useState("");
  const [RegularPrice, setRegularPrice] = useState("");
  const [SellPrice, setSellPrice] = useState("");
  const [RegularPriceError, setRegularPriceError] = useState("");
  const [CurrencyId, setCurrencyId] = useState("");
  const [SellPriceError, setSellPriceError] = useState("");
  const [CurrencyError, setCurrencyError] = useState("");
  const [webLink, setwebLink] = useState("");
  const [WebLinkError, setWebLinkError] = useState("");
  const [websitelinkname, setwebsitelinkname] = useState("");
  const [websitelinknameError, setwebsitelinknameError] = useState("");
  const [Title, setTitle] = useState("");
  const [TitleError, setTitleError] = useState("");
  const [DocumentName, setDocumentName] = useState("");
  const [LabelNamError, setLabelNamError] = useState("");
  const [ArticleShortDescription, setArticleShortDescription] = useState("");
  const [ArticleShortDescriptionError, setArticleShortDescriptionError] =
    useState("");
  const [
    IsArticleshortDescriptionDisplay,
    setIsArticleshortDescriptionDisplay,
  ] = useState(true);
  const [CertificateList, setCertificateList] = React.useState([]);
  const [istraveldistanceenable, setistraveldistanceenable] = useState(false);
  const [isenablemadeindisplay, setisenablemadeindisplay] = useState(false);
  const [isarticledistancedisplay, setisarticledistancedisplay] =
    useState(false);

  const [CertificateName, setCertificateName] = useState("");
  const [CertificateNameError, setCertificateNameError] = useState("");
  const [CertificateLogoPath, setCertificateLogoPath] = useState("");
  const [CertificateLogoFile, setCertificateLogoFile] = useState([]);
  const [CertificateLogoFileError, setCertificateLogoFileError] = useState("");
  const [DocumentFile, setDocumentFile] = useState([]);
  const [DocumentFileError, setDocumentFileError] = useState([]);
  const [UserDcoumnetName, setUserDcoumnetName] = useState("");
  const [CertificateDocumentpath, setCertificateDocumentpath] = useState([]);
  const [modalSignupAdd, setmodalSignupAdd] = useState(false);
  const [CertificateWebsiteError, setCertificateWebsiteError] = useState("");
  const [CertificateWebsite, setCertificateWebsite] = useState("");

  const [VendorsName, setVendorsName] = useState("");
  const [VendorsNameError, setVendorsNameError] = useState("");
  const [VendorsLogoPath, setVendorsLogoPath] = useState("");
  const [VendorsLogoError, setVendorsLogoError] = useState("");
  const [Email, setEmail] = useState("");
  const [EmailError, setEmailError] = useState("");
  const [vendorWebsite, setvendorWebsite] = useState("");
  const [vendorWebsiteError, setvendorWebsiteError] = useState("");
  const [VendorStreet, setVendorStreet] = useState("");
  const [VendorStreetError, setVendorStreetError] = useState("");
  const [Postcode, setPostcode] = useState("");
  const [PostcodeError, setPostcodeError] = useState("");
  const [HouseNo, setHouseNo] = useState("");
  const [HouseNoError, setHouseNoError] = useState("");
  const [City, setCity] = useState("");
  const [CityError, setCityError] = useState("");
  const [Country, setCountry] = useState("");
  const [CountryError, setCountryError] = useState("");
  const [State, setState] = useState("");
  const [StateError, setStateError] = useState("");
  const [VendorsDescription, setVendorsDescription] = useState("");
  const [VendorsDescriptionError, setVendorsDescriptionError] = useState("");
  const [VendorsLogoFile, setVendorsLogoFile] = useState([]);
  const [ContactNo, setContactNo] = useState("");
  const [ContactNoError, setContactNoError] = useState("");
  const [CountryId, setCountryId] = useState("");
  const [CountryIdError, setCountryIdError] = useState("");
  const [CountrydetailList, setCountrydetailList] = useState([]);
  const [vendorlist, setvendorlist] = useState([]);
  const [QrCodeString, setQrCodeString] = useState("");
  const [QrCodeID, setQrCodeID] = useState("");
  const [QrCodeStringArticle, setQrCodeStringArticle] = useState("");

  const [selectCombinationID, setselectCombinationID] = useState("");
  const [createdDate, setcreatedDate] = useState("");
  const [DuplicateQrcodeList, setDuplicateQrcodeList] = useState([]);
  const [QrcodeQty, setQrcodeQty] = useState(0);
  const [BatchNumber, setBatchnumber] = useState("");
  const [BatchNumberError, setBatchNumberError] = useState("");
  const [selectBatchNumbername, setselectBatchNumbername] = useState("");
  const [EnableEWarranty, setEnableEWarranty] = useState(false);
  const [isBatchNumber, setisBatchNumber] = useState(false);
  const [VendorID, setVendorID] = useState("");

  const [ExpiryDate, setExpiryDate] = useState(null);
  const [ExpiryDateFinal, setExpiryDateFinal] = useState(null);
  const [ManufactureDate, setManufactureDate] = useState(null);
  const [ManufactureDateFinal, setManufactureDateFinal] = useState(null);
  const [isAttributeshow, setisAttributeshow] = useState(false);
  const [IsArticlechat, setIsArticlechat] = useState(true);
  const [Isrelatedproduct, setIsrelatedproduct] = useState(false);

  const [youTubleVideoLink, setyouTubleVideoLink] = useState("");
  const [youTubleVideoLinkError, setyouTubleVideoLinkError] = useState("");

  const reactTags = React.createRef();

  const [subToEmail, setsubToEmail] = useState([]);
  const [isToEamil, setisToEamil] = useState(false);
  const [isToEamilAttribute, setisToEamilAttribute] = useState(false);
  const [ToemailEmptyError, setToemailEmptyError] = useState("");
  const [isToemailMaltiple, setisToemailMaltiple] = useState(false);
  const [isDuplicateToEamil, setisDuplicateToEamil] = useState(false);

  const [ShortDescriptionisloding, setShortDescriptionisloding] =
    useState(false);

  const [Attributeisloding, setAttributeisloding] = useState(false);
  const [Certificatesisloding, setCertificatesisloding] = useState(false);

  const [OldLabelName, setOldLabelName] = useState("");
  const ref = useRef();

  const domainFrontUrl = useRef("");

  useEffect(() => {
    // document.body.style.overflow = "hidden";
    let checkLogin = localStorage.getItem("loginUserID");
    if (checkLogin == "" || checkLogin == "" || checkLogin == undefined) {
      props.history.push("Login1");
    } else {
      getDominUrl();
      GetAllDropdwonArticle();
      getAllCurrencyDropdownlist();
      getAllCountryDropdownlist();
      GetAllvendor();
    }
  }, []);

  const getDominUrl = async () => {
    let response = await GetDominUrl();
    if (response !== null && response.domainName !== null && response.domainName !== "") {
      domainFrontUrl.current = response.domainName;
    }
    else {
      domainFrontUrl.current = "";
    }
  }

  useEffect(() => {
    getAllCertificateList("");
  }, []);

  useEffect(() => {
    getqrcodeAttributes();
  }, [
    VendorID,
    ManufactureDate,
    selectBatchNumbername,
    selectCombinationID,
    ExpiryDate,
  ]);

  const getallbatchNumber = () => {
    if (ArticleID !== null && ArticleID !== "" && ArticleID != undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setbatchNumberList([]);
      fetch(
        Config.apiUrl +
        "QrcodeBatchNumber/GetallQrcodeBatchnumber?ProductID=" +
        ArticleID,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result != null) {
            setbatchNumberList(result);
          }
        });
      });
    }
  };

  const addbatchnumber = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      BatchNumber === null ||
      BatchNumber === "" ||
      BatchNumber === undefined
    ) {
      retval = false;
      setBatchNumberError("please enter a batch number");
      return;
    }

    var data = {
      BatchNumber: BatchNumber,
      ProductID: ArticleID,
      UserCompanyID: loginid,
      CreatedBy: loginid,
      UpdatedBy: loginid,
    };
    fetch(Config.apiUrl + "QrcodeBatchNumber/Create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(data),
    })
      .then((result1) => {
        result1.json().then((resp) => {
          if (resp !== null && resp.data !== null) {
            getallbatchNumber();
            setBatchnumber("");
            swal("Congratulations ! save successfully.", {
              icon: "success",
            });
          } else {
          }
        });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  // vendor

  const GetAllvendor = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setvendorlist([]);
    fetch(Config.apiUrl + "Vendor/DropdownList", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setvendorlist(result);
        }
      });
    });
  };
  const onChangeVendorsEmail = (event) => {
    setEmailError("");
    setEmail(event.target.value);
  };
  const onChangeVendorsContactNo = (event) => {
    setContactNoError("");
    // setContactNo(event.target.value);
    setContactNo(event.target.value.replace(/[^\d+]/, ""));
  };
  const onChangeVendorsWebsite = (event) => {
    setvendorWebsiteError("");
    setvendorWebsite(event.target.value);
  };
  const onChangeVendorsStreet = (event) => {
    setVendorStreetError("");
    setVendorStreet(event.target.value);
  };
  const onChangeVendorsName = (event) => {
    setVendorsNameError("");
    setVendorsName(event.target.value);
  };
  const VendorsuploadSingleFile = (e) => {
    setVendorsLogoFile([]);
    setVendorsLogoPath();
    setVendorsLogoError("");
    if (e.target.files.length > 0) {
      setVendorsLogoPath(URL.createObjectURL(e.target.files[0]));
      setVendorsLogoFile(e.target.files[0]);
    }
  };

  const onChangeVendorsHouseNo = (event) => {
    setHouseNoError("");
    setHouseNo(event.target.value);
  };
  const onChangeVendorsPostcode = (event) => {
    setPostcodeError("");
    setPostcode(event.target.value);
  };

  const onChangeVendorsCity = (event) => {
    setCityError("");
    setCity(event.target.value);
  };

  const onChangeVendorsdescription = (event) => {
    setVendorsDescriptionError("");
    setVendorsDescription(event.target.value);
  };
  const onChangeParamdetaildropdown = (event) => {
    let parId = event.target.value;
    setCountryIdError("");
    setCountryId(parId);
  };

  // vendor

  //FixSegmentName create first time
  const CretaeFixSegmentName = (ArticleIDObj) => {
    setisrefresh(true);
    document.body.style.overflow = "hidden";
    let titleList = ["Product Detail", "Material", "Sustainability"];
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "ArticleProductSegment/GenerateDefault?articleId=" +
      ArticleIDObj,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(titleList),
      }
    ).then((result) => {
      result.json().then((resp) => {
        //console.log(resp);
        document.body.style.overflow = "auto";
        setisrefresh(false);
        if (resp != null) {
          getAllArticleSegmentList(ArticleIDObj);
        }
      });
    });
  };
  //End

  const getAllCertificateList = (ArticaleIDObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "Certificate/GetAllCertificateweb?ArticaleID=" +
      ArticaleIDObj,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setCertificateList(result);
        }
      });
    });
  };

  const ArticlenumberhandleInputChange = (event) => {
    setsearchArticlenumber([]);
    setArticleNumber(event.target.value);
    const ArticleNumberObj = event.target.value;
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (ArticleNumberObj !== "") {
      fetch(
        Config.apiUrl +
        "ArticleProduct/GetAllArticlesNumberPagination?SearchQuery=" +
        ArticleNumberObj,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => response.json())
        .then((Articlenumberlist) => {
          if (Articlenumberlist.length > 0) {
            const filteredData = Articlenumberlist.filter((element) => {
              return element.articleNumber
                .toLowerCase()
                .includes(ArticleNumberObj.toLowerCase());
            });
            setsearchArticlenumber(filteredData);
          } else {
            //setArticlesnum(false);
            const filteredData = [];
            setsearchArticlenumber(filteredData);
          }
        });
    } else {
      const filteredData = [];
      //setArticlesnum(false);
      setsearchArticlenumber(filteredData);
    }
  };
  const GetAllDropdwonArticle = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let EmaptyArrry = [];
    fetch(Config.apiUrl + "ArticleProduct/AllDropdwon", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result.labelDetail.length > 0) {
          setLabelList(result.labelDetail);
        } else {
          setLabelList(EmaptyArrry);
        }

        if (result.categorydetail.length > 0) {
          setCategoryList(result.categorydetail);
        } else {
          setCategoryList(EmaptyArrry);
        }

        if (result.articletype.length > 0) {
          setArticlesTypeList(result.articletype);
        } else {
          setArticlesTypeList(EmaptyArrry);
        }
        // if (result.supplierdetail.length > 0) {
        //     setSupplierList(result.supplierdetail);
        // }
        // else {
        //     setSupplierList(EmaptyArrry);
        // }
      });
    });
  };
  const ArticleImagedelete = (_idFileUplod) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(Config.apiUrl + "FileUpload/Delete?id=" + _idFileUplod, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }).then((result) => {
          result.json().then((resp) => {
            if (resp === true) {
              getAllArticlePicsList(ArticleID);
              swal("Congratulations! Your data deleted successfully.", {
                icon: "success",
              });
            } else {
              swal("Your Article Images is safe!");
            }
          });
        });
      }
    });
  };

  const ArticleProductCreate = async (_idObj) => {
    setisrefresh(true);
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = await localStorage.getItem("UserCompanyId");
    fetch(
      Config.apiUrl + "ArticleProduct/GenerateProductFromArticle?id=" + _idObj,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((response) => {
      response.json().then((result) => {
        if (result != null) {
          setArticleID(result._id);
          setisrefresh(false);
          document.body.style.overflow = "auto";
          ArticlenumbergetbyID(result._id);
        }
      });
    });
  };

  const getqrcodearticle = (articleID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (articleID !== null && articleID !== "" && articleID !== undefined) {
      let ManufactureDateFinalTemp = "";
      if (ManufactureDate !== null) {
        ManufactureDateFinalTemp = Moment(ManufactureDate).format("YYYY-MM-DD");
      }
      let ExpiryDateFinalTemp = "";
      if (ExpiryDate !== null) {
        ExpiryDateFinalTemp = Moment(ExpiryDate).format("YYYY-MM-DD");
      }

      fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetQrcodestringfilter?targetId=" +
        selectCombinationID +
        "&BatchNumber=" +
        selectBatchNumbername +
        "&ManufactureDate=" +
        ManufactureDateFinalTemp +
        "&VendorsID=" +
        VendorID +
        "&productID=" +
        articleID +
        "&Expirydate=" +
        ExpiryDateFinalTemp,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          if (
            responseJson !== null &&
            responseJson?._id !== "" &&
            responseJson?._id !== null &&
            responseJson?._id !== undefined
          ) {
            setQrCodeID(responseJson?._id);
            let qrcodestring = domainFrontUrl.current + responseJson.codeString;
            // // setQrCodeString(responseJson.codeString);
            // // setQrCodeStringArticle(responseJson.codeString);
            setQrCodeString(qrcodestring);
            setQrCodeStringArticle(qrcodestring);

            setQrcodeQty(0);
            setDuplicateQrcodeList("");
          } else {
            setQrCodeString("");
            setQrCodeStringArticle("");
            setQrCodeID("");
            setQrcodeQty(0);
            setDuplicateQrcodeList("");
          }
        })
        .catch((error) => {
          console.log(error);
          setQrCodeString("");
          setQrCodeStringArticle("");
          setQrCodeID("");
        });

    } else {
      setQrCodeStringArticle("");
      setQrCodeID("");
    }
    //
  };
  const ArticlenumbergetbyID = (_idObj) => {
    setisrefresh(true);
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (_idObj !== "" || _idObj !== null || _idObj !== undefined) {
      onEditBindAttributeValue(_idObj);
      getAllArticleSegmentList(_idObj);
      getqrcodearticle(_idObj);
      fetch(Config.apiUrl + "ArticleProduct/ById?id=" + _idObj, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }).then((response) => {
        response.json().then((result) => {
          if (result != null) {
            setisrefresh(false);
            document.body.style.overflow = "auto";
            setsearchArticlenumber([]);
            var cat1 = result.categoryID;
            var sub1 = result.subCategoryID;
            setCategoryId(cat1);
            if (cat1 !== "" && cat1 !== null && cat1 !== undefined) {
              getSubCategoryDropdownlistByCategoryID(cat1);
            }
            setArticleNumber(result.articleNumber);
            setisArticleDisable(true);
            setArticleName(result.articleName);
            setLabelId(result.labelID);
            setArticlesTypeId(result.articleTypeID);
            if (result.labelID !== null && result.labelID !== "" && result.labelID !== undefined) {
              setOldLabelName(result.labelDetail?.name ? result.labelDetail?.name : "");
            }
            // setArticlesTypeId(result.articleTypeID);
            if (result.articleTypeID === "62ac68e2830ffdde1c0b09b9") {
              onEditBindAttributeValue(_idObj);
              setisAttributeshow(true);
            }
            setCurrencyId(result.currencyID);

            if (result?.regularPrice && result?.regularPrice !== "0" && result?.regularPrice !== 0) {
              setRegularPrice(result.regularPrice);
            } else {
              setRegularPrice("");
            }
            if (result?.sellPrice && result?.sellPrice !== "0" && result?.sellPrice !== 0) {
              setSellPrice(result?.sellPrice);
            } else {
              setSellPrice("");
            }
            if (result.categorydetail != null && result.categorydetail != "") {
              setCategoryselectname(result.categorydetail.name);
              if (
                result.subCategoryDetail !== null &&
                result.subCategoryDetail !== ""
              ) {
                setsubCategoryselectname(result.subCategoryDetail.name);
              }
            }
            if (
              result.createdDate !== null &&
              result.createdDate !== "" &&
              result.createdDate !== undefined
            ) {
              let d = Moment(result.createdDate).format("YYYY-MM-DD");
              setcreatedDate(Moment(result.createdDate).format("YYYY-MM-DD"));
            }
            getArticleSizeImage(result?._id);
            setArticleSKU(result?.articleSKU);
            setOldArticleSKU(result?.articleSKU ? result?.articleSKU : "");
            setIsNameAndCatDisplay(result?.isNameAndCatDisplay);
            setIsPriceDisplay(result?.isPriceDisplay);
            setIsLabelDisplay(result?.isLabelDisplay);
            setIsSKUDisplay(result?.isSKUDisplay);
            setIsSizeTabelDisplay(result?.isSizeTabelDisplay);
            setIsArticleTypeDisplay(result?.isArticleTypeDisplay);
            setIsArticleDescriptionDisplay(result?.isArticleDescriptionDisplay);
            setistraveldistanceenable(result?.isTravelDistanceEnable);
            setisenablemadeindisplay(result?.isEnableMadeIndisplay);
            setisarticledistancedisplay(result?.isArticleDistanceDisplay);
            setIsArticleImageDisplay(result?.isArticleImageDisplay);
            setIsArticlechat(result?.isArticleChatDisplay);
            setIsrelatedproduct(result?.isRelatedProductDisplay);
            if (result?.shortDescription) {
              setArticleShortDescription(result?.shortDescription);
            } else {
              setArticleShortDescription("");
            }

            setIsArticleshortDescriptionDisplay(
              result?.isShortDescriptionDisplay
            );
            getAllArticlePicsList(result?._id);
            getAllCertificateList(result?._id);
            setArticleID(result._id);
            if (sub1 === "" || sub1 === undefined || sub1 === null) {
              setSubCategoryId("0");
            } else {
              setSubCategoryId(sub1);
            }
          }
        });
      });
    } else {
      document.body.style.overflow = "auto";
      setisrefresh(false);
    }
  };

  const getArticleSizeImage = (articleidObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "FileUpload/?targetID=" +
      articleidObj +
      "&FileType=" +
      "sizetable",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null && result.length > 0) {
          setSizetablefilePath(Config.contentUrl + result[0].filePath);
        } else {
          setSizetablefilePath("");
        }
      });
    });
  };
  const getAllArticlePicsList = (articleidObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "FileUpload/?targetID=" +
      articleidObj +
      "&FileType=" +
      "articleimage",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        setisrefresh(false);
        if (result.length > 0) {
          setArticlePicsImageList(result);
        } else {
          setArticleSegmentImageLists([]);
        }
      });
    });
  };

  const getAllArticleSegmentList = (articleidObj) => {
    setisrefresh(true);
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "ArticleProductSegment?articleProductID=" + articleidObj,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        document.body.style.overflow = "auto";
        setisrefresh(false);
        if (result.length > 0) {
          setarticleSegmentList(result);
          var first = result[0];
          ArticleSegmentgetbyId(first._id);
        } else {
          setarticleSegmentList([]);
        }
      });
    });
  };
  //DropDown Method Start
  const getAllCategoryDropdownlist = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    fetch(Config.apiUrl + "Category/CategoryDrodownList", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setCategoryList(result);
        }
      });
    });
  };
  const getSubCategoryDropdownlistByCategoryID = (catId) => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    fetch(
      Config.apiUrl + "Category/SubCategoryDrodownList?categoryID=" + catId,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          if (result.length > 0) {
            setSubCategoryList(result);
          } else {
            setSubCategoryList([]);
          }
        } else {
          setSubCategoryList([]);
        }
      });
    });
  };

  const getAllCurrencyDropdownlist = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(Config.apiUrl + "GenericListing/DropdownList?categoryName=Currency", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setCurrencyDetailsList(result);
        }
      });
    });
  };
  const getAllLabelDropdownlist = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(Config.apiUrl + "Label/DropdownList", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
    }).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setLabelList(result);
        } else {
          setLabelList([]);
        }
      });
    });
  };
  const getAllArticlesTypeDropdownlist = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "GenericListing/DropdownList?categoryName=" +
      "ArticleType",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result != null) {
          setArticlesTypeList(result);
        } else {
          setArticlesTypeList([]);
        }
      });
    });
  };

  //End

  const onEditBindAttributeValue = (ArticleIDObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "Attribute/ArticleAttributeList?ArticleID=" +
      ArticleIDObj +
      "&ArticleTypeID=" +
      "",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((result) => {
      result.json().then((resp) => {
        if (resp.articleID != null && resp.articleID != "") {
          // console.log("resp.attributeCombinationList=>", resp.attributeCombinationList)
          // console.log("resp.attributeMappingList=>", resp.attributeMappingList)
          setCombinationList(resp.attributeCombinationList);
          setselectedAttributeList(resp.attributeMappingList);
        }
      });
    });
  };
  const ProductNamecategoryhandleSubmit = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      setIsNameAndCatDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "nameandcat" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            setIsNameAndCatDisplay(e.target.checked);
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsNameAndCatDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    } else {
      var data = {
        _id: ArticleID,
        ArticleName: ArticleName,
        IsProduct: true,
        ArticleNumber: ArticleNumber,
        IsNameAndCatDisplay: e.target.checked,
        UserCompanyID: loginid,
      };
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (
            resp != null &&
            resp?._id !== "" &&
            resp?._id !== null &&
            resp?._id !== undefined
          ) {
            setIsNameAndCatDisplay(e.target.checked);
            CretaeFixSegmentName(resp._id);
            setisArticleDisable(true);
            setArticleID(resp._id);
            swal("Thank You", "Product's details are saved.", "success");
          } else {
            setIsNameAndCatDisplay(!e.target.checked);
            swal("Sorry!", "Product's details are not saved.", "error");
          }
        });
      });
    }
  };
  const ArticleSegmentgetbyId = (ArticleSegmentID) => {
    // setisrefresh(true)
    document.body.style.overflow = "hidden";
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    fetch(
      Config.apiUrl +
      "ArticleProductSegment/SegmentFileById?segmentid=" +
      ArticleSegmentID,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((response) => {
      response.json().then((result) => {
        document.body.style.overflow = "auto";
        setisrefresh(false);
        if (result !== null) {
          if (result.description != null) {
            setSegmentDescription(result.description);
          } else {
            setSegmentDescription("");
          }

          if (result.articleVideo != null) {
            setVideosegmentList(result.articleVideo);
          } else {
            setVideosegmentList([]);
          }
          if (result.articleDocument != null) {
            setArticleSegmentDocumentlist(result.articleDocument);
          } else {
            setArticleSegmentDocumentlist([]);
          }
          if (result.articleExternalLinkList != null) {
            setarticleSegmentWebLinkList(result.articleExternalLinkList);
          } else {
            setarticleSegmentWebLinkList([]);
          }
          if (result.articleSegmentImage != null) {
            setArticleSegmentImageLists(result.articleSegmentImage);
          } else {
            setArticleSegmentImageLists([]);
          }
          setIsArticleSegmentDescriptionDisplay(
            result.isArticleSegmentDescriptionDisplay
          );
          setIsArticleSegmentDocumentDisplay(
            result.isArticleSegmentDocumentDisplay
          );
          setIsArticleSegmentImageDisplay(result.isArticleSegmentImageDisplay);
          setIsArticleSegmentVideoDisplay(result.isArticleSegmentVideoDisplay);
          setIsArticleSegmentWebLinkDisplay(
            result.isArticleSegmentWebLinkDisplay
          );
          setArticleSegmentID(ArticleSegmentID);
          setisrefresh(false);
        }
      });
    });
  };
  const onChangeSegmentDescription = (event) => {
    setSegmentDescriptionError("");
    setSegmentDescription(event);
  };
  const onChangeProductName = (event) => {
    // if (event.target.value.length > 30) {
    //     setArticleNameError("You have reached your maximum limit of characters allowed")
    // }
    // else {
    //     setArticleName(event.target.value);
    // }
    setArticleNameError("");
    setArticleName(event.target.value);
  };
  const onChangeCategory = (event) => {
    setCategoryError("");
    let catId = event.target.value;
    var index = event.nativeEvent.target.selectedIndex;
    let valuetext = event.nativeEvent.target[index].text;
    setCategoryId(catId);
    setCategoryId("");
    if (catId != "0" && catId != "" && catId !== undefined) {
      setCategoryId(catId);
      setsubCategoryselectname("");
      setCategoryselectname(valuetext);
      getSubCategoryDropdownlistByCategoryID(catId);
    } else {
      setSubCategoryList([]);
    }
  };
  const onChangeSubCategory = (event) => {
    setSubCategoryError("");
    let subcatId = event.target.value;
    setSubCategoryId(subcatId);
    var index = event.nativeEvent.target.selectedIndex;
    let valuetext = event.nativeEvent.target[index].text;
    setsubCategoryselectname(valuetext);
  };

  if (
    location?.state?.EditArticleDetailsID != "" &&
    location?.state?.EditArticleDetailsID !== undefined &&
    location?.state?.EditArticleDetailsID !== null
  ) {
    let EditArticleDetailsID = location.state.EditArticleDetailsID;
    if (
      EditArticleDetailsID !== null &&
      EditArticleDetailsID != "" &&
      EditArticleDetailsID != undefined &&
      EditArticleDetailsCallDone == false
    ) {
      let temp = EditArticleDetailsCallDone;
      temp = true;
      setEditArticleDetailsCallDone(temp);
      ArticlenumbergetbyID(EditArticleDetailsID);
    }
  }

  const onChangeMaincategory = (event) => {
    setMainCategory(event.target.value);
    setMainCategoryError("");
  };

  const onChangeRegularPrice = (values) => {
    setRegularPriceError("");
    setRegularPrice(values.floatValue);
    // setRegularPrice(event.target.value);
    // const amount = event.target.value;
    // if (event.target.value !== null && event.target.value !== "") {
    //     if (!amount || amount.match(/^\d{1,}(\.\d{0,2})?$/)) {
    //         setRegularPrice(amount);
    //     }
    // }
    // else { setRegularPrice(''); }
  };
  const onChangeSellPrice = (values) => {
    setSellPriceError("");
    setSellPrice(values.floatValue);
    // console.log(Object.keys(values));
    // console.log("value", values.value);
    // console.log("formattedValue", values.formattedValue);
    // console.log("floatValue", values.floatValue);
    // const amount = event.target.value;
    // if (event.target.value !== null && event.target.value !== "") {
    //     if (!amount || amount.match(/^\d{1,}(\.\d{0,2})?$/)) {
    //         setSellPrice(amount);
    //     }
    // }
    // else { setSellPrice(''); }
  };
  const onChangeyouTubleVideoLink = (event) => {
    setyouTubleVideoLinkError("");
    let temp = [];
    temp.push(event.target.value);
    setyouTubleVideoLink(temp);
  };
  const togglecategoryModal = () => {
    setcategoryModalisOpen(!categoryModalisOpen);
    setMainCategory("");
    setsubcategorylistnew([""]);
  };

  const createSubCategoryUI = () => {
    return subcategorylistnew.map((el, i) => (
      <>
        <div key={i} className="removeSection">
          <input
            type="text"
            className="form-control mr-2"
            maxlength="30"
            placeholder="Enter Sub Category"
            value={el || ""}
            // onChange={(e) => { SubCategoryhandleChange(i, e) }} />
            onChange={SubCategoryhandleChange(i)}
          />
          {i > 0 ? (
            <a
              href="javascript:void(0)"
              onClick={(e) => {
                SubCategoryremoveClick(i);
              }}
              className="btn btn-danger"
            >
              <i class="fas fa-trash"></i>
            </a>
          ) : (
            ""
          )}
        </div>
        <p
          class="col-sm-12"
          style={{ textAlign: "right", fontSize: 12, color: "red" }}
        >
          {el.length}/30
        </p>
      </>
    ));
  };
  const SubCategoryhandleChange = (i) => (event) => {
    setSubCategoryAddtimeError("");
    let subcategorylistnewTemp = [...subcategorylistnew];
    subcategorylistnewTemp[i] = event.target.value;
    setsubcategorylistnew(subcategorylistnewTemp);
    const unique = [...new Set(subcategorylistnewTemp)];
    if (subcategorylistnewTemp.length === unique.length) {
      setisSubcategoryMaltiple(false);
    } else {
      setisSubcategoryMaltiple(true);
    }
  };
  const SubCategoryaddClick = (e) => {
    setsubcategorylistnew((n) => [...n, ""]);
  };

  const SubCategoryremoveClick = (i) => {
    let subcategorylistnewTemp = [...subcategorylistnew];
    subcategorylistnewTemp.splice(i, 1);
    setsubcategorylistnew(subcategorylistnewTemp);
  };

  const createCategory = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      MainCategory === null ||
      MainCategory === "" ||
      MainCategory === undefined
    ) {
      retval = false;
      setMainCategoryError("Category name must be filled out ");
    }
    if (subcategorylistnew.length === 0) {
      setSubCategoryAddtimeError("sub Category name must be filled out");
    } else {
      const found = subcategorylistnew.find(
        (element) => element === "" || element === "" || element === null
      );
      if (found != undefined) {
        setSubCategoryAddtimeError("Sub Category Name must be filled out");
        retval = false;
      }

      const unique = [...new Set(subcategorylistnew)];
      if (subcategorylistnew.length !== unique.length) {
        retval = false;
      }
    }
    if (retval === true) {
      fetch(
        Config.apiUrl +
        "Category/CheckCategory?id=" +
        "" +
        "&categoryName=" +
        MainCategory,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            var data = {
              Name: MainCategory,
              SubCategoryList: subcategorylistnew,
              UserCompanyID: loginid,
              ParentID: "0",
            };
            fetch(Config.apiUrl + "Category/CreateCategory", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(data),
            })
              .then((result1) => {
                result1.json().then((resp) => {
                  if (resp != null) {
                    getAllCategoryDropdownlist();
                    setCategoryId(resp._id);
                    getSubCategoryDropdownlistByCategoryID(resp._id);
                    togglecategoryModal();
                  }
                });
              })
              .catch((error) => {
                console.error("There was an error!", error);
              });
          } else {
            swal("Your Category name already exists !");
          }
        });
      });
    }
  };

  const vendoraddtoggle = () => {
    setmodalvendor(!modalvendor);
  };
  const toggleQrcode = () => {
    setQrCodeString("");
    setManufactureDate(null);
    setExpiryDateFinal(null);
    setVendorID("");
    setExpiryDate(null);
    setDuplicateQrcodeList([]);
    setQrcodeQty(0);
    setselectCombinationID("");
    setselectBatchNumbername("");
    if (ArticleID !== null && ArticleID !== undefined && ArticleID !== "") {
      getallbatchNumber();
      setmodalQrcode(!modalQrcode);
      if (modalQrcode === true) {
        setQrCodeString("");
        setselectCombinationID("");
      }
    } else {
      swal("Sorry!", "Pleace Create  Product", "error");
    }
  };

  const batchnumbertoggle = () => {
    setBatchNumberError("");
    setBatchnumber("");
    setBatchnumberisOpen(!batchnumberisOpen);
  };
  const ModelClosed = () => {
    setQrCodeString("");
    setManufactureDate(null);
    setExpiryDateFinal(null);
    setVendorID("");
    setExpiryDate(null);
    setDuplicateQrcodeList([]);
    setQrcodeQty(0);
    setselectCombinationID("");
    setselectBatchNumbername("");
    setmodalQrcode(!modalQrcode);
  };


  const getqrcodeAttributes = () => {
    if (ArticleID !== null && ArticleID !== "" && ArticleID !== undefined) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let ManufactureDateFinalTemp = "";
      if (ManufactureDate !== null) {
        // ManufactureDateFinalTemp = ManufactureDateFinal;
        ManufactureDateFinalTemp = Moment(ManufactureDate).format("YYYY-MM-DD");
      }
      let ExpiryDateFinalTemp = "";
      if (ExpiryDate !== null) {
        ExpiryDateFinalTemp = Moment(ExpiryDate).format("YYYY-MM-DD");
      }
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/GetQrcodestringfilter?targetId=" +
        selectCombinationID +
        "&BatchNumber=" +
        selectBatchNumbername +
        "&ManufactureDate=" +
        ManufactureDateFinalTemp +
        "&VendorsID=" +
        VendorID +
        "&productID=" +
        ArticleID +
        "&Expirydate=" +
        ExpiryDateFinalTemp,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          if (
            responseJson !== null &&
            responseJson?._id !== "" &&
            responseJson?._id !== null &&
            responseJson?._id !== undefined
          ) {
            setQrCodeID(responseJson?._id);
            if (responseJson?.codeString) {
              let qrcodestring = domainFrontUrl.current + responseJson.codeString;
              setQrCodeString(qrcodestring);
              setQrCodeStringArticle(qrcodestring);
              // setQrCodeString(Config.FrontUrl + responseJson.codeString);
              // setQrCodeStringArticle(Config.FrontUrl + responseJson.codeString);
            }
            else {
              setQrCodeString("");
              setQrCodeStringArticle("");
            }
            setQrcodeQty(0);
            setDuplicateQrcodeList("");
          } else {
            setQrCodeString("");
            setQrCodeStringArticle("");
            setQrCodeID("");
            setQrcodeQty(0);
            setDuplicateQrcodeList("");
          }
        })
        .catch((error) => {
          console.log(error);
          setQrCodeString("");
          setQrCodeStringArticle("");
          setQrCodeID("");
        });
    }
  };

  const Qrcodegenerator = () => {
    // let url = Config.FrontUrl + 'productdetails?mapId=' + selectCombinationID + '&render=Combination';
    if (
      QrCodeString === null ||
      QrCodeString === "" ||
      QrCodeString === undefined
    ) {
      if (
        selectCombinationID !== null &&
        selectCombinationID !== "" &&
        selectCombinationID !== undefined
      ) {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");

        let ArticleQrcodestring = {
          UserCompanyID: loginid,
          TargetType: "ProductQrCodeAttributes",
          TargetID: selectCombinationID,
          IsDeleted: false,
          BatchNumber: selectBatchNumbername,
          EnableEWarranty: EnableEWarranty,
          Expirydate: ExpiryDate
            ? Moment(ExpiryDate).format("YYYY-MM-DD")
            : null,
          Manufacturedate: ManufactureDate
            ? Moment(ManufactureDate).format("YYYY-MM-DD")
            : null,
          Manufacturedatestring: ManufactureDate
            ? Moment(ManufactureDate).format("YYYY-MM-DD")
            : null,

          VendorId: VendorID,
          MainTargetID: ArticleID,
          CombinationId: selectCombinationID,
        };
        fetch(
          Config.apiUrl + "QrCodeResourceController/CreateQrcodestringproduct",
          {
            headers: {
              userCompanyID: loginid,
              "Content-Type": "application/json",
              Authorization: "Bearer " + Auth0token,
            },
            method: "POST",
            body: JSON.stringify(ArticleQrcodestring),
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((responseJson) => {
            if (responseJson !== null && responseJson !== "") {
              if (responseJson?._id !== null) {
                getallbatchNumber();
                setQrCodeID(responseJson?._id);
                if (responseJson?.codeString) {
                  let qrcodestring = domainFrontUrl.current + responseJson.codeString;
                  // setQrCodeString(Config.FrontUrl + responseJson?.codeString);
                  setQrCodeString(qrcodestring);
                }
                else {
                  setQrCodeString("");
                }
                swal("successfully", "Product  Qrcode generate.", "success");
              } else {
                swal("error", "Product  Qrcode not generate.", "error");
              }
            } else {
              setQrCodeString("");
              setQrCodeID("");
              swal("error", "Product  Qrcode not generate.", "error");
            }
          })
          .catch((error) => {
            swal("error", error?.message, "error");
            console.log(error);
            setQrCodeString("");
            setQrCodeID("");
          });
      } else {
        swal("oops!", "please select Combination ", "warning");
      }
    } else {
      swal("Qr code already created");
    }
  };

  const QrcodegeneratorArticle = () => {
    // let url = Config.FrontUrl + 'productdetails?mapId=' + ArticleID + '&render=details';
    //setQrCodeStringArticle(url);
    if (
      QrCodeStringArticle === null ||
      QrCodeStringArticle === "" ||
      QrCodeStringArticle === undefined
    ) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let ArticleQrcodestring = {
        UserCompanyID: loginid,
        TargetType: "ProductQrCode",
        TargetID: ArticleID,
        // CodeString: url,
        IsDeleted: false,
        BatchNumber: selectBatchNumbername,
        EnableEWarranty: EnableEWarranty,
        // Expirydate: ExpiryDate,

        // Expirydate: ExpiryDate ? ExpiryDate : null,
        // Manufacturedate: ManufactureDate ? ManufactureDate : null,
        // Manufacturedatestring: ManufactureDate ? ManufactureDate : null,
        Expirydate: ExpiryDate ? Moment(ExpiryDate).format("YYYY-MM-DD") : null,
        Manufacturedate: ManufactureDate
          ? Moment(ManufactureDate).format("YYYY-MM-DD")
          : null,
        Manufacturedatestring: ManufactureDate
          ? Moment(ManufactureDate).format("YYYY-MM-DD")
          : null,
        MainTargetID: ArticleID,
        CombinationId: "",
        VendorId: VendorID,
      };
      fetch(
        Config.apiUrl + "QrCodeResourceController/CreateQrcodestringproduct",
        {
          headers: {
            userCompanyID: loginid,
            "Content-Type": "application/json",
            Authorization: "Bearer " + Auth0token,
          },
          method: "POST",
          body: JSON.stringify(ArticleQrcodestring),
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          if (responseJson?._id !== null && responseJson?._id !== "") {
            // setQrCodeString(responseJson.codeString)
            setQrCodeID(responseJson?._id);
            if (responseJson?.codeString) {
              let qrcodestring = domainFrontUrl.current + responseJson?.codeString;
              // setQrCodeStringArticle(Config.FrontUrl + responseJson.codeString);
              setQrCodeStringArticle(qrcodestring);
            }
            else {
              setQrCodeStringArticle("");
            }
            swal("successfully", "Product  Qrcode created.", "success");
          } else {
            setQrCodeID("");
            setQrCodeStringArticle("");
            swal("error", "Product  Qrcode not generate.", "error");
          }
        })
        .catch((error) => {
          console.log(error);
          swal("error", error.message, "error");
          setQrCodeID("");
          setQrCodeStringArticle("");
        });
    } else {
      swal("Qr code already created");
    }

  };

  const ProductIsPricehandleSubmit = (e) => {
    // setIsPriceDisplay(e.target.checked);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      setIsPriceDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "price" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsPriceDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    } else {
      var data = {
        _id: "",
        ArticleName: ArticleName,
        IsProduct: true,
        ArticleNumber: ArticleNumber,
        IsPriceDisplay: e.target.checked,
        UserCompanyID: loginid,
      };

      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            setIsPriceDisplay(true);
            setisArticleDisable(true);
            CretaeFixSegmentName(resp._id);
            setArticleID(resp._id);
            swal("Thank You", "Article's Price details are saved.", "success");
          } else {
            swal("Sorry!", "Article's Price details are not saved.", "error");
          }
        });
      });
    }
  };

  const onChangeCurrencydropdown = (event) => {
    setCurrencyError("");
    let C_ID = event.target.value;
    setCurrencyId(C_ID);
  };

  const createPrice = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    // if (CurrencyId === null || CurrencyId === "" || CurrencyId === undefined) {
    //   IsValid = false;
    //   setCurrencyError("Please Selcte Currency");
    // }
    if (
      RegularPrice === null ||
      RegularPrice === "" ||
      RegularPrice === undefined
    ) {
      IsValid = false;
      setRegularPriceError("Please Enter Regular Price");
    } else {
      if (SellPrice !== null && SellPrice !== "" && SellPrice !== undefined) {
        // let RegularPriceconvert = Math.floor(RegularPrice - 1).toFixed(2);
        let RegularPriceconvert = RegularPrice;
        console.log("RegularPriceconvert==>", RegularPriceconvert);
        let SellPricePriceconvert = SellPrice;
        console.log("SellPricePriceconvert==>", SellPricePriceconvert);
        if (RegularPriceconvert === SellPricePriceconvert) {
          IsValid = false;
          setSellPriceError(
            "Please Enter lessthen SalePrice  to Regular Price !"
          );
        } else if (RegularPriceconvert < SellPricePriceconvert) {
          IsValid = false;
          setSellPriceError(
            "Please Enter lessthen SalePrice  to Regular Price !"
          );
        }
      }
    }
    if (IsValid === true) {
      var data = {
        _id: ArticleID,
        CurrencyID: CurrencyId,
        RegularPrice: RegularPrice,
        SellPrice:
          SellPrice === null || SellPrice === "" || SellPrice === undefined
            ? 0
            : SellPrice,
        IsPriceDisplay: IsPriceDisplay,
        UserCompanyID: loginid,
        IsProduct: true,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
        UserCompanyID: loginid,
      };
      if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
        fetch(Config.apiUrl + "ArticleProduct/Create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            setCurrencyError("");
            setRegularPriceError("");
            setSellPriceError("");
            if (resp != null) {
              setisArticleDisable(true);
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              swal(
                "Thank You",
                "Article's Price details are saved.",
                "success"
              );
            } else {
              swal("Sorry!", "Article's Price details are not saved.", "error");
            }
          });
        });
      } else {
        fetch(Config.apiUrl + "ArticleProduct/UpdatePrice?id=" + ArticleID, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp?._id !== null) {
              setCurrencyError("");
              setRegularPriceError("");
              setSellPriceError("");
              swal("Saved", "Article's Price details are saved.", "success");
            } else
              swal("Sorry!", "Article's Price details are not saved.", "error");
          });
        });
      }
    }
  };

  const ProductIsLabelhandleSubmit = (e) => {
    setIsLabelDisplay(e.target.checked);
  };

  const onChangeLabeldrop = (event) => {
    setLabelError("");
    let lablId = event.target.value;
    setLabelId(lablId);
  };

  const toggleLableModel = () => {
    setLabelNameError("");
    setLableDescription("");
    setLabelName("");
    setLogoFile([]);
    setLogoPath("");
    setLableModelisOpen(!LableModelisOpen);
  };

  const onChangeLableName = (event) => {
    setLabelNamError("");
    setLabelName(event.target.value);
  };

  const setLableFile = (event) => {
    if (event.target.files && event.target.files[0]) {
      setLogoPath(URL.createObjectURL(event.target.files[0]));
      setLogoFile(event.target.files[0]);
    }
  };

  const onChangeLableDescription = (event) => {
    setDescriptionError("");
    setLableDescription(event.target.value);
  };

  const fileUploadLablePost = (LabelIDObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    if (LogoFile != null && LogoFile != "" && LogoFile != undefined) {
      // console.log("SizeTabelPraveen=>", LogoFile)
      const byte = LogoFile.size;
      fetch(
        Config.apiUrl +
        "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
        UserCompanyId +
        "&UserFileSize=" +
        byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            const formData = new FormData();
            formData.append("body", LogoFile);
            formData.append("fileType", "label");
            formData.append("targetId", LabelIDObj);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            fetch(Config.apiUrl + "FileUpload/Create", {
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "POST",
              body: formData,
            }).then((result) => {
              result.json().then((resp) => {
                //getDataLabel();
                getAllLabelDropdownlist();
                setLabelId(LabelIDObj);
                console.log(resp);
              });
            });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      getAllLabelDropdownlist();
      setLabelId(LabelIDObj);
    }
  };
  const createLabelbrand = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (LabelName === null || LabelName === undefined || LabelName === "") {
      retval = false;
      setLabelNamError("Label Name must be filled out");
      return;
    }
    // if (
    //   LableDescription === null ||
    //   LableDescription === undefined ||
    //   LableDescription === ""
    // ) {
    //   retval = false;
    //   setDescriptionError("Description must be filled out");
    //   return;
    // }
    // if (LogoFile.length === 0) {
    //   retval = false;
    //   setLogoPathError("select Logo File");
    // }
    let DataObj = {
      Name: LabelName,
      Description: LableDescription,
      UserCompanyID: loginid,
      IsProduct: true,
    };

    fetch(
      Config.apiUrl + "Label/CheckLabel?id=" + "" + "&labelName=" + LabelName,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        if (result === false) {
          fetch(Config.apiUrl + "Label/Create", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
            body: JSON.stringify(DataObj),
          }).then((result) => {
            result.json().then((resp) => {
              if (resp != null) {
                fileUploadLablePost(resp._id);

                swal("Saved", "Label is saved.", "success");
                toggleLableModel();
              } else {
                swal("Sorry!", "Label is not saved.", "error");
              }
            });
          });
        } else {
          swal("Your label Name already exists !");
        }
      });
    });
  };
  const CreateLabelbrandnds = () => {
    let IsValid = true;
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    // if (LabelId === null || LabelId === "" || LabelId === undefined) {
    //   IsValid = false;
    //   setLabelError("Please Selcte Label");
    // }
    if (IsValid === true) {
      var data = {
        _id: ArticleID,
        LabelID: LabelId,
        IsLabelDisplay: IsLabelDisplay,
        UserCompanyID: loginid,
        IsProduct: true,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
        UserCompanyID: loginid,
      };

      if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
        fetch(Config.apiUrl + "ArticleProduct/Create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              setisArticleDisable(true);
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              let selectlablename = LabelList.find(x => x.value === LabelId);
              setOldLabelName(selectlablename?.text ? selectlablename?.text : "");
              swal("Thank You", "Article's details are saved.", "success");
            } else {
              swal("Sorry!", "Article's details are not saved.", "error");
            }
          });
        });
      } else {
        fetch(Config.apiUrl + "ArticleProduct/UpdateLabel?id=" + ArticleID, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              let selectlablename = LabelList.find(x => x.value === LabelId);
              setOldLabelName(selectlablename?.text ? selectlablename?.text : "");
              swal("Thank You", "Article's details are saved.", "success");
            } else {
              swal("Sorry!", "Article's details are not saved.", "error");
            }
          });
        });
      }
    }
  };

  const IsSizeTabelhandleSubmit = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setIsSizeTabelDisplay(e.target.checked);
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "sizetabel" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsSizeTabelDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
          // if (resp === false) {
          //     setIsSizeTabelDisplay(!e.target.checked);
          // }
        });
      });
    } else {
      var data = {
        _id: ArticleID,
        UserCompanyID: loginid,
        IsProduct: true,
        IsSizeTabelDisplay: e.target.checked,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
        //_id: ArticleID
      };
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            CretaeFixSegmentName(resp._id);
            setisArticleDisable(true);
            setArticleID(resp._id);
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsSizeTabelDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const SizetableuploadSingleFile = (e) => {
    setSizetablefilePath(URL.createObjectURL(e.target.files[0]));
    setSizeTabel(e.target.files[0]);
  };
  const resetSizeTable = () => {
    ref.current.value = "";
  };
  const CreateSizeTablePics = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    let loginid = localStorage.getItem("loginUserID");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    if (SizeTabel != null && SizeTabel != "" && SizeTabel != undefined) {
      // console.log("SizeTabelPraveen=>", SizeTabel)
      const byte = SizeTabel.size;
      fetch(
        Config.apiUrl +
        "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
        UserCompanyId +
        "&UserFileSize=" +
        byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            const formData = new FormData();
            formData.append("body", SizeTabel);
            formData.append("fileType", "sizetable");
            formData.append("targetId", ArticleID);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            var data = {
              _id: ArticleID,
              UserCompanyID: loginid,
              IsProduct: true,
              ArticleName: ArticleName,
              ArticleNumber: ArticleNumber,
            };
            if (
              ArticleID === null ||
              ArticleID === "" ||
              ArticleID === undefined
            ) {
              fetch(Config.apiUrl + "ArticleProduct/Create", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: JSON.stringify(data),
              }).then((result) => {
                result.json().then((resp) => {
                  if (resp != null) {
                    setisArticleDisable(true);
                    CretaeFixSegmentName(resp._id);
                    formData.append("targetId", resp._id);
                    setArticleID(resp._id);
                    fetch(Config.apiUrl + "FileUpload/Update?id=" + "", {
                      headers: {
                        userCompanyID: loginid,
                        Authorization: "Bearer " + Auth0token,
                      },
                      method: "PUT",
                      body: formData,
                    }).then((result) => {
                      result.json().then((resp) => {
                        resetSizeTable();
                        setSizeTabel("");
                        // console.log(resp);
                        if (resp != null)
                          swal(
                            "Saved",
                            "Article's SizeTabel details are saved.",
                            "success"
                          );
                        else
                          swal(
                            "Sorry!",
                            "Article's SizeTabel details are not saved.",
                            "error"
                          );
                      });
                    });
                    // swal("Thank You", "Article's details are saved.", "success");
                  } else {
                    swal(
                      "Sorry!",
                      "Article's SizeTabel details are not saved.",
                      "error"
                    );
                  }
                });
              });
            } else {
              fetch(Config.apiUrl + "FileUpload/Update?id=" + "", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "PUT",
                body: formData,
              }).then((result) => {
                result.json().then((resp) => {
                  resetSizeTable();
                  setSizeTabel("");
                  // console.log(resp);
                  if (resp != null)
                    swal(
                      "Saved",
                      "Article's SizeTabel details are saved.",
                      "success"
                    );
                  else
                    swal(
                      "Sorry!",
                      "Article's SizeTabel details are not saved.",
                      "error"
                    );
                });
              });
            }
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      swal("Sorry!", "select Any one File.", "error");
    }
  };

  const ProductIsSKUhandleSubmit = (e) => {
    setIsSKUDisplay(e.target.checked);
  };

  const onChangeProductSKU = (event) => {
    setArticleSKUError("");
    setArticleSKU(event.target.value);
  };
  const createSku = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (ArticleSKU === null || ArticleSKU === "" || ArticleSKU === undefined) {
      IsValid = false;
      setArticleSKUError("Please Enter SKU");
    }
    if (IsValid === true) {
      var data = {
        _id: ArticleID,
        ArticleSKU: ArticleSKU,
        IsSKUDisplay: IsSKUDisplay,
        UserCompanyID: loginid,
        IsProduct: true,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
      };

      if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
        fetch(Config.apiUrl + "ArticleProduct/Create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              setOldArticleSKU(ArticleSKU);
              setisArticleDisable(true);
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              swal("Saved", "Article's SKU details are saved.", "success");
            } else {
              swal("Sorry!", "Article's SKU details are not saved.", "error");
            }
          });
        });
      } else {
        fetch(Config.apiUrl + "ArticleProduct/UpdateSKU?id=" + ArticleID, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp !== null) {
              setOldArticleSKU(ArticleSKU);
              swal("Saved", "Article's SKU details are saved.", "success");
            } else
              swal("Sorry!", "Article's SKU details are not saved.", "error");
          });
        });
      }
    }
  };
  const Deletesku = async (articleid) => {
    console.log("articleid==>", articleid);
    if (articleid !== null && articleid !== "" && articleid !== undefined)
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this article SKU !",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          var response = await SkuDelete(articleid);
          if (response === true) {
            setArticleSKU("");
            setOldArticleSKU("");
            swal("Congratulations! Your data deleted successfully.", {
              icon: "success",
            });
          } else {
            swal("Your data is safe!");
          }
        }
      });
  };
  const onChangeProductdroptype = (event) => {
    let artId = event.target.value;
    if (artId === "62ac68e2830ffdde1c0b09b9") {
      setisAttributeshow(true);
    } else {
      setisAttributeshow(false);
    }

    setArticleTypeError("");
    setArticlesTypeId(artId);
  };

  const onDelete = (i) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Attribute!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const tags = selectedAttributeList.slice(0);
        tags.splice(i, 1);
        setselectedAttributeList(tags);
        const sugg = ArticleAttributeList.slice(0);
        sugg.splice(i, 1);
        setArticleAttributeList(sugg);
      }
    });
    // const tags = selectedAttributeList.slice(0)
    // tags.splice(i, 1);
    // setselectedAttributeList(tags);
    // const sugg = ArticleAttributeList.slice(0);
    // sugg.splice(i, 1);
    // setArticleAttributeList(sugg);
  };
  const onAddition = (tag) => {
    var myIndex = selectedAttributeList.findIndex((m) => m.name == tag.name);
    if (myIndex == -1) {
      tag.otherList = [];
      tag.other = "";
      if (selectedAttributeList.length <= 4) {
        const tags = [].concat(selectedAttributeList, tag);
        setselectedAttributeList(tags);
        const sugge = [].concat(ArticleAttributeList, tag);
        setArticleAttributeList(sugge);
      }
    }
  };

  const onChangeAttributeVariant = (index, event) => {
    var allSelectedList = [...selectedAttributeList];
    var tempItem = allSelectedList[index];
    tempItem.otherList = event;
    allSelectedList[index] = tempItem;
    setselectedAttributeList(allSelectedList);
  };
  const onchangeGenrateAttributePrice = (index, event) => {
    var allSelectedList = [...CombinationList];
    var tempData = allSelectedList[index];
    tempData.price = event.target.value;
    allSelectedList[index] = tempData;
    setCombinationList(allSelectedList);
  };
  const onchangeGenrateAttributeSku = (index, event) => {
    var allSelectedList = [...CombinationList];
    var tempData = allSelectedList[index];
    tempData.sku = event.target.value;
    allSelectedList[index] = tempData;
    setCombinationList(allSelectedList);
  };
  const onchangeGenrateAttributeQty = (index, event) => {
    var allSelectedList = [...CombinationList];
    var tempData = allSelectedList[index];
    tempData.qty = event.target.value;
    allSelectedList[index] = tempData;
    setCombinationList(allSelectedList);
  };
  const deletOldimage = (index, id) => {
    if (id !== null && id !== undefined && id !== "") {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "FileUpload/Delete?id=" + id, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                var allSelectedList = [...CombinationList];
                var tempData = allSelectedList[index];
                tempData.attributeImagePath = "";
                tempData.profileImage = "";
                allSelectedList[index] = tempData;
                setCombinationList(allSelectedList);
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article Segment Images is safe!");
              }
            });
          });
        }
      });
    }
  };
  const deletenewimage = (index) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        var allSelectedList = [...CombinationList];
        var tempData = allSelectedList[index];
        tempData.attributeImagePath = "";
        tempData.profileImage = null;
        allSelectedList[index] = tempData;
        setCombinationList(allSelectedList);
      }
    });
  };
  const onchangeAttributeimage = (index, event) => {
    var allSelectedList = [...CombinationList];
    var tempData = allSelectedList[index];
    tempData.attributeImagePath = URL.createObjectURL(event.target.files[0]);
    tempData.profileImage = event.target.files[0];
    allSelectedList[index] = tempData;
    setCombinationList(allSelectedList);
  };
  const CreateAttributegenrateVariant = async () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let IsValid = true;
    if (
      ArticlesTypeId === null ||
      ArticlesTypeId === "" ||
      ArticlesTypeId === undefined ||
      ArticlesTypeId === "0"
    ) {
      IsValid = false;
      setArticleTypeError("Please Selcte Article Type");
    }
    if (CombinationList.length === 0) {
      IsValid = false;
    }
    if (selectedAttributeList.length === 0) {
      IsValid = false;
    }
    if (IsValid === true) {
      var data = {
        _id: ArticleID,
        UserCompanyID: loginid,
        IsProduct: true,
        ArticleTypeID: ArticlesTypeId,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
      };

      if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
        setAttributeisloding(true);
        fetch(Config.apiUrl + "ArticleProduct/Create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then(async (resp) => {
            if (resp != null) {
              CretaeFixSegmentName(resp._id);
              setisArticleDisable(true);
              setArticleID(resp._id);
              let A_ID = resp._id;
              if (
                ArticlesTypeId === null ||
                ArticlesTypeId === "" ||
                ArticlesTypeId === undefined ||
                ArticlesTypeId === "0"
              ) {
                IsValid = false;
                setArticleTypeError("Please Selcte Article Type");
              }
              if (CombinationList.length === 0) {
                IsValid = false;
              }
              if (selectedAttributeList.length === 0) {
                IsValid = false;
              }
              if (IsValid === true) {
                createArticlestypes(ArticleID, ArticlesTypeId);
                // console.log("CombinationList=>", CombinationList);
                const byte =
                  CombinationList.map(
                    (item) => item?.profileImage?.size || 0
                  ).reduce((prev, curr) => prev + curr, 0) || 0;
                if (byte > 0) {
                  let StorageResponse = await CheckStorageLimit(byte);
                  if (StorageResponse === true || StorageResponse === "true") {
                    const formData = new FormData();
                    formData.append("ArticleID", resp._id);
                    formData.append("ArticleTypeID", ArticlesTypeId);
                    formData.append("UserCompanyID", loginid);
                    formData.append("combinationCount", CombinationList.length);
                    formData.append(
                      "selectedAttributeCount",
                      selectedAttributeList.length
                    );

                    let ispost = true;
                    if (selectedAttributeList.length > 0) {
                      let ischeck = CombinationList.filter(
                        (x) => x.id != null && x.id != "" && x.id != undefined
                      );
                      if (ischeck.length > 0) {
                        ispost = false;
                      }
                    }
                    for (
                      let index = 0;
                      index < CombinationList.length;
                      index++
                    ) {
                      const element = CombinationList[index];
                      formData.append(
                        "AttributeCombinationList_id" + index,
                        element.id
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue1" + index,
                        element.attributeValue1
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue2" + index,
                        element.attributeValue2
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue3" + index,
                        element.attributeValue3
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue4" + index,
                        element.attributeValue4
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue5" + index,
                        element.attributeValue4
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue5" + index,
                        element.attributeValue4
                      );
                      formData.append(
                        "AttributeCombinationList_sku" + index,
                        element.sku
                      );
                      formData.append(
                        "AttributeCombinationList_barcode" + index,
                        element.barcode
                      );
                      formData.append(
                        "AttributeCombinationList_price" + index,
                        element.price
                      );
                      formData.append(
                        "profileImage" + index,
                        element.profileImage
                      );
                    }

                    for (
                      let index = 0;
                      index < selectedAttributeList.length;
                      index++
                    ) {
                      const element = selectedAttributeList[index];

                      formData.append(
                        "AttributeMapping_id" + index,
                        element.id
                      );
                      formData.append(
                        "AttributeMapping_name" + index,
                        element.name
                      );
                      formData.append(
                        "AttributeMapping_otherList" + index,
                        element.otherList
                      );
                      let temp = "";
                      for (
                        let index1 = 0;
                        index1 < element.otherList.length;
                        index1++
                      ) {
                        const elementnew = element.otherList[index1];
                        if (index1 === 0) {
                          temp += elementnew;
                        } else {
                          temp += "," + elementnew;
                        }
                      }
                      formData.append("AttributeMapping_other" + index, temp);
                    }

                    let url =
                      Config.apiUrl + "Attribute/SaveAttributeCombination1";
                    if (ispost === false) {
                      url =
                        Config.apiUrl + "Attribute/UpdateAttributeValueMapp";
                    }
                    fetch(url, {
                      method: "POST",
                      headers: {
                        userCompanyID: loginid,
                        Authorization: "Bearer " + Auth0token,
                      },
                      body: formData,
                    })
                      .then((result1) => {
                        result1
                          .json()
                          .then((resp1) => {
                            if (resp1 != null) {
                              onEditBindAttributeValue(resp1.articleID);
                              if (
                                resp1.articleID != null &&
                                resp1.articleID != ""
                              ) {
                                swal(
                                  "Saved",
                                  "Article's attribute details are saved.",
                                  "success"
                                );
                              } else {
                                swal(
                                  "Sorry!",
                                  "Article's attribute details are not saved.",
                                  "error"
                                );
                              }
                            }
                          })
                          .catch((error) => {
                            console.log("Error:-", error);
                          });
                      })
                      .catch((error) => {
                        console.log("Error:-", error);
                      });
                  } else if (
                    StorageResponse === false ||
                    StorageResponse === "false"
                  ) {
                    const formData = new FormData();
                    formData.append("ArticleID", resp._id);
                    formData.append("ArticleTypeID", ArticlesTypeId);
                    formData.append("UserCompanyID", loginid);
                    formData.append("combinationCount", CombinationList.length);
                    formData.append(
                      "selectedAttributeCount",
                      selectedAttributeList.length
                    );

                    let ispost = true;
                    if (selectedAttributeList.length > 0) {
                      let ischeck = CombinationList.filter(
                        (x) => x.id != null && x.id != "" && x.id != undefined
                      );
                      if (ischeck.length > 0) {
                        ispost = false;
                      }
                    }
                    for (
                      let index = 0;
                      index < CombinationList.length;
                      index++
                    ) {
                      const element = CombinationList[index];
                      formData.append(
                        "AttributeCombinationList_id" + index,
                        element.id
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue1" + index,
                        element.attributeValue1
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue2" + index,
                        element.attributeValue2
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue3" + index,
                        element.attributeValue3
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue4" + index,
                        element.attributeValue4
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue5" + index,
                        element.attributeValue4
                      );
                      formData.append(
                        "AttributeCombinationList_attributeValue5" + index,
                        element.attributeValue4
                      );
                      formData.append(
                        "AttributeCombinationList_sku" + index,
                        element.sku
                      );
                      formData.append(
                        "AttributeCombinationList_barcode" + index,
                        element.barcode
                      );
                      formData.append(
                        "AttributeCombinationList_price" + index,
                        element.price
                      );
                      // formData.append(
                      //   "profileImage" + index,
                      //   element.profileImage
                      // );
                    }

                    for (
                      let index = 0;
                      index < selectedAttributeList.length;
                      index++
                    ) {
                      const element = selectedAttributeList[index];

                      formData.append(
                        "AttributeMapping_id" + index,
                        element.id
                      );
                      formData.append(
                        "AttributeMapping_name" + index,
                        element.name
                      );
                      formData.append(
                        "AttributeMapping_otherList" + index,
                        element.otherList
                      );
                      let temp = "";
                      for (
                        let index1 = 0;
                        index1 < element.otherList.length;
                        index1++
                      ) {
                        const elementnew = element.otherList[index1];
                        if (index1 === 0) {
                          temp += elementnew;
                        } else {
                          temp += "," + elementnew;
                        }
                      }
                      formData.append("AttributeMapping_other" + index, temp);
                    }

                    let url =
                      Config.apiUrl + "Attribute/SaveAttributeCombination1";
                    if (ispost === false) {
                      url =
                        Config.apiUrl + "Attribute/UpdateAttributeValueMapp";
                    }
                    fetch(url, {
                      method: "POST",
                      headers: {
                        userCompanyID: loginid,
                        Authorization: "Bearer " + Auth0token,
                      },
                      body: formData,
                    })
                      .then((result1) => {
                        result1
                          .json()
                          .then((resp1) => {
                            if (resp1 != null) {
                              onEditBindAttributeValue(resp1.articleID);
                              if (
                                resp1.articleID != null &&
                                resp1.articleID != ""
                              ) {
                                swal(
                                  "Saved",
                                  "Article's attribute details are saved.",
                                  "success"
                                );
                              } else {
                                swal(
                                  "Sorry!",
                                  "Article's attribute details are not saved.",
                                  "error"
                                );
                              }
                            }
                          })
                          .catch((error) => {
                            console.log("Error:-", error);
                          });
                      })
                      .catch((error) => {
                        console.log("Error:-", error);
                      });
                  }
                } else {
                  const formData = new FormData();
                  formData.append("ArticleID", resp._id);
                  formData.append("ArticleTypeID", ArticlesTypeId);
                  formData.append("UserCompanyID", loginid);
                  formData.append("combinationCount", CombinationList.length);
                  formData.append(
                    "selectedAttributeCount",
                    selectedAttributeList.length
                  );

                  let ispost = true;
                  if (selectedAttributeList.length > 0) {
                    let ischeck = CombinationList.filter(
                      (x) => x.id != null && x.id != "" && x.id != undefined
                    );
                    if (ischeck.length > 0) {
                      ispost = false;
                    }
                  }
                  for (let index = 0; index < CombinationList.length; index++) {
                    const element = CombinationList[index];
                    formData.append(
                      "AttributeCombinationList_id" + index,
                      element.id
                    );
                    formData.append(
                      "AttributeCombinationList_attributeValue1" + index,
                      element.attributeValue1
                    );
                    formData.append(
                      "AttributeCombinationList_attributeValue2" + index,
                      element.attributeValue2
                    );
                    formData.append(
                      "AttributeCombinationList_attributeValue3" + index,
                      element.attributeValue3
                    );
                    formData.append(
                      "AttributeCombinationList_attributeValue4" + index,
                      element.attributeValue4
                    );
                    formData.append(
                      "AttributeCombinationList_attributeValue5" + index,
                      element.attributeValue4
                    );
                    formData.append(
                      "AttributeCombinationList_attributeValue5" + index,
                      element.attributeValue4
                    );
                    formData.append(
                      "AttributeCombinationList_sku" + index,
                      element.sku
                    );
                    formData.append(
                      "AttributeCombinationList_barcode" + index,
                      element.barcode
                    );
                    formData.append(
                      "AttributeCombinationList_price" + index,
                      element.price
                    );
                    formData.append(
                      "profileImage" + index,
                      element.profileImage
                    );
                  }

                  for (
                    let index = 0;
                    index < selectedAttributeList.length;
                    index++
                  ) {
                    const element = selectedAttributeList[index];

                    formData.append("AttributeMapping_id" + index, element.id);
                    formData.append(
                      "AttributeMapping_name" + index,
                      element.name
                    );
                    formData.append(
                      "AttributeMapping_otherList" + index,
                      element.otherList
                    );
                    let temp = "";
                    for (
                      let index1 = 0;
                      index1 < element.otherList.length;
                      index1++
                    ) {
                      const elementnew = element.otherList[index1];
                      if (index1 === 0) {
                        temp += elementnew;
                      } else {
                        temp += "," + elementnew;
                      }
                    }
                    formData.append("AttributeMapping_other" + index, temp);
                  }
                  let url =
                    Config.apiUrl + "Attribute/SaveAttributeCombination1";
                  if (ispost === false) {
                    url = Config.apiUrl + "Attribute/UpdateAttributeValueMapp";
                  }
                  fetch(url, {
                    method: "POST",
                    headers: {
                      userCompanyID: loginid,
                      Authorization: "Bearer " + Auth0token,
                    },
                    body: formData,
                  })
                    .then((result1) => {
                      result1
                        .json()
                        .then((resp1) => {
                          if (resp1 != null) {
                            onEditBindAttributeValue(resp1.articleID);
                            setAttributeisloding(false);
                            if (
                              resp1.articleID != null &&
                              resp1.articleID != ""
                            ) {
                              swal(
                                "Saved",
                                "Article's attribute details are saved.",
                                "success"
                              );
                            } else {
                              swal(
                                "Sorry!",
                                "Article's attribute details are not saved.",
                                "error"
                              );
                            }
                          }
                        })
                        .catch((error) => {
                          setAttributeisloding(false);
                          console.log("Error:-", error);
                        });
                    })
                    .catch((error) => {
                      setAttributeisloding(false);
                      console.log("Error:-", error);
                    });
                }
              }
              setAttributeisloding(false);
            } else {
              setAttributeisloding(false);
              swal(
                "Sorry!",
                "Article's attribute details are not saved.",
                "error"
              );
            }
          });
        });
      } else {
        setAttributeisloding(true);
        // createArticlestypes(ArticleID, ArticlesTypeId);
        if (
          ArticlesTypeId === null ||
          ArticlesTypeId === "" ||
          ArticlesTypeId === undefined ||
          ArticlesTypeId === "0"
        ) {
          IsValid = false;
          setArticleTypeError("Please Selcte Article Type");
        }
        if (CombinationList.length === 0) {
          IsValid = false;
        }
        if (selectedAttributeList.length === 0) {
          IsValid = false;
        }
        if (IsValid === true) {
          setAttributeisloding(true);
          await createArticlestypes(ArticleID, ArticlesTypeId);
          const byte =
            CombinationList.map((item) => item?.profileImage?.size || 0).reduce(
              (prev, curr) => prev + curr,
              0
            ) || 0;
          if (byte > 0) {
            let StorageResponse = await CheckStorageLimit(byte);
            if (StorageResponse === true || StorageResponse === "true") {
              const formData = new FormData();
              formData.append("ArticleID", ArticleID);
              formData.append("ArticleTypeID", ArticlesTypeId);
              formData.append("UserCompanyID", loginid);
              formData.append("combinationCount", CombinationList.length);
              formData.append(
                "selectedAttributeCount",
                selectedAttributeList.length
              );

              let ispost = true;
              if (selectedAttributeList.length > 0) {
                let ischeck = CombinationList.filter(
                  (x) => x.id != null && x.id != "" && x.id != undefined
                );
                if (ischeck.length > 0) {
                  ispost = false;
                }
              }
              for (let index = 0; index < CombinationList.length; index++) {
                const element = CombinationList[index];
                formData.append(
                  "AttributeCombinationList_id" + index,
                  element.id
                );
                formData.append(
                  "AttributeCombinationList_attributeValue1" + index,
                  element.attributeValue1
                );
                formData.append(
                  "AttributeCombinationList_attributeValue2" + index,
                  element.attributeValue2
                );
                formData.append(
                  "AttributeCombinationList_attributeValue3" + index,
                  element.attributeValue3
                );
                formData.append(
                  "AttributeCombinationList_attributeValue4" + index,
                  element.attributeValue4
                );
                formData.append(
                  "AttributeCombinationList_attributeValue5" + index,
                  element.attributeValue4
                );
                formData.append(
                  "AttributeCombinationList_attributeValue5" + index,
                  element.attributeValue4
                );
                formData.append(
                  "AttributeCombinationList_sku" + index,
                  element.sku
                );
                formData.append(
                  "AttributeCombinationList_barcode" + index,
                  element.barcode
                );
                formData.append(
                  "AttributeCombinationList_price" + index,
                  element.price
                );
                formData.append("profileImage" + index, element.profileImage);
              }

              for (
                let index = 0;
                index < selectedAttributeList.length;
                index++
              ) {
                const element = selectedAttributeList[index];

                formData.append("AttributeMapping_id" + index, element.id);
                formData.append("AttributeMapping_name" + index, element.name);
                formData.append(
                  "AttributeMapping_otherList" + index,
                  element.otherList
                );
                let temp = "";
                for (
                  let index1 = 0;
                  index1 < element.otherList.length;
                  index1++
                ) {
                  const elementnew = element.otherList[index1];
                  if (index1 === 0) {
                    temp += elementnew;
                  } else {
                    temp += "," + elementnew;
                  }
                }
                formData.append("AttributeMapping_other" + index, temp);
              }

              let url = Config.apiUrl + "Attribute/SaveAttributeCombination1";
              if (ispost === false) {
                url = Config.apiUrl + "Attribute/UpdateAttributeValueMapp";
              }
              fetch(url, {
                method: "POST",
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: formData,
              })
                .then((result1) => {
                  result1
                    .json()
                    .then(async (resp1) => {
                      if (resp1 != null) {
                        await onEditBindAttributeValue(resp1.articleID);
                        setAttributeisloding(false);
                        if (resp1.articleID != null && resp1.articleID != "") {
                          swal(
                            "Saved",
                            "Article's attribute details are saved.",
                            "success"
                          );
                        } else {
                          swal(
                            "Sorry!",
                            "Article's attribute details are not saved.",
                            "error"
                          );
                        }
                      } else {
                        setAttributeisloding(false);
                      }
                    })
                    .catch((error) => {
                      setAttributeisloding(false);
                      console.log("Error:-", error);
                    });
                })
                .catch((error) => {
                  setAttributeisloding(false);
                  console.log("Error:-", error);
                });
            } else if (
              StorageResponse === false ||
              StorageResponse === "false"
            ) {
              const formData = new FormData();
              formData.append("ArticleID", ArticleID);
              formData.append("ArticleTypeID", ArticlesTypeId);
              formData.append("UserCompanyID", loginid);
              formData.append("combinationCount", CombinationList.length);
              formData.append(
                "selectedAttributeCount",
                selectedAttributeList.length
              );

              let ispost = true;
              if (selectedAttributeList.length > 0) {
                let ischeck = CombinationList.filter(
                  (x) => x.id != null && x.id != "" && x.id != undefined
                );
                if (ischeck.length > 0) {
                  ispost = false;
                }
              }
              for (let index = 0; index < CombinationList.length; index++) {
                const element = CombinationList[index];
                formData.append(
                  "AttributeCombinationList_id" + index,
                  element.id
                );
                formData.append(
                  "AttributeCombinationList_attributeValue1" + index,
                  element.attributeValue1
                );
                formData.append(
                  "AttributeCombinationList_attributeValue2" + index,
                  element.attributeValue2
                );
                formData.append(
                  "AttributeCombinationList_attributeValue3" + index,
                  element.attributeValue3
                );
                formData.append(
                  "AttributeCombinationList_attributeValue4" + index,
                  element.attributeValue4
                );
                formData.append(
                  "AttributeCombinationList_attributeValue5" + index,
                  element.attributeValue4
                );
                formData.append(
                  "AttributeCombinationList_attributeValue5" + index,
                  element.attributeValue4
                );
                formData.append(
                  "AttributeCombinationList_sku" + index,
                  element.sku
                );
                formData.append(
                  "AttributeCombinationList_barcode" + index,
                  element.barcode
                );
                formData.append(
                  "AttributeCombinationList_price" + index,
                  element.price
                );
                // formData.append(
                //   "profileImage" + index,
                //   element.profileImage
                // );
              }

              for (
                let index = 0;
                index < selectedAttributeList.length;
                index++
              ) {
                const element = selectedAttributeList[index];

                formData.append("AttributeMapping_id" + index, element.id);
                formData.append("AttributeMapping_name" + index, element.name);
                formData.append(
                  "AttributeMapping_otherList" + index,
                  element.otherList
                );
                let temp = "";
                for (
                  let index1 = 0;
                  index1 < element.otherList.length;
                  index1++
                ) {
                  const elementnew = element.otherList[index1];
                  if (index1 === 0) {
                    temp += elementnew;
                  } else {
                    temp += "," + elementnew;
                  }
                }
                formData.append("AttributeMapping_other" + index, temp);
              }

              let url = Config.apiUrl + "Attribute/SaveAttributeCombination1";
              if (ispost === false) {
                url = Config.apiUrl + "Attribute/UpdateAttributeValueMapp";
              }
              fetch(url, {
                method: "POST",
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: formData,
              })
                .then((result1) => {
                  result1
                    .json()
                    .then(async (resp1) => {
                      if (resp1 != null) {
                        await onEditBindAttributeValue(resp1.articleID);
                        setAttributeisloding(false);
                        if (resp1.articleID != null && resp1.articleID != "") {
                          swal(
                            "Saved",
                            "Article's attribute details are saved.",
                            "success"
                          );
                        } else {
                          swal(
                            "Sorry!",
                            "Article's attribute details are not saved.",
                            "error"
                          );
                        }
                      } else {
                        setAttributeisloding(false);
                      }
                    })
                    .catch((error) => {
                      console.log("Error:-", error);
                      setAttributeisloding(false);
                    });
                })
                .catch((error) => {
                  console.log("Error:-", error);
                  setAttributeisloding(false);
                });
            }
          } else {
            const formData = new FormData();
            formData.append("ArticleID", ArticleID);
            formData.append("ArticleTypeID", ArticlesTypeId);
            formData.append("UserCompanyID", loginid);
            formData.append("combinationCount", CombinationList.length);
            formData.append(
              "selectedAttributeCount",
              selectedAttributeList.length
            );

            let ispost = true;
            if (selectedAttributeList.length > 0) {
              let ischeck = CombinationList.filter(
                (x) => x.id != null && x.id != "" && x.id != undefined
              );
              if (ischeck.length > 0) {
                ispost = false;
              }
            }
            for (let index = 0; index < CombinationList.length; index++) {
              const element = CombinationList[index];
              formData.append(
                "AttributeCombinationList_id" + index,
                element.id
              );
              formData.append(
                "AttributeCombinationList_attributeValue1" + index,
                element.attributeValue1
              );
              formData.append(
                "AttributeCombinationList_attributeValue2" + index,
                element.attributeValue2
              );
              formData.append(
                "AttributeCombinationList_attributeValue3" + index,
                element.attributeValue3
              );
              formData.append(
                "AttributeCombinationList_attributeValue4" + index,
                element.attributeValue4
              );
              formData.append(
                "AttributeCombinationList_attributeValue5" + index,
                element.attributeValue4
              );
              formData.append(
                "AttributeCombinationList_attributeValue5" + index,
                element.attributeValue4
              );
              formData.append(
                "AttributeCombinationList_sku" + index,
                element.sku
              );
              formData.append(
                "AttributeCombinationList_barcode" + index,
                element.barcode
              );
              formData.append(
                "AttributeCombinationList_price" + index,
                element.price
              );
              formData.append("profileImage" + index, element.profileImage);
            }

            for (let index = 0; index < selectedAttributeList.length; index++) {
              const element = selectedAttributeList[index];

              formData.append("AttributeMapping_id" + index, element.id);
              formData.append("AttributeMapping_name" + index, element.name);
              formData.append(
                "AttributeMapping_otherList" + index,
                element.otherList
              );
              let temp = "";
              for (
                let index1 = 0;
                index1 < element.otherList.length;
                index1++
              ) {
                const elementnew = element.otherList[index1];
                if (index1 === 0) {
                  temp += elementnew;
                } else {
                  temp += "," + elementnew;
                }
              }
              formData.append("AttributeMapping_other" + index, temp);
            }

            let url = Config.apiUrl + "Attribute/SaveAttributeCombination1";
            if (ispost === false) {
              url = Config.apiUrl + "Attribute/UpdateAttributeValueMapp";
            }
            fetch(url, {
              method: "POST",
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: formData,
            })
              .then((result1) => {
                result1
                  .json()
                  .then(async (resp1) => {
                    if (resp1 != null) {
                      await onEditBindAttributeValue(resp1.articleID);
                      setAttributeisloding(false);
                      if (resp1.articleID != null && resp1.articleID != "") {
                        swal(
                          "Saved",
                          "Article's attribute details are saved.",
                          "success"
                        );
                      } else {
                        swal(
                          "Sorry!",
                          "Article's attribute details are not saved.",
                          "error"
                        );
                      }
                    } else {
                      setAttributeisloding(false);
                    }
                  })
                  .catch((error) => {
                    setAttributeisloding(false);
                    console.log("Error:-", error);
                  });
              })
              .catch((error) => {
                setAttributeisloding(false);
                console.log("Error:-", error);
              });
          }
        } else {
          setAttributeisloding(false);
        }
      }
    }
  };
  const CreateArticleType = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleID != null &&
      ArticleID != "" &&
      ArticleID != undefined
      //&&
      // ArticlesTypeId != null &&
      // ArticlesTypeId != "" &&
      // ArticlesTypeId != undefined &&
      // ArticlesTypeId != "0"
    ) {
      var data = {
        _id: ArticleID,
        ArticleTypeID: ArticlesTypeId,
        UserCompanyID: loginid,
      };
      setAttributeisloding(true);
      fetch(Config.apiUrl + "ArticleProduct/UpdateType?id=" + ArticleID, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            setAttributeisloding(false);
            if (resp?._id != null) {
              swal("Saved", "Article's Type  are saved.", "success");
            } else {
              swal(
                "Sorry!",
                "Article's attribute details are not saved.",
                "error"
              );
            }
          }
        });
      });
    } else {
      if (
        ArticlesTypeId != null &&
        ArticlesTypeId != "" &&
        ArticlesTypeId != undefined &&
        ArticlesTypeId != "0"
      ) {
        setAttributeisloding(true);
        var data = {
          _id: ArticleID,
          UserCompanyID: loginid,
          IsProduct: true,
          ArticleTypeID: ArticlesTypeId,
          ArticleName: ArticleName,
          ArticleNumber: ArticleNumber,
        };
        fetch(Config.apiUrl + "ArticleProduct/Create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              CretaeFixSegmentName(resp._id);
              setisArticleDisable(true);
              setArticleID(resp._id);
            } else {
              swal(
                "Sorry!",
                "Article's attribute details are not saved.",
                "error"
              );
            }
            setAttributeisloding(false);
          });
        });
      } else {
        setArticleTypeError("Please Selcte Article Type");
      }
    }
  };

  const getUploadParams = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };

  const title = articleSegmentList.map((x) => {
    return (
      <Tab
        onClick={() => {
          ArticleSegmentgetbyId(x._id);
        }}
        key={x._id}
      >
        {x.title}
      </Tab>
    );
  });

  const text = articleSegmentList.map((x) => {
    return <TabPanel key={x._id}>{x.Title}</TabPanel>;
  });
  const displayPosts = (
    <Tabs defaultIndex={0} onSelect={(index) => console.log(index)}>
      <TabList>{title}</TabList>
      {text}
    </Tabs>
  );

  const CreateAttributegenratemapping = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    if (selectedAttributeList.length > 0) {
      fetch(Config.apiUrl + "Attribute/GenerateAttributeCombination", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(selectedAttributeList),
      }).then((result) => {
        result.json().then((resp) => {
          setCombinationList([]);
          if (resp != null) {
            if (resp.attributeCombinationList.length > 0) {
              setCombinationList(resp.attributeCombinationList);
            }
          }
        });
      });
    } else {
      swal("Add Product Attribute");
    }
  };

  const createArticlestypes = (ArticleIDObj, ArticlesTypeIdObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleIDObj != null &&
      ArticleIDObj != "" &&
      ArticleIDObj != undefined &&
      ArticlesTypeIdObj != null &&
      ArticlesTypeIdObj != "" &&
      ArticlesTypeIdObj != undefined &&
      ArticlesTypeIdObj != "0"
    ) {
      var data = {
        _id: ArticleID,
        ArticleTypeID: ArticlesTypeId,
        UserCompanyID: loginid,
      };
      fetch(Config.apiUrl + "ArticleProduct/UpdateType?id=" + ArticleID, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            //setshow();
            setArticlesTypeId(ArticlesTypeIdObj);
          }
        });
      });
    }
  };

  const IsArticleTypehandleSubmit = (e) => {
    setIsArticleTypeDisplay(e.target.checked);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl +
      "ArticleProduct/UpdatePublish?id=" +
      ArticleID +
      "&type=" +
      "type" +
      "&isPublish=" +
      e.target.checked,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": "*",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((result) => {
      result.json().then((resp) => {
        // if (resp === false) {
        //     setIsArticleTypeDisplay(!e.target.checked);
        // }
        if (resp === true) {
          swal("Congratulations ! update successfully.", {
            icon: "success",
          });
        } else {
          setIsArticleTypeDisplay(!e.target.checked);
          swal("Sorry!", "Not update.", "error");
        }
      });
    });
  };

  const toggleSegmentModal = () => {
    setSegmentModalisOpen(!SegmentModalisOpen);
    setTitle("");
  };
  const toggleSegmentModalEdit = () => {
    setSegmentEditisOpen(!SegmentEditisOpen);
    //getAllArticleSegmentList(ArticleID);
  };
  const toggleSegmentEditDetails = () => {
    if (SegmentEditDetailsisOpen === true) {
      setSegmentEditisOpen(true);
    }
    setSegmentEditDetailsisOpen(!SegmentEditDetailsisOpen);
    //getAllArticleSegmentList(ArticleID);
  };
  const onChangeArticlesegmentName = (event) => {
    setTitleError("");
    setTitle(event.target.value);
    // setTitleError('');
    // if (event.target.value.length > 30) {
    //     setTitleError("You have reached your maximum limit of characters allowed")
    // }
    // else {
    //     setTitle(event.target.value);
    // }
  };
  const createArticleSegmentName = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (Title === null || Title === "" || Title === undefined) {
      IsValid = false;
      setTitleError("Please Enter Segment Name");
    }
    if (IsValid === true) {
      var data = {
        _id: ArticleID,
        UserCompanyID: loginid,
        IsProduct: true,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
      };

      if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
        fetch(Config.apiUrl + "ArticleProduct/Create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              CretaeFixSegmentName(resp._id);
              setisArticleDisable(true);
              setArticleID(resp._id);
              let A_ID = resp._id;
              var dataSagment = {
                _id: "",
                Title: Title,
                ArticleID: A_ID,
                UserCompanyID: loginid,
              };
              fetch(
                Config.apiUrl +
                "ArticleProductSegment/CheckSegment?id=" +
                A_ID +
                "&segmentName=" +
                Title,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    userCompanyID: loginid,
                    Authorization: "Bearer " + Auth0token,
                  },
                }
              ).then((resp1) => {
                resp1.json().then((result) => {
                  if (result === false) {
                    fetch(Config.apiUrl + "ArticleProductSegment/Create", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        "Access-Control-Allow-Origin": "*",
                        userCompanyID: loginid,
                        Authorization: "Bearer " + Auth0token,
                      },
                      body: JSON.stringify(dataSagment),
                    }).then((result1) => {
                      result1.json().then((resp1) => {
                        if (resp1 != null) {
                          getAllArticleSegmentList(A_ID);
                          toggleSegmentModal(false);
                          swal(
                            "Saved",
                            "Article's Segment Name are saved.",
                            "success"
                          );
                        } else
                          swal(
                            "Sorry!",
                            "Article's Segment Name are not saved.",
                            "error"
                          );
                      });
                    });
                  } else {
                    swal("Your Segment name already exists !");
                  }
                });
              });
            } else {
              swal("Saved", "Article's Segment Name are saved.", "success");
            }
          });
        });
      } else {
        var dataSagment = {
          _id: "",
          Title: Title,
          ArticleID: ArticleID,
          UserCompanyID: loginid,
        };
        fetch(
          Config.apiUrl +
          "ArticleProductSegment/CheckSegment?id=" +
          ArticleID +
          "&segmentName=" +
          Title,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        ).then((resp1) => {
          resp1.json().then((result) => {
            if (result === false) {
              fetch(Config.apiUrl + "ArticleProductSegment/Create", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: JSON.stringify(dataSagment),
              }).then((result1) => {
                result1.json().then((resp) => {
                  if (resp != null) {
                    getAllArticleSegmentList(ArticleID);
                    toggleSegmentModal(false);
                    swal(
                      "Saved",
                      "Article's Segment Name are saved.",
                      "success"
                    );
                  } else
                    swal(
                      "Sorry!",
                      "Article's Segment Name are not saved.",
                      "error"
                    );
                });
              });
            } else {
              swal("Your Segment name already exists !");
            }
          });
        });
      }
    }
  };
  const onClickArticleSegmentNameEdit = (item) => {
    setTitle(item.title);
    setArticleSegmentID(item._id);
    setSegmentEditisOpen(false);
    toggleSegmentEditDetails();
  };
  const ArticlesegmentNamedelete = (_idObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(Config.apiUrl + "ArticleProductSegment/Delete?id=" + _idObj, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }).then((result) => {
          result.json().then((resp) => {
            if (resp === true) {
              getAllArticleSegmentList(ArticleID);
              swal("Congratulations! Your data deleted successfully.", {
                icon: "success",
              });
            } else {
              swal("Your Product Segment Name is safe!");
            }
            //ArticledocumentsegmentListgetData();
          });
        });
      }
    });
  };
  const UpdateArticleSegmentName = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      IsValid = false;
    }
    if (Title === "" || Title === undefined || Title === null) {
      IsValid = false;
      setTitleError("Please Enter Segment Name");
    }
    if (IsValid === true) {
      var data = {
        _id: ArticleSegmentID,
        ArticleID: ArticleID,
        Title: Title,
        UserCompanyID: loginid,
      };

      fetch(
        Config.apiUrl +
        "ArticleProductSegment/CheckSegment?id=" +
        ArticleID +
        "&segmentName=" +
        Title,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            fetch(
              Config.apiUrl +
              "ArticleProductSegment/UpdateName?id=" +
              ArticleSegmentID,
              {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  "Access-Control-Allow-Origin": "*",
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: JSON.stringify(data),
              }
            ).then((result) => {
              result.json().then((resp) => {
                if (resp != null && resp?._id !== null  && resp?._id !== "") {
                  getAllArticleSegmentList(resp?.articleID);
                  toggleSegmentEditDetails();
                  setSegmentEditisOpen(true);
                  swal("Saved", "Article's Segment Name are saved.", "success");
                } else
                  swal(
                    "Sorry!",
                    "Article's Segment Name are not saved.",
                    "error"
                  );
              });
            });
          } else {
            swal("Your Segment name already exists !");
          }
        });
      });
    }
  };

  const IsArticleImagehandleSubmit = (e) => {
    //setIsArticleImageDisplay(e.target.checked);
    //createArticleImagecheckboxupdate(ArticleID, e.target.checked);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setIsArticleImageDisplay(e.target.checked);
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      // let loginid = localStorage.getItem("loginUserID");
      // setIsSizeTabelDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "image" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsSizeTabelDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
          // if (resp === false) {
          //     setIsSizeTabelDisplay(!e.target.checked);
          // }
        });
      });
    } else {
      var data = {
        _id: ArticleID,
        UserCompanyID: loginid,
        IsProduct: true,
        IsArticleImageDisplay: e.target.checked,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
        //_id: ArticleID
      };
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            //setisArticleDisable(true);
            CretaeFixSegmentName(resp._id);
            setArticleID(resp._id);
            setisArticleDisable(true);
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsSizeTabelDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const getUploadArticleImage = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeArticleImageStatus = ({ meta, file }, status) => {
    // console.log(status, meta, file);
  };
  const CreateArticlePics = (event) => {
    let Auth0token = localStorage.getItem("Auth0token");
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let tempFiles = [];
    event.map((i) => {
      tempFiles.push(i.file);
    });
    event.forEach((f) => f.remove());
    if (tempFiles.length > 0) {
      const byte =
        tempFiles
          .map((item) => item.size || 0)
          .reduce((prev, curr) => prev + curr, 0) || 0;
      fetch(
        Config.apiUrl +
        "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
        UserCompanyId +
        "&UserFileSize=" +
        byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            setisrefresh(true);
            const formData = new FormData();
            formData.append("fileType", "articleimage");
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            tempFiles.map((i) => {
              formData.append("body", i);
            });
            if (
              ArticleID === null ||
              ArticleID === "" ||
              ArticleID === undefined
            ) {
              var data = {
                _id: ArticleID,
                UserCompanyID: loginid,
                IsProduct: true,
                ArticleName: ArticleName,
                ArticleNumber: ArticleNumber,
              };
              fetch(Config.apiUrl + "ArticleProduct/Create", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                body: JSON.stringify(data),
              }).then((result) => {
                result.json().then((resp) => {
                  if (resp != null) {
                    document.body.style.overflow = "auto";
                    setisrefresh(false);
                    CretaeFixSegmentName(resp._id);
                    setisArticleDisable(true);
                    formData.append("targetId", resp._id);
                    setArticleID(resp._id);
                    let A_ID = resp._id;
                    fetch(Config.apiUrl + "FileUpload/Create", {
                      headers: {
                        userCompanyID: loginid,
                        Authorization: "Bearer " + Auth0token,
                      },
                      method: "POST",
                      body: formData,
                    }).then((result) => {
                      result.json().then((resp) => {
                        getAllArticlePicsList(A_ID);
                      });
                    });
                  } else {
                    swal(
                      "Sorry!",
                      "Article's SizeTabel details are not saved.",
                      "error"
                    );
                  }
                });
              });
            } else {
              formData.append("targetId", ArticleID);
              fetch(Config.apiUrl + "FileUpload/Create", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "POST",
                body: formData,
              }).then((result) => {
                result.json().then((resp) => {
                  document.body.style.overflow = "auto";
                  setisrefresh(false);
                  // console.log(resp);
                  getAllArticlePicsList(ArticleID);
                });
              });
            }
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      document.body.style.overflow = "auto";
      setisrefresh(false);
    }
  };

  //Article Segment Description Disply
  const IsArticleDescriptionDisplyUpdate = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setIsArticleDescriptionDisplay(e.target.checked);
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "description" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          // if (resp === false) {
          //     setIsArticleDescriptionDisplay(!e.target.checked);
          // }
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleDescriptionDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    } else {
      var data = {
        _id: ArticleID,
        UserCompanyID: loginid,
        IsProduct: true,
        IsArticleDescriptionDisplay: e.target.checked,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
      };
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            CretaeFixSegmentName(resp._id);
            setisArticleDisable(true);
            setArticleID(resp._id);
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleDescriptionDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  //Article Segment Image Method
  const IsArticleSegmentImagehandleSubmit = (e) => {
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentImageDisplay(e.target.checked);
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "ArticleProductSegment/UpdatePublish?id=" +
        ArticleSegmentID +
        "&type=" +
        "segmentimage" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          // if (resp === false) {
          //     setIsArticleSegmentImageDisplay(!e.target.checked);
          // }

          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentImageDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const ArticlesegmentImagedelete = (_idFileUplod) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      _idFileUplod != null &&
      _idFileUplod != "" &&
      _idFileUplod != undefined
    ) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "FileUpload/Delete?id=" + _idFileUplod, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              ArticleSegmentgetbyId(ArticleSegmentID);
              if (resp === true) {
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article Segment Images is safe!");
              }
            });
          });
        }
      });
    }
  };
  const getArticleUploadParamsSegmentImages = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeArticleUploadSegmentImagesStatus = (
    { meta, file },
    status
  ) => {
    // console.log(status, meta, file)
  };
  const CreateArticleSegmentImages = (event) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let tempFiles = [];
    event.map((i) => {
      tempFiles.push(i.file);
    });
    event.forEach((f) => f.remove());
    if (tempFiles.length > 0) {
      const byte =
        tempFiles
          .map((item) => item?.size || 0)
          .reduce((prev, curr) => prev + curr, 0) || 0;
      fetch(
        Config.apiUrl +
        "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
        UserCompanyId +
        "&UserFileSize=" +
        byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            const formData = new FormData();
            formData.append("fileType", "articlesegmentimage");
            formData.append("targetId", ArticleSegmentID);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            tempFiles.map((i) => {
              formData.append("body", i);
            });
            setisrefresh(true);
            document.body.style.overflow = "hidden";
            fetch(Config.apiUrl + "FileUpload/Create", {
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "POST",
              body: formData,
            })
              .then((result) => {
                result.json().then((resp) => {
                  // console.log(resp);
                  setisrefresh(false);
                  document.body.style.overflow = "auto";
                  ArticleSegmentgetbyId(ArticleSegmentID);
                });
              })
              .catch((error) => {
                setisrefresh(false);
                document.body.style.overflow = "auto";
                console.log(error);
              });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      setisrefresh(false);
      document.body.style.overflow = "auto";
    }
  };
  //End
  const IsArticleSegmentDescriptionhandleSubmit = (e) => {
    // setIsArticleSegmentDescriptionDisplay(e.target.checked);
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentDescriptionDisplay(e.target.checked);
      let Auth0token = localStorage.getItem("Auth0token");
      let loginid = localStorage.getItem("loginUserID");
      fetch(
        Config.apiUrl +
        "ArticleProductSegment/UpdatePublish?id=" +
        ArticleSegmentID +
        "&type=" +
        "segmentdescription" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentDescriptionDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const createdeSegmentDescription = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");

    var data = {
      _id: ArticleSegmentID,
      Description: SegmentDescription,
      IsArticleSegmentDescriptionDisplay: IsArticleSegmentDescriptionDisplay,
      UserCompanyID: loginid,
      ArticleID: ArticleID,
    };
    fetch(Config.apiUrl + "ArticleProductSegment/UpdateDescription/", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(data),
    }).then((result) => {
      result.json().then((resp) => {
        // if (resp != null) {
        //     ArticleSegmentgetbyId(ArticleSegmentID);
        // }
        if (resp != null) {
          ArticleSegmentgetbyId(ArticleSegmentID);
          swal(
            "Saved",
            "Article' Segment Description  are Updated.",
            "success"
          );
        } else
          swal(
            "Sorry!",
            "Article's Segment Description are not saved.",
            "error"
          );
      });
    });
    // if (
    //   SegmentDescription != null &&
    //   SegmentDescription != "" &&
    //   SegmentDescription != undefined
    // ) {

    // } else {
    //   setSegmentDescriptionError("Please Enter Description");
    // }
  };

  //Article Segment Video Method start
  const IsArticleSegmentVideoUpdate = (e) => {
    //setIsArticleSegmentVideoDisplay(e.target.checked);
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentVideoDisplay(e.target.checked);
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "ArticleProductSegment/UpdatePublish?id=" +
        ArticleSegmentID +
        "&type=" +
        "segmentvideo" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          // if (resp === false) {
          //     //setIsArticleSegmentImageDisplay(!e.target.checked);
          //     setIsArticleSegmentVideoDisplay(!e.target.checked);
          // }
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentVideoDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const ArticlesegmentVideodelete = (_idFileUplod) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      _idFileUplod != null &&
      _idFileUplod != "" &&
      _idFileUplod != undefined
    ) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "FileUpload/Delete?id=" + _idFileUplod, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                ArticleSegmentgetbyId(ArticleSegmentID);
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Article Segment Video is safe!");
              }
            });
          });
        }
      });
    }
  };

  const reyurnperamiter = (item) => {
    let itemobj = item.split("https://www.youtube.com/watch");
    return new URLSearchParams(itemobj[1]).get("v");
    //    console.log("IdPraveen=>",ID)
  };
  const getArticleUploadParamsVideos = ({ meta }) => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeArticleSegmentVideoUploadStatus = (
    { meta, file },
    status
  ) => {
    console.log(status, meta, file);
    // if (status === 'done') {
    //     if (VideosegmentListTemp.length > 0) {
    //         let temp = VideosegmentListTemp;
    //         temp.push(file);
    //         setVideosegmentListTemp(temp);
    //     }
    //     else {
    //         let temp = [];
    //         temp.push(file);
    //         setVideosegmentListTemp(temp);
    //     }
    // }

    // if (status === 'removed') {
    //     if (VideosegmentListTemp.length > 0) {
    //         var index = VideosegmentListTemp.indexOf(file);
    //         setVideosegmentListTemp.splice(index, 1);
    //     }
    // }
  };
  const CreateArticleSegmentVideo = (event) => {
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let tempFiles = [];
    event.map((i) => {
      tempFiles.push(i.file);
    });
    event.forEach((f) => f.remove());
    if (tempFiles.length > 0) {
      const byte =
        tempFiles
          .map((item) => item?.size || 0)
          .reduce((prev, curr) => prev + curr, 0) || 0;
      fetch(
        Config.apiUrl +
        "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
        UserCompanyId +
        "&UserFileSize=" +
        byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            setisrefresh(true);
            const formData = new FormData();
            tempFiles.map((i) => {
              formData.append("body", i);
            });
            formData.append("fileType", "articlesegmentvideo");
            formData.append("targetId", ArticleSegmentID);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            fetch(Config.apiUrl + "FileUpload/Create", {
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "POST",
              body: formData,
            }).then((result) => {
              result.json().then((resp) => {
                document.body.style.overflow = "auto";
                setisrefresh(false);
                // console.log(resp);
                if (resp) {
                  ArticleSegmentgetbyId(ArticleSegmentID);
                  swal(
                    "Saved",
                    "Article's Segment Videos are saved.",
                    "success"
                  );
                } else
                  swal(
                    "Sorry!",
                    "Article's Segment Videos are not saved.",
                    "error"
                  );
              });
            });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    }
  };
  //End

  //WebLink Method start
  const IsArticleSegmentWebLinkupdate = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentWebLinkDisplay(e.target.checked);

      fetch(
        Config.apiUrl +
        "ArticleProductSegment/UpdatePublish?id=" +
        ArticleSegmentID +
        "&type=" +
        "segmentexternallink" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentWebLinkDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const onChangeWebLink = (event) => {
    // setWebLinkError('');
    // setwebLink(event.target.value);
    setWebLinkError("");
    // if (!/^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/.test(event.target.value)) {
    //     setWebLinkError("Invalid weblink");
    //     setwebLink(event.target.value);
    // }
    // else {
    //     setwebLink(event.target.value);
    // }
    if (
      event.target.value !== null &&
      event.target.value !== "" &&
      event.target.value !== undefined
    ) {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(event.target.value)
      ) {
        setWebLinkError("Invalid weblink");
        setwebLink(event.target.value);
      } else {
        setwebLink(event.target.value);
      }
    } else {
      setwebLink(event.target.value);
    }
  };
  const onChangewebsitelinkname = (event) => {
    // setwebsitelinknameError('');
    // setwebsitelinkname(event.target.value);
    setwebsitelinknameError("");
    if (event.target.value.length > 30) {
      setwebsitelinknameError(
        "You have reached your maximum limit of characters allowed"
      );
    } else {
      setwebsitelinkname(event.target.value);
    }
  };

  const createWebLink = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (webLink === "" || webLink === undefined || webLink === null) {
      IsValid = false;
      setWebLinkError("webLink must be filled out");
    } else {
      if (
        !new RegExp(
          "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
        ).test(webLink)
      ) {
        setWebLinkError("Invalid weblink");
        IsValid = false;
      }
    }
    if (IsValid === true) {
      var data = {
        //_id: this.state._id,
        Name: websitelinkname,
        UserCompanyID: loginid,
        LinkURL: webLink,
        ArticleSegmentID: ArticleSegmentID,
      };
      fetch(Config.apiUrl + "ExternalLink/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            ArticleSegmentgetbyId(ArticleSegmentID);
            setwebLink("");
            setwebsitelinkname("");
            swal("Saved", "Article's WebLink details are saved.", "success");
          } else
            swal("Sorry!", "Article's WebLink details are not saved.", "error");
        });
      });
    }
  };
  const ArticleWeblinkdelete = (_idObj) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (_idObj != null && _idObj != "" && _idObj != undefined) {
      swal({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this imaginary file!",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          fetch(Config.apiUrl + "ExternalLink/Delete?id=" + _idObj, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                ArticleSegmentgetbyId(ArticleSegmentID);
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your WebLink is safe!");
              }
              //ArticleWebLinkListgetData();
            });
          });
        }
      });
    }
  };
  // end

  //Documents Method start
  const IsArticleSegmentDocumentUpdate = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleSegmentID != null &&
      ArticleSegmentID != "" &&
      ArticleSegmentID != undefined
    ) {
      setIsArticleSegmentDocumentDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
        "ArticleProductSegment/UpdatePublish?id=" +
        ArticleSegmentID +
        "&type=" +
        "segmentdocument" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleSegmentDocumentDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const onChangeDocumentName = (event) => {
    setDocumentName(event.target.value);
  };
  const UpdateArticleDocumentFile = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    var data = {
      _id: ArticleDocumentID,
      ArticleSegmentID: ArticleSegmentID,
      FileName: DocumentName,
    };
    fetch(Config.apiUrl + "ArticleDocument/UpdateArticleDocument/", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(data),
    }).then((result) => {
      result.json().then((resp) => {
        if (resp) {
          ArticleSegmentgetbyId(ArticleSegmentID);
          //setshow(true);
          toggleArticleSegmentDocumentEditName();
          //getAllArticleSegmentList(ArticleID);
          //ArticleDocumentSegmentIdByListgetData(ArticleSegmentID);
          swal("Saved", "Article'Segment Document are Updated.", "success");
        } else
          swal("Sorry!", "Article'Segment Document are not Updated.", "error");
      });
    });
  };
  const downloadEmployeeData = (filename, myUrl) => {
    let downloadURL = Config.contentUrl + filename;
    window.open(downloadURL, "_blank");
  };
  const ArticlesegmentDocumentdelete = (ArticlesegmentDocumentID) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        fetch(
          Config.apiUrl + "FileUpload/Delete?id=" + ArticlesegmentDocumentID,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        ).then((result) => {
          result.json().then((resp) => {
            ArticleSegmentgetbyId(ArticleSegmentID);
            if (resp === true) {
              swal("Congratulations! Your data deleted successfully.", {
                icon: "success",
              });
            } else {
              swal("Your Article Segment Document is safe!");
            }
          });
        });
      }
    });
  };
  const onClickDocumentEdit = (item) => {
    setDocumentName(item.fileName);
    setArticleDocumentID(item._id);
    toggleArticleSegmentDocumentEditName();
  };
  const getArticleUploadParamsDocument = () => {
    return { url: "https://httpbin.org/post" };
  };
  const handleChangeArticleUploadDocumentStatus = ({ meta, file }, status) => {
    // console.log(status, meta, file);
  };
  const CreateArticleDocument = (event) => {
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let UserCompanyId = localStorage.getItem("UserCompanyId");
    let tempFiles = [];
    event.map((i) => {
      tempFiles.push(i.file);
    });
    event.forEach((f) => f.remove());
    if (tempFiles.length > 0) {
      const byte =
        tempFiles
          .map((item) => item.size || 0)
          .reduce((prev, curr) => prev + curr, 0) || 0;
      fetch(
        Config.apiUrl +
        "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
        UserCompanyId +
        "&UserFileSize=" +
        byte,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          if (resp1 === true || resp1 === "true") {
            setisrefresh(true);
            const formData = new FormData();
            tempFiles.map((i) => {
              formData.append("body", i);
            });
            formData.append("fileType", "articlesegmentdocument");
            formData.append("targetId", ArticleSegmentID);
            formData.append("externalLink", "");
            formData.append("displayOrder", "0");
            fetch(Config.apiUrl + "FileUpload/Create", {
              headers: {
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              method: "POST",
              body: formData,
            }).then((result) => {
              result.json().then((resp) => {
                document.body.style.overflow = "auto";
                setisrefresh(false);
                // console.log(resp);
                ArticleSegmentgetbyId(ArticleSegmentID);
              });
            });
          } else if (resp1 === false || resp1 === "false") {
            swal("oops!", "You not allow add Image", "warning");
          } else {
            alert(resp1);
          }
        });
    } else {
      document.body.style.overflow = "auto";
      setisrefresh(false);
    }
  };
  const toggleArticleSegmentDocumentEditName = () => {
    setArticleSegmentDocumentEditNameisOpen(
      !ArticleSegmentDocumentEditNameisOpen
    );
  };

  const createArticlesNameAndCategorySection = () => {
    let IsValid = true;
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (
      ArticleName === null ||
      ArticleName === "" ||
      ArticleName === undefined
    ) {
      IsValid = false;
      setArticleNameError("Please Enter Article Name");
    }
    if (IsValid === true) {
      var data = {
        _id: ArticleID,
        ArticleName: ArticleName,
        CategoryID: CategoryId,
        SubCategoryID: SubCategoryId,
        IsNameAndCatDisplay: IsNameAndCatDisplay,
        UserCompanyID: loginid,
        ArticleNumber: ArticleNumber,
        IsProduct: true,
      };

      if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
        fetch(Config.apiUrl + "ArticleProduct/Create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              CretaeFixSegmentName(resp._id);
              setisArticleDisable(true);
              setArticleID(resp._id);
              swal("Thank You", "Article's details are saved.", "success");
            } else {
              swal("Sorry!", "Article's details are not saved.", "error");
            }
          });
        });
      } else {
        fetch(Config.apiUrl + "ArticleProduct/UpdateCatrgory?id=" + ArticleID, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              swal("Thank You", "Article's details are saved.", "success");
            } else {
              swal("Sorry!", "Article's details are not saved.", "error");
            }
          });
        });
      }

      // if (ArticleNumber != null && ArticleNumber != "" && ArticleNumber != undefined) {
      // }
      // else {
      //     swal("oops!", "Please Enter Article Number", "error");
      // }
    }
  };
  //End
  const onChangeArticleShortDescription = (event) => {
    setArticleShortDescription(event);
    setArticleShortDescriptionError("");
  };

  const IshortDescriptionandleSubmit = (e) => {
    // setIsArticleshortDescriptionDisplay(e.target.checked);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      setIsArticleshortDescriptionDisplay(e.target.checked);
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "shortdescription" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticleshortDescriptionDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    } else {
      setIsArticleshortDescriptionDisplay(e.target.checked);
      var data = {
        _id: "",
        IsShortDescriptionDisplay: IsArticleshortDescriptionDisplay,
        UserCompanyID: loginid,
        IsProduct: true,
        ArticleNumber: ArticleNumber,
        ArticleName: ArticleName,
      };
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            CretaeFixSegmentName(resp._id);
            setArticleID(resp._id);
            swal("Thank You", "Article's details are saved.", "success");
          } else {
            setIsArticleshortDescriptionDisplay(!e.target.checked);
            swal("Sorry!", "Article's details are not saved.", "error");
          }
        });
      });
    }
  };
  const createShortDescription = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    // if (
    //   ArticleShortDescription === null ||
    //   ArticleShortDescription === "" ||
    //   ArticleShortDescription === undefined
    // ) {
    //   IsValid = false;
    //   setArticleShortDescriptionError("Please Enter Short Description");
    // }
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      setisrefresh(true);
      setShortDescriptionisloding(true);
      document.body.style.overflow = "hidden";

      var data = {
        _id: "",
        ShortDescription: ArticleShortDescription,
        IsShortDescriptionDisplay: IsArticleshortDescriptionDisplay,
        UserCompanyID: loginid,
        IsProduct: true,
        ArticleName: ArticleName,
        ArticleNumber: ArticleNumber,
      };
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          document.body.style.overflow = "auto";
          setShortDescriptionisloding(false);
          setisrefresh(false);
          if (resp != null) {
            CretaeFixSegmentName(resp._id);
            //setisArticleDisable(true);
            setArticleID(resp._id);
            swal("Thank You", "Article's details are saved.", "success");
          } else {
            swal("Sorry!", "Article's details are not saved.", "error");
          }
        });
      });
    } else {
      if (IsValid === true) {
        setShortDescriptionisloding(true);
        // setisrefresh(true);
        // document.body.style.overflow = "hidden";
        var data = {
          _id: ArticleID,
          ShortDescription: ArticleShortDescription,
          IsShortDescriptionDisplay: IsArticleshortDescriptionDisplay,
          UserCompanyID: loginid,
        };
        fetch(
          Config.apiUrl +
          "ArticleProduct/UpdateShortDescription?id=" +
          ArticleID,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
            body: JSON.stringify(data),
          }
        ).then((result) => {
          result.json().then((resp) => {
            // document.body.style.overflow = "auto";
            // setisrefresh(false);
            setShortDescriptionisloding(false);
            if (resp != null)
              swal(
                "Saved",
                "Article's ShortDescription details are saved.",
                "success"
              );
            else
              swal(
                "Sorry!",
                "Article's ShortDescription details are not saved.",
                "error"
              );
          });
        });
      }
    }
  };
  //Distance
  const Enablemadeindisplaysubmit = (e) => {
    // setisenablemadeindisplay(e.target.checked);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setisenablemadeindisplay(e.target.checked);
    var data = {
      _id: ArticleID,
      IsEnableMadeIndisplay: e.target.checked,
      UserCompanyID: loginid,
      IsProduct: true,
      ArticleName: ArticleName,
      ArticleNumber: ArticleNumber,
    };
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            if (resp._id != null && resp._id != "") {
              setisArticleDisable(true);
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              swal("Saved", "Article Madein are Updated.", "success");
            } else {
              swal("Sorry!", "Article Madein are not Updated.", "error");
            }
          } else {
            swal("Sorry!", "Article Madein are not Updated.", "error");
          }
        });
      });
    } else {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "enablemadein" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            // setisenablemadeindisplay(e.target.checked)
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setisenablemadeindisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };
  const Istraveldistanceenablesubmit = (e) => {
    // setistraveldistanceenable(e.target.checked);
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setistraveldistanceenable(e.target.checked);
    var data = {
      _id: ArticleID,
      IsTravelDistanceEnable: e.target.checked,
      UserCompanyID: loginid,
      IsProduct: true,
      ArticleName: ArticleName,
      ArticleNumber: ArticleNumber,
    };
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            if (resp._id != null && resp._id != "") {
              setisArticleDisable(true);
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              setistraveldistanceenable(e.target.checked);
              swal("Saved", "Article Madein are Updated.", "success");
            } else {
              swal("Sorry!", "Article Madein are not Updated.", "error");
            }
          } else {
            swal("Sorry!", "Article Madein are not Updated.", "error");
          }
        });
      });
    } else {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "traveldistance" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setistraveldistanceenable(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    }
  };

  const onUpdateDistance = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    var data = {
      _id: ArticleID,
      IsArticleDistanceDisplay: isarticledistancedisplay,
      IsEnableMadeIndisplay: isenablemadeindisplay,
      IsTravelDistanceEnable: istraveldistanceenable,
      UserCompanyID: loginid,
      IsProduct: true,
      ArticleName: ArticleName,
      ArticleNumber: ArticleNumber,
    };
    if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            if (resp._id != null && resp._id != "") {
              setisArticleDisable(true);
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              swal("Saved", "Article Distance are Updated.", "success");
            } else {
              swal("Sorry!", "Article Distance are not Updated.", "error");
            }
          } else {
            swal("Sorry!", "Article Distance are not Updated.", "error");
          }
        });
      });
    } else {
      fetch(Config.apiUrl + "ArticleProduct/UpdateDistance?id=" + ArticleID, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            if (resp._id != null && resp._id != "") {
              swal("Saved", "Article Distance are Updated.", "success");
            } else {
              swal("Sorry!", "Article Distance are not Updated.", "error");
            }
          } else swal("Sorry!", "Article Distance are not Updated.", "error");
        });
      });
    }
  };
  const AddArticleDetails = (ArticleIdObj) => {
    history.push({
      pathname: "/article-addnew",
      state: { EditArticleDetailsID: ArticleIdObj },
    });
  };

  const toggleSignupAdd = () => {
    Certificateclerefrom();
    setmodalSignupAdd(!modalSignupAdd);
  };
  const Certificateclerefrom = () => {
    setCertificateNameError("");
    setUserDcoumnetName("");
    setCertificateLogoPath("");
    setCertificateLogoFileError("");
    setCertificateLogoFile("");
    setCertificateWebsiteError("");
    setDocumentFileError("");
    setCertificateName("");
    setDocumentFile([]);
    setCertificateWebsite("");
    setCertificateWebsiteError("");
    setCertificateDocumentpath([]);
  };
  const CertificatesetFile = (event) => {
    setCertificateLogoPath(URL.createObjectURL(event.target.files[0]));
    setCertificateLogoFileError("");
    setCertificateLogoFile(event.target.files[0]);
  };

  const DcoumnetNameEdit = (event, i) => {
    let temp = [...CertificateDocumentpath];
    var tempData = CertificateDocumentpath[i];
    tempData.FileName = event.target.value;
    setUserDcoumnetName(event.target.value);
  };
  const CertificatesetFileDocument = (event) => {
    setDocumentFileError("");
    // let temp = [...CertificateDocumentpath];
    let temp = [];
    let tempDocumnetFile = DocumentFile;
    let selectedFile = event.target.files;
    for (let index = 0; index < selectedFile.length; index++) {
      let typeobj = selectedFile[index].type;
      if (typeobj === "application/pdf") {
        const element = URL.createObjectURL(selectedFile[index]);
        let dt = {
          _id: "",
          FileUrl: element,
          FileName: selectedFile[index].name,
        };
        setUserDcoumnetName(selectedFile[index].name);
        temp.push(dt);
        tempDocumnetFile.push(selectedFile[index]);
      }
    }
    setCertificateDocumentpath(temp);
    setDocumentFile(tempDocumnetFile);
  };
  const onChangeCertificateName = (event) => {
    setCertificateNameError("");
    setCertificateName(event.target.value);
  };
  const onChangeWebsiteName = (event) => {
    setCertificateWebsiteError("");
    setCertificateWebsite(event.target.value);
  };
  const downloadDocumentData = (filename, myUrl) => {
    window.open(filename, "_blank");
  };
  const ondeleteDocumentFile = (FileID, i) => {
    let temp = [...CertificateDocumentpath];
    temp.splice(i, 1);
    setCertificateDocumentpath(temp);
  };
  const IsCertificateshandleSubmit = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    setIsCertificateDisplay(e.target.checked);
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "certificate" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          // if (resp === false) {
          //     setIsCertificateDisplay(!e.target.checked);
          // }
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsCertificateDisplay(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    } else {
      var data = {
        _id: ArticleID,
        ArticleName: ArticleName,
        IsProduct: true,
        ArticleNumber: ArticleNumber,
        UserCompanyID: loginid,
      };

      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            if (resp._id != null && resp._id != undefined && resp._id != "") {
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              fetch(
                Config.apiUrl +
                "ArticleProduct/UpdatePublish?id=" +
                resp._id +
                "&type=" +
                "certificate" +
                "&isPublish=" +
                e.target.checked,
                {
                  method: "GET",
                  headers: {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    userCompanyID: loginid,
                    Authorization: "Bearer " + Auth0token,
                  },
                }
              ).then((result) => {
                result.json().then((resp) => {
                  // if (resp === false) {
                  //     setIsCertificateDisplay(!e.target.checked);
                  // }
                  if (resp === true) {
                    swal("Congratulations ! update successfully.", {
                      icon: "success",
                    });
                  } else {
                    setIsCertificateDisplay(!e.target.checked);
                    swal("Sorry!", "Not update.", "error");
                  }
                });
              });
            }
          } else {
            swal("Sorry!", "Article  Certificate are  not Updated.", "error");
          }
        });
      });
    }
  };
  const fileUploadCrrtificatLogoPost = (IDObj) => {
    if (IDObj != "") {
      if (
        CertificateLogoFile != "" ||
        CertificateLogoFile != null ||
        CertificateLogoFile.length > 0
      ) {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        let UserCompanyId = localStorage.getItem("UserCompanyId");

        const byte = CertificateLogoFile.size;
        fetch(
          Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1 === true || resp1 === "true") {
              const formData = new FormData();
              formData.append("body", CertificateLogoFile);
              formData.append("fileType", "certificatelogo");
              formData.append("targetId", IDObj);
              formData.append("externalLink", "");
              formData.append("displayOrder", "0");
              fetch(Config.apiUrl + "FileUpload/Create", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "POST",
                body: formData,
              }).then((result) => {
                result.json().then((resp) => {
                  fileUploadCertificatPost(IDObj);
                });
              });
            } else if (resp1 === false || resp1 === "false") {
              swal("oops!", "You not allow add Image", "warning");
            } else {
              alert(resp1);
            }
          });
      } else {
        fileUploadCertificatPost(IDObj);
      }
    }
  };
  const fileUploadCertificatPost = (IDObj) => {
    if (IDObj != "") {
      if (
        DocumentFile != "" ||
        DocumentFile != null ||
        DocumentFile.length > 0
      ) {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        let UserCompanyId = localStorage.getItem("UserCompanyId");
        const byte =
          DocumentFile.map((item) => item.size || 0).reduce(
            (prev, curr) => prev + curr,
            0
          ) || 0;
        fetch(
          Config.apiUrl +
          "UserPackageFeature/CheckStorageLimit?UserCompanyId=" +
          UserCompanyId +
          "&UserFileSize=" +
          byte,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        )
          .then((response) => {
            if (response.ok) {
              return response.json();
            }
            throw new Error("Something went wrong");
          })
          .then((resp1) => {
            if (resp1 === true || resp1 === "true") {
              const formDataNew = new FormData();
              formDataNew.append("body", DocumentFile[0]);
              formDataNew.append("fileType", "certificate");
              formDataNew.append("targetId", IDObj);
              formDataNew.append("externalLink", "");
              formDataNew.append("displayOrder", "0");
              fetch(Config.apiUrl + "FileUpload/Create", {
                headers: {
                  userCompanyID: loginid,
                  Authorization: "Bearer " + Auth0token,
                },
                method: "POST",
                body: formDataNew,
              }).then((result) => {
                result.json().then((resp) => {
                  Certificateclerefrom();
                  getAllCertificateList(ArticleID);
                });
              });
            } else if (resp1 === false || resp1 === "false") {
              swal("oops!", "You not allow add Image", "warning");
            } else {
              alert(resp1);
            }
          });
      } else {
        Certificateclerefrom();
        getAllCertificateList(ArticleID);
      }
    }
  };
  const createDocument = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      CertificateName === null ||
      CertificateName === undefined ||
      CertificateName === ""
    ) {
      retval = false;
      setCertificateNameError("Certificate Name must be filled out");
    }
    // if (CertificateWebsite === null || CertificateWebsite === undefined || CertificateWebsite === '') {
    //     retval = false;
    //     setCertificateWebsiteError('Website must be filled out')
    // }
    // if (CertificateLogoFile === '' || CertificateLogoFile === null || CertificateLogoFile.length === 0) {
    //     retval = false;
    //     setCertificateLogoFileError("Logo File must be secleted any One");
    // }
    // if (DocumentFile.length === 0) {
    //     retval = false;
    //     setDocumentFileError("Document  File must be secleted One or more");
    // }
    let DataObj = {
      Name: CertificateName,
      Website: CertificateWebsite,
      UserCompanyID: loginid,
    };
    if (retval === true) {
      fetch(
        Config.apiUrl +
        "Certificate/CheckCertificate?id=" +
        "" +
        "&certificateName=" +
        CertificateName,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => {
          if (result === false) {
            fetch(Config.apiUrl + "Certificate/Create", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
              body: JSON.stringify(DataObj),
            }).then((result) => {
              result.json().then((resp) => {
                if (resp != null) {
                  fileUploadCrrtificatLogoPost(resp._id);
                  toggleSignupAdd();
                  swal("Saved", "Certificate is saved.", "success");
                } else {
                  swal("Sorry!", "Certificate is not saved.", "error");
                }
              });
            });
          } else {
            swal("Your Category name already exists !");
          }
        });
      });
    }
  };

  const isCertificateselectupdate = (itemObj) => {
    let certificateListTemp = [...CertificateList];
    if (certificateListTemp.length > 0) {
      certificateListTemp.map((item) => {
        if (item._id === itemObj._id) {
          if (item.isCertificateselect != true) {
            item.isCertificateselect = true;
          } else {
            item.isCertificateselect = false;
          }
        }
      });
      setCertificateList(certificateListTemp);
    }
  };

  const UpdateArticleCertificate = () => {
    if (CertificateList.length > 0) {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let certificateIdList = [];
      setCertificatesisloding(true);
      CertificateList.map((item) => {
        if (item.isCertificateselect === true) {
          certificateIdList.push(item._id);
        }
      });
      var data = {
        _id: ArticleID,
        ArticleName: ArticleName,
        IsProduct: true,
        ArticleNumber: ArticleNumber,
        UserCompanyID: loginid,
      };
      if (ArticleID === null || ArticleID === "" || ArticleID === undefined) {
        fetch(Config.apiUrl + "ArticleProduct/Create", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          body: JSON.stringify(data),
        }).then((result) => {
          result.json().then((resp) => {
            if (resp != null) {
              if (resp._id != null && resp._id != undefined && resp._id != "") {
                CretaeFixSegmentName(resp._id);
                setArticleID(resp._id);
                let ArticleCertificateData = {
                  articleId: resp._id,
                  fileType: "ArticleProductCertificate",
                  certificateId: certificateIdList,
                  userCompanyID: loginid,
                };
                fetch(Config.apiUrl + "FileUpload/UpdateArticleCertificate", {
                  headers: {
                    userCompanyID: loginid,
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + Auth0token,
                  },
                  method: "POST",
                  body: JSON.stringify(ArticleCertificateData),
                })
                  .then((result1) => {
                    result1.json().then((resp1) => {
                      getAllCertificateList(resp._id);
                      setCertificatesisloding(false);
                      swal(
                        "Update",
                        "Article  Certificate are Updated.",
                        "success"
                      );
                    });
                  })
                  .catch((error) => {
                    setCertificatesisloding(false);
                    console.log(error);
                  });
              }
            } else {
              setCertificatesisloding(false);
              swal("Sorry!", "Article  Certificate are  not Updated.", "error");
            }
          });
        });
      } else {
        let ArticleCertificateData = {
          articleId: ArticleID,
          fileType: "ArticleProductCertificate",
          certificateId: certificateIdList,
          userCompanyID: loginid,
        };
        fetch(Config.apiUrl + "FileUpload/UpdateArticleCertificate", {
          headers: {
            userCompanyID: loginid,
            "Content-Type": "application/json",
            Authorization: "Bearer " + Auth0token,
          },
          method: "POST",
          body: JSON.stringify(ArticleCertificateData),
        })
          .then((result) => {
            result.json().then((resp) => {
              setCertificatesisloding(false);
              getAllCertificateList(ArticleID);
              swal("Update", "Article  Certificate are Updated.", "success");
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };
  const DeleteSizeTable = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        if (SizeTabel === null || SizeTabel === "" || SizeTabel === undefined) {
          fetch(
            Config.apiUrl +
            "FileUpload/DeleteSizeTable?id=" +
            ArticleID +
            "&fileType=" +
            "sizetable",
            {
              method: "DELETE",
              headers: {
                "Content-Type": "application/json",
                userCompanyID: loginid,
                Authorization: "Bearer " + Auth0token,
              },
            }
          ).then((result) => {
            result.json().then((resp) => {
              if (resp === true) {
                setSizeTabel("");
                setSizetablefilePath("");
                swal("Congratulations! Your data deleted successfully.", {
                  icon: "success",
                });
              } else {
                swal("Your Size Images is safe!");
              }
            });
          });
        } else {
          setSizeTabel("");
          setSizetablefilePath("");
          document.getElementById("mysizetable").value = "";
          getArticleSizeImage(ArticleID);
        }
      }
    });
  };

  const getAllCountryDropdownlist = () => {
    let Auth0token = localStorage.getItem("Auth0token");
    fetch(
      Config.apiUrl + "GenericListing/DropdownList?categoryName=" + "Country",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Auth0token,
        },
      }
    ).then((resp1) => {
      resp1.json().then((result) => {
        setCountrydetailList(result);
      });
    });
  };

  const fileUploadVendorsLogoPost = (IDObj) => {
    if (IDObj != "") {
      if (
        VendorsLogoFile != "" ||
        VendorsLogoFile != null ||
        VendorsLogoFile.length > 0
      ) {
        let loginid = localStorage.getItem("loginUserID");
        let Auth0token = localStorage.getItem("Auth0token");
        const formData = new FormData();
        formData.append("body", VendorsLogoFile);
        formData.append("fileType", "vendor");
        formData.append("targetId", IDObj);
        formData.append("externalLink", "");
        formData.append("displayOrder", "0");
        fetch(Config.apiUrl + "FileUpload/Create", {
          headers: {
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
          method: "POST",
          body: formData,
        }).then((result) => {
          result.json().then((resp) => {
            GetAllvendor();
          });
        });
      } else {
        GetAllvendor();
      }
    } else {
      GetAllvendor();
    }
  };
  const CreateUserProfileVendors = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let retval = true;
    if (
      VendorsName === null ||
      VendorsName === undefined ||
      VendorsName === ""
    ) {
      retval = false;
      setVendorsNameError("Name must be filled out");
    }
    // if (VendorsLogoFile === '' || VendorsLogoFile === null || VendorsLogoFile.length === 0) {
    //     retval = false;
    //     setVendorsLogoError("Logo File must be secleted any One");
    // }
    // if (Email === null || Email === undefined || Email === '') {
    //     retval = false;
    //     setEmailError('Email must be filled out');
    // }
    // else {
    //     var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    //     var test = mailformat.test(Email)
    //     if (test === false) {
    //         retval = false;
    //         setEmailError('Enter Valid Email')
    //     }

    // }
    if (Email?.length > 0) {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      var test = mailformat.test(Email);
      if (test === false) {
        retval = false;
        setEmailError("Enter Valid Email");
      }
    }
    // if (ContactNo === null || ContactNo === undefined || ContactNo === '') {
    //     retval = false;
    //     setContactNoError('Contact No must be filled out');
    // }
    // else {
    //     var Numbercheck = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    //     var test = Numbercheck.test(ContactNo)
    //     if (test === false) {
    //         retval = false;
    //         setContactNoError('Enter Valid Contact No')
    //     }
    // }
    // if (ContactNo?.length > 0) {
    //   var Numbercheck = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    //   var test = Numbercheck.test(ContactNo);
    //   if (test === false) {
    //     retval = false;
    //     setContactNoError("Enter Valid Contact No");
    //   }
    // }
    // if (VendorStreet === null || VendorStreet === undefined || VendorStreet === '') {
    //     retval = false;
    //     setVendorStreetError('Street must be filled out');
    // }

    // if (HouseNo === null || HouseNo === undefined || HouseNo === '') {
    //     retval = false;
    //     setHouseNoError('House No must be filled out');
    // }
    // if (Postcode === null || Postcode === undefined || Postcode === '') {
    //     retval = false;
    //     setPostcodeError('Postcode  must be filled out');
    // }
    // if (City === null || City === undefined || City === '') {
    //     retval = false;
    //     setCityError('City  must be filled out');
    // }
    // if (CountryId === null || CountryId === undefined || CountryId === '') {
    //     retval = false;
    //     setCountryIdError('pleace Select Country');
    // }
    // if (VendorsDescription === null || VendorsDescription === undefined || VendorsDescription === '') {
    //     retval = false;
    //     setVendorsDescriptionError('Description must be filled out');
    // }
    // if (vendorWebsite === null || vendorWebsite === undefined || vendorWebsite === '') {
    //     retval = false;
    //     setvendorWebsiteError('Website must be filled out');
    // }
    // else {
    //     var re = /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
    //     var test = re.test(vendorWebsite)
    //     if (test === false) {
    //         retval = false;
    //         setvendorWebsiteError('Enter Valid Website')
    //     }
    // }
    if (vendorWebsite?.length > 0) {
      var re =
        /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/;
      var test = re.test(vendorWebsite);
      if (test === false) {
        retval = false;
        setvendorWebsiteError("Enter Valid Website");
      }
    }

    let DataObj = {
      Name: VendorsName,
      UserCompanyID: loginid,
      Email: Email,
      ContactNumber: ContactNo,
      Street: VendorStreet,
      HouseNumber: HouseNo,
      PostCode: Postcode,
      City: City,
      Country: CountryId,
      Description: VendorsDescription,
      Website: vendorWebsite,
    };
    if (retval === true) {
      fetch(Config.apiUrl + "Vendor/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(DataObj),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            if (resp._id !== null && resp._id !== "") {
              fileUploadVendorsLogoPost(resp._id);
              DiscardUserProfileVendors();
              swal("Saved", "Vendor is saved.", "success");
            } else {
              swal("Sorry!", "Vendor is not saved.", "error");
            }
          } else {
            swal("Sorry!", "Vendor is not saved.", "error");
          }
        });
      });
    }
  };
  const createyouTubeVideoLink = () => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let IsValid = true;
    if (
      youTubleVideoLink === "" ||
      youTubleVideoLink === undefined ||
      youTubleVideoLink === null
    ) {
      IsValid = false;
      setWebLinkError("youTubleVideoLink must be filled out");
      return;
    }
    if (IsValid === true) {
      setIsloading(true);
      var data = {
        //_id: this.state._id,
        // Name: websitelinkname,
        fileType: "articlesegmentvideo",
        UserCompanyID: loginid,
        youTubeLinkList: youTubleVideoLink,
        targetID: ArticleSegmentID,
      };
      fetch(Config.apiUrl + "FileUpload/SaveYouTubeLink", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            ArticleSegmentgetbyId(ArticleSegmentID);
            setyouTubleVideoLink("");
            // setwebsitelinkname('')
            swal("Saved", "Article's WebLink details are saved.", "success");
          } else
            swal("Sorry!", "Article's WebLink details are not saved.", "error");
        });
      });
    } else {
      setIsloading(false);
    }
  };
  const DiscardUserProfileVendors = () => {
    clereVendor();
    setmodalvendor(!modalvendor);
  };
  const clereVendor = () => {
    setVendorsName("");
    setVendorsLogoPath("");
    setVendorsNameError("");
    setVendorsLogoError("");
    setVendorsLogoFile([]);
    setVendorsLogoError("");
    setEmail("");
    setEmailError("");
    setContactNo("");
    setContactNoError("");
    setVendorStreet("");
    setVendorStreetError("");
    setHouseNoError("");
    setHouseNo("");
    setPostcode("");
    setPostcodeError("");
    setCity("");
    setCityError("");
    setCountryId("");
    setCountryIdError("");
    setVendorsDescription("");
    setVendorsDescriptionError("");
    setvendorWebsiteError("");
    setVendorID("");
  };
  const onchangeManufactureDate = (date) => {
    if (date !== null && date !== "" && date !== undefined) {
      let Finaldate = Moment(date).format("YYYY-MM-DD");
      setManufactureDateFinal(Finaldate);
      setManufactureDate(date);
    } else {
      setManufactureDateFinal(null);
      setManufactureDate(null);
    }
  };
  const onchangeExpiryDate = (date) => {
    setExpiryDate(date);
    if (date !== null && date !== "" && date !== undefined) {
      let Finaldate = Moment(date).format("YYYY-MM-DD");
      setExpiryDateFinal(Finaldate);
    } else {
      setExpiryDateFinal(null);
    }
  };

  const onchangeVendor = (event) => {
    setVendorID(event.target.value);
    // setQrcodeQty(0)
    // setDuplicateQrcodeList("")
  };
  const onchangeCombinationQrcode = (event) => {
    setselectCombinationID(event.target.value);
  };
  const printQrcode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, ArticleName);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };
  const onchangeselectBatchnumber = (event) => {
    setBatchnumber(event.target.value);
    // setQrcodeQty(0)
    // setDuplicateQrcodeList("")
    setselectBatchNumbername(event.target.value);
  };
  const printQrcodeArticle = () => {
    const qrCodeURL = document
      .getElementById("ArticleqrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    var doc = new jsPDF("p", "pt", "A4");
    doc.setFontSize(22);
    doc.text(20, 30, ArticleName);
    doc.setFontSize(10);
    // doc.text(20, 80, "Title: " + row.title);
    // doc.text(20, 100, "Years: " + row.years);
    doc.addImage(qrCodeURL, "JPEG", 100, 100, 200, 200);
    //doc.save("QrCode.pdf");
    doc.autoPrint();
    doc.output("dataurlnewwindow");
  };
  const downloadQRCodeArticle = () => {
    // const qrCodeURL = document.getElementById('ArticleqrCodeEl')
    //     .toDataURL("image/png")
    //     .replace("image/png", "image/octet-stream");
    // var doc = new jsPDF("p", "pt", "c6");
    // doc.setFontSize(22);
    // doc.text(20, 30, "Qr Code");
    // doc.setFontSize(10);
    // // doc.text(20, 80, "Title: " + row.title);
    // // doc.text(20, 100, "Years: " + row.years);
    // doc.addImage(qrCodeURL, "JPEG", 100, 100, 50, 50);
    // doc.save("QrCode.pdf");
    const qrCodeURL = document
      .getElementById("ArticleqrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    // console.log(qrCodeURL)
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };
  const downloadQRCode = () => {
    const qrCodeURL = document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    // console.log(qrCodeURL)
    let aEl = document.createElement("a");
    aEl.href = qrCodeURL;
    aEl.download = "QR_Code.png";
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);
  };

  const OnchangedQrCodeQty = (e) => {
    // if (
    //   e.target.value !== null &&
    //   e.target.value !== "" &&
    //   e.target.value !== undefined
    // ) {
    //   setQrcodeQty(e.target.value);
    // } else {
    //   setQrcodeQty(0);
    // }
    setQrcodeQty(e.target.value);
  };
  const DuplicateQrcodeCreate = () => {
    if (
      QrcodeQty > 0 &&
      QrCodeID !== null &&
      QrCodeID !== undefined &&
      QrCodeID !== ""
    ) {
      let UserCompanyId = localStorage.getItem("UserCompanyId");
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      fetch(
        Config.apiUrl +
        "QrCodeResourceController/UpdateQrCodeResourceBulkQrCodeQuantity?id=" +
        QrCodeID +
        "&bulkQrCodeQuantity=" +
        QrcodeQty +
        "&userCompanyID=" +
        UserCompanyId,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((resp1) => {
        resp1.json().then((result) => { });
      });
      if (
        selectCombinationID != "" &&
        selectCombinationID != undefined &&
        selectCombinationID != null
        // ||
        // (VendorID != '' &&
        //     VendorID != undefined &&
        //     VendorID != null) ||
        // (BatchNumber != '' &&
        //     BatchNumber != undefined &&
        //     BatchNumber != null) ||
        // (ManufactureDate !== null &&
        //     ManufactureDate !== '' &&
        //     ManufactureDate !== undefined)
      ) {
        if (
          QrCodeString !== "" &&
          QrCodeString !== undefined &&
          QrCodeString !== null
        ) {
          let Qrcodestringtemp = [];
          for (let index = 0; index < Math.ceil(QrcodeQty); index++) {
            Qrcodestringtemp.push(QrCodeString);
          }
          setDuplicateQrcodeList(Qrcodestringtemp);
        } else {
          swal("Sorry!", "pleace create Qrcode", "error");
        }
      } else {
        if (
          QrCodeStringArticle !== "" &&
          QrCodeStringArticle !== undefined &&
          QrCodeStringArticle !== null
        ) {
          let Qrcodestringtemp = [];
          for (let index = 0; index < Math.ceil(QrcodeQty); index++) {
            Qrcodestringtemp.push(QrCodeStringArticle);
          }
          setDuplicateQrcodeList(Qrcodestringtemp);
        } else {
          swal("Sorry!", "pleace create Qrcode", "error");
        }
      }
    }
  };
  const downloadQRDuplicate = () => {
    if (DuplicateQrcodeList.length > 0) {
      let totalqrcodePDf = [];
      for (let index = 0; index < DuplicateQrcodeList.length; index++) {
        const element = DuplicateQrcodeList[index];
        const qrCodeURL = document
          .getElementById("qrCodeElDuplicate" + index)
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        totalqrcodePDf.push(qrCodeURL);
      }

      var doc = new jsPDF();
      doc.text(20, 30, ArticleName);
      let noofpage = Math.ceil(totalqrcodePDf.length / 12);
      let pagenum = 1;
      let rownumber = 1;
      let posisionnumber = 1;
      doc.text(20, 10, ArticleName);
      for (let index = 0; index < totalqrcodePDf.length; index++) {
        const element = totalqrcodePDf[index];
        if (rownumber === 1) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 20, 50, 50, "FD");

            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 20, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 20, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 2;
          }
        } else if (rownumber === 2) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 80, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 80, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 80, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 3;
          }
        } else if (rownumber === 3) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 140, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 140, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 140, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 4;
          }
        } else if (rownumber === 4) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 200, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 200, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 200, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 1;
            if (pagenum < noofpage) {
              doc.addPage();
              pagenum = pagenum + 1;
            }
          }
        }
      }
      // doc.output('dataurlnewwindow');
      doc.save("QrCode" + new Date().getTime() + ".pdf");

      // var doc = new jsPDF("p", "pt", "A4");
      // doc.setFontSize(22);
      // doc.text(20, 30, ArticleName);
      // doc.setFontSize(10);
      // // doc.text(20, 80, "Title: " + row.title);
      // // doc.text(20, 100, "Years: " + row.years);
      // for (let index = 0; index < totalqrcodePDf.length; index++) {
      //     const element = totalqrcodePDf[index];
      //     doc.addImage(element, "JPEG", 140, 110, 90, 90, 'SLOW');
      // }
      // //doc.save("QrCode.pdf");
      // doc.save("QrCode.pdf");
    }
  };

  const printQRDuplicate = () => {
    if (DuplicateQrcodeList.length > 0) {
      let totalqrcodePDf = [];
      for (let index = 0; index < DuplicateQrcodeList.length; index++) {
        const element = DuplicateQrcodeList[index];
        const qrCodeURL = document
          .getElementById("qrCodeElDuplicate" + index)
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        totalqrcodePDf.push(qrCodeURL);
      }
      var doc = new jsPDF();
      doc.text(20, 30, ArticleName);
      let noofpage = Math.ceil(totalqrcodePDf.length / 12);
      let pagenum = 1;
      let rownumber = 1;
      let posisionnumber = 1;
      doc.text(20, 10, ArticleName);
      for (let index = 0; index < totalqrcodePDf.length; index++) {
        const element = totalqrcodePDf[index];
        if (rownumber === 1) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 20, 50, 50, "FD");

            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 20, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 20, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 2;
          }
        } else if (rownumber === 2) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 80, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 80, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 80, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 3;
          }
        } else if (rownumber === 3) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 140, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 140, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 140, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 4;
          }
        } else if (rownumber === 4) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 200, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 200, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 200, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 1;
            if (pagenum < noofpage) {
              doc.addPage();
              pagenum = pagenum + 1;
            }
          }
        }
      }
      // doc.output('dataurlnewwindow');
      window.open(doc.output("bloburl"));
      doc.autoPrint();
      doc.close();
      // doc.save('Test.pdf');
      // // doc.setFontSize(10);
      // // doc.text(20, 80, "Title: " + row.title);
      // // doc.text(20, 100, "Years: " + row.years);
      // // doc.text(20, 30, ArticleName);

      // var doc = new jsPDF("p", "pt", "A4");
      // doc.setFontSize(22);
      // let pageHeight = doc.internal.pageSize.height;
      // let y = 500
      // for (let index = 0; index < totalqrcodePDf.length; index++) {
      //     const element = totalqrcodePDf[index];
      //     doc.text(20, 30, ArticleName);
      //     doc.addImage(element, "JPEG", 140, 110, 90, 90, 'SLOW');
      //     // doc.addImage(element, "JPEG", 140, 15, 90, 90, "alias1", 'SLOW');
      //     // doc.addImage(element, "JPEG", 100, 100, 50, 50);
      //     //  doc.addPage();
      // }

      // doc.output('dataurlnewwindow');
      // doc.autoPrint();
    }
  };
  const onchangeBatchnumber = (event) => {
    setBatchnumber(event.target.value);
    setBatchNumberError("");
  };

  const IsArticlechathandleSubmit = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      setIsArticlechat(e.target.checked);
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "articlechat" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsArticlechat(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    } else {
      var data = {
        _id: ArticleID,
        ArticleName: ArticleName,
        IsProduct: true,
        isArticleChatDisplay: e.target.checked,
        ArticleNumber: ArticleNumber,
        UserCompanyID: loginid,
      };
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            if (resp._id != null && resp._id != undefined && resp._id != "") {
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              swal("Congratulations ! update successfully.", {
                icon: "success",
              });
            }
          } else {
            swal("Sorry ! Not update successfully.", {
              icon: "error",
            });
          }
        });
      });
    }
  };
  const IsrelatedproducthandleSubmit = (e) => {
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    if (ArticleID != null && ArticleID != "" && ArticleID != undefined) {
      setIsrelatedproduct(e.target.checked);
      fetch(
        Config.apiUrl +
        "ArticleProduct/UpdatePublish?id=" +
        ArticleID +
        "&type=" +
        "relatedproduct" +
        "&isPublish=" +
        e.target.checked,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      ).then((result) => {
        result.json().then((resp) => {
          if (resp === true) {
            swal("Congratulations ! update successfully.", {
              icon: "success",
            });
          } else {
            setIsrelatedproduct(!e.target.checked);
            swal("Sorry!", "Not update.", "error");
          }
        });
      });
    } else {
      var data = {
        _id: ArticleID,
        ArticleName: ArticleName,
        IsProduct: true,
        IsRelatedProductDisplay: e.target.checked,
        ArticleNumber: ArticleNumber,
        UserCompanyID: loginid,
      };
      fetch(Config.apiUrl + "ArticleProduct/Create", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(data),
      }).then((result) => {
        result.json().then((resp) => {
          if (resp != null) {
            if (resp._id != null && resp._id != undefined && resp._id != "") {
              CretaeFixSegmentName(resp._id);
              setArticleID(resp._id);
              swal("Congratulations ! update successfully.", {
                icon: "success",
              });
            }
          } else {
            swal("Sorry ! Not update successfully.", {
              icon: "error",
            });
          }
        });
      });
    }
  };
  const toggleToEmailAttributecreate = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamilAttribute(!isToEamilAttribute);
  };
  const toggleToEmail = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisToEamil(!isToEamil);
  };
  const SubToEmailremoveClick = (i) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToEmailTemp = [...subToEmail];
    if (subToEmailTemp != null && subToEmailTemp !== undefined) {
      subToEmailTemp.splice(i, 1);
    }
    setsubToEmail(subToEmailTemp);
  };
  const SubToEmailhandleChange = (i) => (event) => {
    setToemailEmptyError("");
    setisToemailMaltiple(false);
    let subToemaillistnewTemp = [...subToEmail];
    subToemaillistnewTemp[i] = event.target.value;
    setsubToEmail(subToemaillistnewTemp);
    const unique = [...new Set(subToemaillistnewTemp)];
    if (subToemaillistnewTemp.length !== unique.length) {
      setisToemailMaltiple(true);
    }
  };
  const SubToEmailaddClick = () => {
    setsubToEmail((n) => [...n, ""]);
  };

  const createSubToEmailUI = () => {
    return subToEmail.map((el, i) => (
      <div key={i} className="removeSection">
        <input
          type="text"
          className="form-control mr-2"
          //maxlength="50"
          placeholder="Enter To Email"
          value={el || ""}
          onChange={SubToEmailhandleChange(i)}
        />
        {i > 0 ? (
          <a
            href="javascript:void(0)"
            onClick={(e) => {
              SubToEmailremoveClick(i);
            }}
            className="btn btn-danger"
          >
            <i class="fas fa-trash"></i>
          </a>
        ) : (
          <></>
        )}
      </div>
    ));
  };
  const QRCodeArticleSend = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }
    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("ArticleqrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: ArticleName,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        // console.log("123=====>", resp1)
        if (resp1 === true) {
          toggleToEmail();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };

  const QRCodeArticleSendAttributecreate = async (e) => {
    const unique = [...new Set(subToEmail)];
    if (subToEmail.length !== unique.length) {
      setisToemailMaltiple(true);
      return;
    }

    const found = subToEmail.find(
      (element) => element === "" || element === "" || element === null
    );
    if (found != undefined) {
      setToemailEmptyError("All filled is required");
      return;
    }
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    const qrCodeURL = await document
      .getElementById("qrCodeEl")
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let filelist = [];
    let filedata = {
      path: "png",
      sourceURL: "png",
      data: qrCodeURL,
    };
    filelist.push(filedata);
    // let Toemail = [];
    // Toemail.push("rprajapati@eagletechsolutions.uk")

    let ContactHelpModel = {
      UserCompanyID: loginid,
      name: ".png",
      // "To": "rprajapati@eagletechsolutions.uk",
      subject: "Qrcode",
      body: ArticleName,
      attachFileList: filelist,
      ToEmailList: subToEmail,
    };
    fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userCompanyID: loginid,
        Authorization: "Bearer " + Auth0token,
      },
      body: JSON.stringify(ContactHelpModel),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then((resp1) => {
        // console.log("123=====>", resp1)
        if (resp1 === true) {
          toggleToEmailAttributecreate();
          swal("Thank You", "Successfully  send email", "success");
        } else {
          swal("Sorry", "Pleace  Contact Admin.", "error");
        }
      });
  };

  const toggleDuplicateSendEmail = () => {
    setisToemailMaltiple(false);
    setToemailEmptyError("");
    setsubToEmail([""]);
    setisDuplicateToEamil(!isDuplicateToEamil);
  };
  const sendpdfEmail = async () => {
    if (DuplicateQrcodeList.length > 0) {
      let totalqrcodePDf = [];
      for (let index = 0; index < DuplicateQrcodeList.length; index++) {
        const element = DuplicateQrcodeList[index];
        const qrCodeURL = document
          .getElementById("qrCodeElDuplicate" + index)
          .toDataURL("image/png")
          .replace("image/png", "image/octet-stream");
        totalqrcodePDf.push(qrCodeURL);
      }

      var doc = new jsPDF();
      doc.text(20, 30, ArticleName);
      let noofpage = Math.ceil(totalqrcodePDf.length / 12);
      let pagenum = 1;
      let rownumber = 1;
      let posisionnumber = 1;
      doc.text(20, 10, ArticleName);
      for (let index = 0; index < totalqrcodePDf.length; index++) {
        const element = totalqrcodePDf[index];
        if (rownumber === 1) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 20, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 20, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 20, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 2;
          }
        } else if (rownumber === 2) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 80, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 80, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 80, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 3;
          }
        } else if (rownumber === 3) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 140, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 140, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 140, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 4;
          }
        } else if (rownumber === 4) {
          if (posisionnumber === 1) {
            doc.addImage(element, "JPEG", 20, 200, 50, 50, "FD");
            posisionnumber = 2;
          } else if (posisionnumber === 2) {
            doc.addImage(element, "JPEG", 80, 200, 50, 50, "FD");
            posisionnumber = 3;
          } else if (posisionnumber === 3) {
            doc.addImage(element, "JPEG", 140, 200, 50, 50, "FD");
            posisionnumber = 1;
            rownumber = 1;
            if (pagenum < noofpage) {
              doc.addPage();
              pagenum = pagenum + 1;
            }
          }
        }
      }
      let file = await doc.output();
      let url = "data:application/pdf;base64," + (await btoa(file));
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      let filelist = [];
      let filedata = {
        path: "pdf",
        sourceURL: "pdf",
        data: url,
      };
      filelist.push(filedata);

      let ContactHelpModel = {
        UserCompanyID: loginid,
        name: ".pdf",
        subject: "Qrcode",
        body: ArticleName,
        attachFileList: filelist,
        ToEmailList: subToEmail,
      };
      fetch(Config.apiUrl + "EmailQueue/SendMailOfQrcodesend?ispdf=true", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          Authorization: "Bearer " + Auth0token,
        },
        body: JSON.stringify(ContactHelpModel),
      })
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((resp1) => {
          // console.log("123=====>", resp1)
          if (resp1 === true) {
            toggleDuplicateSendEmail();
            swal("Thank You", "Successfully  send email", "success");
          } else {
            swal("Sorry", "Pleace  Contact Admin.", "error");
          }
        });
    }
  };

  return (
    <>
      <div>
        <LoaderSpinner isrefresh={isrefresh} />

        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/home">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/productqrcode">Production QR Code </Link>
          </li>
          <li className="breadcrumb-item active">Add New Product</li>
        </ol>

        <h1 className="page-header">Add New Production</h1>

        <Panel>
          <PanelHeader>
            <h4 className="mb-0 text-light">Select Article</h4>
          </PanelHeader>
          <PanelBody>
            <div className="form-group row m-b-15 align-items-center">
              <label className="col-xxl-3 col-lg-4 col-form-label">
                Select Article for product data retrieval
              </label>
              <div className="searchForm col-xxl-4 col-lg-5">
                <form>
                  <TextareaAutosize
                    maxLength={90}
                    className="form-control"
                    placeholder="Select Article"
                    value={ArticleNumber}
                    onChange={(e) => {
                      ArticlenumberhandleInputChange(e);
                    }}
                    disabled={isArticleDisable == true ? "disabled" : ""}
                  />
                </form>
                {searchArticlenumber.length > 0 ? (
                  <div className="SearchFilterDiv">
                    {searchArticlenumber.map((i) => (
                      <p
                        onClick={() => {
                          ArticleProductCreate(i._id);
                        }}
                      >
                        {i.articleNumber}
                      </p>
                    ))}
                  </div>
                ) : (
                  <></>
                )}
              </div>
              <div className="col-xxl-4 col-lg-3 mt-md-0 mt-2">
                {/* <button type="button" onClick={() => { OnsearchArticlenumber() }} className="btn  btn-primary m-r-5 shadow-add">Go</button> */}

                {/* <Link to="addnewarticle" params={{ EditArticleDetailsID: '' }} type="button" className="btns btn btn-primary search-btn  mr-2 mb-1 ">
                                <i class='fas fa-lg fa-fw m-r-5 fa-plus-square icon'></i>
                                Add new Articels
                            </Link> */}
                {/* <button className="btns btn btn-primary shadow-add  mr-2 mb-1" onClick={(e) => { AddArticleDetails('') }}>
                                    Go
                                </button> */}
                {/* <button className="btns btn btn-purple shadow-add  mr-2 mb-1">
                                        Add new Articels
                                    </button> */}
                {/* <Link to="/article-addnew" params={{ EditArticleDetailsID: '' }} type="button" className="btns btn btn-purple shadow-add  mr-2 mb-1">
                                    <i class='fas fa-lg fa-fw m-r-5 fa-plus-square icon'></i>
                                    Add new Articels
                                </Link> */}
                <button
                  className="btns btn btn-primary shadow-add  mr-2 mb-1 my-2"
                  onClick={(e) => {
                    AddArticleDetails(null);
                  }}
                >
                  Add new Articels
                </button>
              </div>
            </div>
          </PanelBody>
        </Panel>

        <div className="row">
          <div className="col-xl-7 pb-4">
            <Panel className="penal-stretch">
              <PanelHeader>
                <h4 className="mb-0 text-light">Name and category</h4>

                <div className="form-group row m-b-0 mr-3">
                  <div className="col-md-12">
                    <div className="checkbox checkbox-css checkbox-inline pt-0">
                      <input
                        type="checkbox"
                        checked={IsNameAndCatDisplay}
                        onChange={ProductNamecategoryhandleSubmit}
                        id="inlineCssCheckboxc2"
                      />
                      <label htmlFor="inlineCssCheckboxc2">Publish</label>
                    </div>
                  </div>
                </div>
              </PanelHeader>
              <PanelBody>
                <div className="row m-b-10">
                  <div className="col-xl-12">
                    <div>
                      <h5 className="m-b-15">
                        <b>Name</b>
                      </h5>
                    </div>
                    <div className="form-group ">
                      <label htmlFor="exampleInputEmail1 " className="">
                        Product Name
                      </label>
                      <div className="row">
                        {/* <input type="text"
                                                    className="form-control col-xxl-6 col-lg-8 col-md-11 col-xs-10 m-l-10"
                                                    placeholder="Enter Product Name"
                                                    value={ArticleName}
                                                    maxLength={90}
                                                    onChange={(e) => { onChangeProductName(e) }}
                                                /> */}
                        <TextareaAutosize
                          maxLength={90}
                          className="form-control col-xl-6 m-l-10"
                          placeholder="Enter Product Name"
                          value={ArticleName}
                          onChange={(e) => {
                            onChangeProductName(e);
                          }}
                        />
                        <p
                          style={{
                            fontSize: 12,
                            color: "red",
                            marginTop: "7px",
                            marginLeft: "10px",
                          }}
                        >
                          {ArticleName?.length}/90
                        </p>
                      </div>

                      {ArticleNameError.length > 0 ? (
                        <span style={{ color: "red" }}>{ArticleNameError}</span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="row m-b-10">
                  <div className="col-xl-12">
                    <div>
                      <h5 className="m-b-15">
                        <b>Category</b>
                      </h5>
                    </div>
                    <div className="form-group">
                      <label htmlFor="exampleInputPassword1">
                        Product main category
                      </label>
                      <div className="row">
                        <select
                          className="default-select2 form-control col-xl-6 m-l-10"
                          value={CategoryId}
                          onChange={(e) => {
                            onChangeCategory(e);
                          }}
                        >
                          <option value="" selected>
                            --- Select Category ---
                          </option>
                          {CategoryList.map((item) => (
                            <option value={item.value}>{item.text}</option>
                          ))}
                        </select>
                      </div>
                      {CategoryError.length > 0 ? (
                        <span style={{ color: "red" }}>{CategoryError}</span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="form-group ">
                      <label htmlFor="exampleInputPassword1">
                        Product Sub Category
                      </label>
                      <div className="row align-items-center">
                        <select
                          className="default-select2 form-control col-xl-6 col-md-8 col-xs-7 m-l-10"
                          value={SubCategoryId}
                          onChange={(e) => {
                            onChangeSubCategory(e);
                          }}
                        >
                          <option value="0" selected>
                            --- Select Sub Category ---
                          </option>
                          {SubCategoryList.map((item) => (
                            <option value={item.value}>{item.text}</option>
                          ))}
                        </select>
                        <button
                          // onClick={(e) => {
                          //   togglecategoryModal(e);
                          // }}
                          onClick={async (e) => {
                            try {
                              let response =
                                await CheckQRCodeCategoriesManagementEnabled();
                              if (response === true || response === "true") {
                                togglecategoryModal(e);
                              } else {
                                swal(
                                  "oops!",
                                  "Sorry! to increase your qrcode categories management enabled.",
                                  "warning"
                                );
                              }
                            } catch (error) {
                              console.log("error!", error);
                            }
                          }}
                          className="btn btn-sm btn-purple shadow-add m-r-5 m-l-10 form col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-xs-4 my-2"
                        >
                          Add Category
                        </button>
                      </div>
                      {SubCategoryError.length > 0 ? (
                        <span style={{ color: "red" }}>{SubCategoryError}</span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <button
                  type="button"
                  onClick={() => {
                    createArticlesNameAndCategorySection();
                  }}
                  className="btn btn-primary shadow-add m-r-10"
                >
                  Save Changes
                </button>
                {/* <button type="button" className="btn btn-danger shadow-add">Reset</button> */}
              </PanelBody>
            </Panel>
          </div>

          {/* Category-Model */}
          <Modal
            isOpen={categoryModalisOpen}
            toggle={categoryModalisOpen}
            onHide={() => togglecategoryModal()}
          >
            <ModalHeader toggle={togglecategoryModal} className="modalheader ">
              <h4 className="text-white mb-0">Add Category</h4>
            </ModalHeader>
            <ModalBody>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Main Category</label>
                <input
                  type="text"
                  maxlength="30"
                  className="form-control"
                  placeholder="Please Enter Main Category"
                  value={MainCategory}
                  onChange={(e) => {
                    onChangeMaincategory(e);
                  }}
                />
                <p
                  style={{
                    fontSize: 12,
                    color: "red",
                    marginTop: "7px",
                    marginLeft: "10px",
                  }}
                >
                  {MainCategory?.length}/30
                </p>
              </div>
              {MainCategoryError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {MainCategoryError}
                </span>
              )}
              <div className="form-group">
                <form className="row mb-2">
                  <div className="col-md-9">
                    <label htmlFor="exampleInputPassword1" className="mt-2">
                      Sub Category
                    </label>
                  </div>

                  <div className="col-md-3">
                    <input
                      type="button"
                      value="Add more"
                      className="form-control btn btn-info width150"
                      onClick={(e) => {
                        SubCategoryaddClick(e);
                      }}
                    />
                  </div>
                </form>
                <div className="input-group m-b-10">
                  <div className="" style={{ width: "100%" }}>
                    {createSubCategoryUI()}
                  </div>
                  {isSubcategoryMaltiple === true ? (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {"Sub Category name dublicate"}
                    </span>
                  ) : (
                    ""
                  )}
                  {SubCategoryAddtimeError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {SubCategoryAddtimeError}
                    </span>
                  )}
                </div>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  type="button"
                  onClick={() => {
                    createCategory();
                  }}
                  className="btn btn-sm btn-primary m-r-5 shadow-add "
                >
                  Create
                </button>
                <button
                  type="button"
                  onClick={() => {
                    togglecategoryModal();
                  }}
                  className="btn btn-sm btn-danger shadow-add "
                >
                  Cancel
                </button>
              </div>
            </ModalBody>
          </Modal>

          <div className="col-xl-5 pb-4">
            <Panel className="penal-stretch">
              <PanelHeader>
                <h4 className="mb-0 text-light">QR Code management</h4>
              </PanelHeader>
              <PanelBody className="p-0">
                <div className="card border-0 bg-dark  overflow-hidden rounded-0">
                  <div className="card-body">
                    <div className="d-flex justify-content-center">
                      <h3 className="m-b-15 text-white">
                        Create & Share Qr Code
                      </h3>
                    </div>
                    <div className=" row d-flex justify-content-center">
                      <div className="col-md-5 bg-white rounded">
                        <img
                          src="../assets/img/user/QR.png"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-center my-4">
                      <button
                        onClick={(e) => {
                          toggleQrcode();
                        }}
                        type="submit"
                        className="btn btn-primary m-r-5 shadow-add"
                      >
                        Create QR Code
                      </button>
                    </div>
                  </div>
                </div>
              </PanelBody>
            </Panel>
          </div>
        </div>
        <Panel>
          <PanelHeader>
            <h4 className="mb-0 text-light">Product Images</h4>
            <div className="form-group row m-b-0 mr-3">
              <div className="col-md-12">
                <div className="checkbox checkbox-css checkbox-inline pt-0">
                  <input
                    type="checkbox"
                    checked={IsArticleImageDisplay}
                    onChange={(e) => {
                      IsArticleImagehandleSubmit(e);
                    }}
                    id="inlineCssCheckboxb7"
                  />
                  <label htmlFor="inlineCssCheckboxb7">Publish</label>
                </div>
              </div>
            </div>
          </PanelHeader>
          <PanelBody>
            <div>
              <h5 className="m-b-15">Product Images</h5>
            </div>
            <div className="col-md-12 pl-0">
              {ArticlePicsImageList.length > 0 ? (
                <div className="d-flex wrapText">
                  {ArticlePicsImageList.map((subscriber, index) => (
                    <div className="mb-3 ">
                      <div className="posRelative">
                        <img
                          src={Config.contentUrl + subscriber.filePath}
                          className="image-article imageUpload"
                        />
                        <div className="posDelete">
                          <a
                            className="btn btn-danger shadow-add btndelete"
                            onClick={() => ArticleImagedelete(subscriber._id)}
                          >
                            <i class="fas fa-trash"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : null}
            </div>
            <div class="dropzone needsclick overflow-hidden">
              <Dropzone
                // getUploadParams={getUploadArticleImage}
                onChangeStatus={handleChangeArticleImageStatus}
                onSubmit={CreateArticlePics}
                accept="image/*,audio/*,video/*"
                styles={{ dropzone: { overflow: "hidden", border: "none" } }}
                inputContent="Drop files here click to upload"
              />
            </div>
            <div className="mt-3">
              {/* <button type="button" onClick={() => { CreateArticlePics() }} className="btn btn-primary shadow-add m-r-10">Save Changes</button>
                                <button type="button" className="btn btn-danger shadow-add">Reset</button> */}
            </div>
          </PanelBody>
        </Panel>
        <Panel>
          <PanelHeader>
            <h4 className="mb-0 text-light">
              Short Description (Add Text below)
            </h4>
            <div className="form-group row m-b-0 mr-3">
              <div className="col-md-12">
                <div className="checkbox checkbox-css checkbox-inline pt-0">
                  <input
                    type="checkbox"
                    checked={IsArticleshortDescriptionDisplay}
                    onChange={(e) => {
                      IshortDescriptionandleSubmit(e);
                    }}
                    id="inlineCssCheckboxb21"
                  />
                  <label htmlFor="inlineCssCheckboxb21">Publish</label>
                </div>
              </div>
            </div>
          </PanelHeader>
          <PanelBody>
            <div class="panel-body p-0">
              {/* <CKEditor
                id={"shortdec1"}
                editor={ClassicEditor}
                data={ArticleShortDescription}
                config={{
                  ckfinder: {
                    uploadUrl: Config.apiUrl + "UserCompany/upload",
                    //uploadUrl: "https://localhost:44389/api/UserCompany/upload",
                  },
                  mediaEmbed: {
                    previewsInData: true,
                  },
                }}
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  // console.log('Editor is ready to use!', editor);
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  onChangeArticleShortDescription(data);
                  //console.log({ event, editor, data });
                }}
                onBlur={(event, editor) => {
                  // console.log('Blur.', editor);
                }}
                onFocus={(event, editor) => {
                  // console.log('Focus.', editor);
                }}
                style={{ height: 200 }}
              /> */}
              <CKEditor
                editor={Editor}
                config={editorConfiguration}
                data={ArticleShortDescription}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  onChangeArticleShortDescription(data);
                  //console.log({ event, editor, data });
                }}
                onBlur={(event, editor) => {
                  console.log("Blur.", editor);
                }}
                onFocus={(event, editor) => {
                  console.log("Focus.", editor);
                }}
                onReady={(editor) => {
                  editor.ui.getEditableElement().parentElement.insertBefore(
                    editor.ui.view.toolbar.element,
                    editor.ui.getEditableElement()
                  );
                }}

              />
              {ArticleShortDescriptionError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {ArticleShortDescriptionError}
                </span>
              )}
            </div>

            <div className="m-t-10">
              <button
                type="button"
                onClick={() => {
                  createShortDescription();
                }}
                className="btn btn-primary shadow-add m-r-10"
              >
                {ShortDescriptionisloding && (
                  <i class="fa fa-spinner fa-spin m-r-10"></i>
                )}
                Save Changes
              </button>
            </div>
          </PanelBody>
        </Panel>
        {/* Enter Batch number */}
        <Modal
          isOpen={batchnumberisOpen}
          toggle={batchnumbertoggle}
          className=""
        >
          <ModalHeader toggle={batchnumbertoggle} className="modalheader">
            <h4 className="text-white mb-0">Add Batch Number</h4>
          </ModalHeader>
          <ModalBody>
            <div className="form-group ">
              <label htmlFor="exampleInputEmail1 " className="">
                Batch number
              </label>
              <input
                type="email"
                className="form-control"
                id="exampleInputEmail1"
                placeholder="Select Batch number"
                value={BatchNumber}
                maxLength={30}
                onChange={(e) => {
                  onchangeBatchnumber(e);
                }}
              />
              <p style={{ textAlign: "right", fontSize: 12, color: "red" }}>
                {BatchNumber.length}/30
              </p>
              {BatchNumberError.length > 0 ? (
                <span style={{ color: "red" }}>{BatchNumberError}</span>
              ) : (
                ""
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={(e) => {
                  addbatchnumber();
                }}
                className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
              >
                Add
              </button>
              <button
                type="button"
                onClick={(e) => {
                  setBatchnumber("");
                  batchnumbertoggle();
                }}
                className="btn btn-danger shadow-add my-3 "
              >
                Cancel
              </button>
            </div>
          </ModalBody>
        </Modal>
        {/* Enter Batch number */}
        <Modal isOpen={modalQrcode} toggle={toggleQrcode} className="modal-xl">
          <ModalHeader toggle={ModelClosed} className="modalheader">
            <h4 className="text-white mb-0">Create Production QR code</h4>
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-xl-6">
                <div className="row  align-items-center">
                  <div className="col-xl-4 col-xs-4">
                    {ArticlePicsImageList.length > 0 ? (
                      <img
                        src={
                          Config.contentUrl + ArticlePicsImageList[0].filePath
                        }
                        alt
                        className="rounded qrcode-article-image"
                      />
                    ) : (
                      <img
                        src="../assets/img/user/noimage.jpg"
                        alt
                        className="rounded qrcode-article-image"
                      />
                    )}
                    {/* <img src="../assets/img/user/user-1.jpg" alt width="100%" className='rounded' /> */}

                    <h5 className="m-t-10 mb-0 text-center">{ArticleName}</h5>
                  </div>
                  <div className="col-xl-4 col-xs-4">
                    {/* <button className="btn btn-lightgreen align-items-center">  <i className="ion ion-md-create m-r-10"></i>Edit information</button> */}
                    {/* <button className="btn btn-primary shadow-add m-r-10">Create QR code</button>
                                    <button className="btn  btn-primary btn-bg mt-3 shadow-add d-inline-flex align-items-center  m-r-10">
                                        <i class='fas  m-r-5 fa-pencil-alt icon'></i>
                                        Edit information</button> */}
                  </div>
                </div>
                <div className="m-t-30">
                  <div className="row">
                    <h5 className="col-xl-4 col-xs-4 mb-0">
                      <b>Article</b>
                    </h5>
                    <div>:</div>
                    <p className="col-xl-6 col-xs-7"> {ArticleNumber}</p>
                  </div>
                  <div className="row">
                    <h5 className="col-xl-4 col-xs-4 ">
                      <b>Category</b>
                    </h5>
                    <p>:</p>
                    <p className="col-xl-6 col-xs-7">
                      {Categoryselectname + " / " + subCategoryselectname}
                      {/* subCategoryselectname.length > 0 ? <p className="col-xl-6 col-xs-7">{+" / " + subCategoryselectname}</p>
                                        :<></> */}
                    </p>
                  </div>
                  <div>
                    <div>
                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                          <b>Vendors</b>
                        </h5>
                        <div>:</div>
                        <div className="col-xl-5 col-xs-5">
                          <select
                            className="default-select2 form-control"
                            onChange={(e) => {
                              onchangeVendor(e);
                            }}
                            value={VendorID}
                          >
                            <option value="">---Select Vendors ---</option>
                            {vendorlist.map((item, i) => {
                              return (
                                <option value={item.value}>{item.text}</option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="col-xl-2 col-xs-2">
                          <button
                            className="btn btn-primary btn-sm shadow-add"
                            onClick={vendoraddtoggle}
                          >
                            <i class="ion ion-md-add fa-2x fa-fw text-white"></i>
                          </button>
                        </div>
                      </div>
                      {isAttributeshow === true ? (
                        <div className="form-group row m-b-15 d-flex align-items-center">
                          <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                            <b>Select Combination </b>
                          </h5>
                          <div>:</div>
                          <div className="col-xl-7 col-xs-7">
                            <select
                              className="default-select2 form-control"
                              onChange={(e) => {
                                onchangeCombinationQrcode(e);
                              }}
                              value={selectCombinationID}
                            >
                              <option value="" selected>
                                --- Select Combination ---
                              </option>
                              {/* {CombinationDropDown()} */}
                              {CombinationList.map((item) => {
                                // <option value={item.id}>{item.attributeValue1 + "/" + item.attributeValue2 + `$'/++"`}</option>
                                return item.attributeValue1 != "" &&
                                  item.attributeValue2 != "" &&
                                  item.attributeValue3 != "" &&
                                  item.attributeValue4 != "" &&
                                  item.attributeValue5 != "" ? (
                                  <option value={item.id}>
                                    {item.attributeValue1 +
                                      " / " +
                                      item.attributeValue2 +
                                      " / " +
                                      item.attributeValue3 +
                                      " / " +
                                      item.attributeValue4 +
                                      " / " +
                                      item.attributeValue5}
                                  </option>
                                ) : item.attributeValue1 != "" &&
                                  item.attributeValue2 != "" &&
                                  item.attributeValue3 != "" &&
                                  item.attributeValue4 != "" &&
                                  item.attributeValue5 === "" ? (
                                  <option value={item.id}>
                                    {item.attributeValue1 +
                                      " / " +
                                      item.attributeValue2 +
                                      " / " +
                                      item.attributeValue3 +
                                      " / " +
                                      item.attributeValue4}
                                  </option>
                                ) : item.attributeValue1 != "" &&
                                  item.attributeValue2 != "" &&
                                  item.attributeValue3 != "" &&
                                  item.attributeValue4 === "" &&
                                  item.attributeValue5 === "" ? (
                                  <option value={item.id}>
                                    {item.attributeValue1 +
                                      " / " +
                                      item.attributeValue2 +
                                      " / " +
                                      item.attributeValue3}
                                  </option>
                                ) : item.attributeValue1 != "" &&
                                  item.attributeValue2 != "" &&
                                  item.attributeValue3 === "" &&
                                  item.attributeValue4 === "" &&
                                  item.attributeValue5 === "" ? (
                                  <option value={item.id}>
                                    {item.attributeValue1 +
                                      " / " +
                                      item.attributeValue2}
                                  </option>
                                ) : item.attributeValue1 != "" &&
                                  item.attributeValue2 === "" &&
                                  item.attributeValue3 === "" &&
                                  item.attributeValue4 === "" &&
                                  item.attributeValue5 === "" ? (
                                  <option value={item.id}>
                                    {item.attributeValue1}
                                  </option>
                                ) : (
                                  <></>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}

                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                          <b>Select Batch Number </b>
                        </h5>
                        <div>:</div>
                        <div className="col-xl-5 col-xs-7">
                          <select
                            className="default-select2 form-control"
                            onChange={(e) => {
                              onchangeselectBatchnumber(e);
                            }}
                            value={selectBatchNumbername}
                          >
                            <option value="" selected>
                              --- Select Batch Number ---
                            </option>
                            {batchNumberList.map((item) => {
                              return (
                                <option value={item._id}>
                                  {item.batchNumber}
                                </option>
                              );
                            })}
                          </select>
                        </div>
                        <div className="col-xl-2 col-xs-2">
                          <button
                            className="btn btn-primary btn-sm shadow-add"
                            // onClick={(e) => { setisBatchNumber(!isBatchNumber) }}
                            onClick={(e) => {
                              batchnumbertoggle();
                            }}
                          >
                            <i class="ion ion-md-add fa-2x fa-fw text-white"></i>
                          </button>
                        </div>
                      </div>

                      {/* {
                                                isBatchNumber === true ?
                                                    <div className="form-group row m-b-15 d-flex align-items-center">
                                                        <h5 className="col-xl-4 col-xs-4 col-form-label mb-0"><b>Enter Batch number</b></h5>
                                                        <div>:</div>
                                                        <div className="col-xl-7 col-xs-7">
                                                            <input type="email" className="form-control" id="exampleInputEmail1"
                                                                placeholder="Select Batch number"
                                                                value={BatchNumber}
                                                                onChange={(e) => { onchangeBatchnumber(e) }} />
                                                        </div>
                                                    </div>
                                                    : <></>
                                            } */}

                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                          <b>Manufacture date</b>
                        </h5>
                        <div>:</div>
                        <div className="col-xl-7 col-xs-7">
                          <DatePicker
                            className="form-control"
                            dateFormat={"dd/MM/yyyy"}
                            placeholderText="DD/MM/YYYY"
                            selected={ManufactureDate}
                            // maxDate={new Date()}
                            // onChange={(date: Date) => setManufactureDate(date)}
                            onChange={(date) => {
                              onchangeManufactureDate(date);
                            }}
                          />
                          {/* <input type="email" disabled={true} className="form-control" id="exampleInputEmail1" placeholder="Manufacture date" value={createdDate} /> */}
                        </div>
                      </div>
                      <div className="form-group row m-b-15 d-flex align-items-center">
                        <h5 className="col-xl-4 col-xs-4 col-form-label mb-0">
                          <b>Expiry date</b>
                        </h5>
                        <div>:</div>
                        <div className="col-xl-7 col-xs-7">
                          {/* <input type="email" className="form-control" id="exampleInputEmail1" placeholder="Expiry date" /> */}
                          <DatePicker
                            className="form-control"
                            dateFormat={"dd/MM/yyyy"}
                            placeholderText="DD/MM/YYYY"
                            selected={ExpiryDate}
                            // minDate={new Date()}
                            // onChange={(date: Date) => setExpiryDate(date)}
                            onChange={(date) => {
                              onchangeExpiryDate(date);
                            }}
                          />
                        </div>
                      </div>

                      {/* <div class="row mb-3 align-items-center">
                                                <h5 class="col-xl-4 col-xs-4 col-form-label mb-0"><b>Enable E Warranty</b></h5>
                                                <div>:</div>
                                                <div class="col-xl-7 col-xs-7">
                                                    <div class="form-check m-t-5">
                                                        <input class="form-check-input" type="checkbox" checked={EnableEWarranty} onChange={(e) => { setEnableEWarranty(!EnableEWarranty) }} id="flexCheckDefault" />
                                                        <label class="form-check-label" for="flexCheckDefault">
                                                        </label>
                                                    </div>

                                                </div>
                                            </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="dash-box">
                  <h4 className="mb-3">Product QR code</h4>
                  {selectCombinationID != "" &&
                    selectCombinationID != undefined &&
                    selectCombinationID != null ? (
                    // ||
                    // (VendorID != '' &&
                    //     VendorID != undefined &&
                    //     VendorID != null) ||
                    // (BatchNumber != '' &&
                    //     BatchNumber != undefined &&
                    //     BatchNumber != null) ||
                    // (ManufactureDate !== null &&
                    //     ManufactureDate !== '' &&
                    //     ManufactureDate !== undefined)
                    QrCodeString != null &&
                      QrCodeString != undefined &&
                      QrCodeString != "" ? (
                      <>
                        <QRCode value={QrCodeString} id="qrCodeEl" size={200} />
                        <p>Attrubute</p>
                      </>
                    ) : (
                      <img
                        src="/assets/img/new-Images/qr-code-scanner.jpg"
                        style={{ height: "200px" }}
                      ></img>
                    )
                  ) : QrCodeStringArticle != null &&
                    QrCodeStringArticle != undefined &&
                    QrCodeStringArticle != "" ? (
                    <QRCode
                      value={QrCodeStringArticle}
                      id="ArticleqrCodeEl"
                      size={200}
                    />
                  ) : (
                    <img
                      src="/assets/img/new-Images/qr-code-scanner.jpg"
                      style={{ height: "200px" }}
                    ></img>
                  )}

                  <div className="my-2">
                    {selectCombinationID != "" &&
                      selectCombinationID != undefined &&
                      selectCombinationID != null ? (
                      // ||
                      // (VendorID != '' &&
                      //     VendorID != undefined &&
                      //     VendorID != null) ||
                      // (BatchNumber != '' &&
                      //     BatchNumber != undefined &&
                      //     BatchNumber != null) ||
                      // (ManufactureDate !== null &&
                      //     ManufactureDate !== '' &&
                      //     ManufactureDate !== undefined)
                      QrCodeString != null &&
                        QrCodeString != undefined &&
                        QrCodeString != "" ? (
                        <div className="d-flex justify-content-center">
                          <button
                            type="submit"
                            className="btn btn-warning  m-r-5 m-b-5 btn-sm "
                            onClick={printQrcode}
                          >
                            Print{" "}
                          </button>
                          <button
                            type="submit"
                            className="btn btn-warning   m-r-5 m-b-5 btn-sm"
                            onClick={downloadQRCode}
                          >
                            Download
                          </button>
                          <button
                            type="submit"
                            className="btn btn-warning m-r-5 m-b-5  btn-sm "
                            onClick={() => {
                              toggleToEmailAttributecreate();
                            }}
                          >
                            Send
                          </button>
                        </div>
                      ) : (
                        <></>
                      )
                    ) : QrCodeStringArticle != null &&
                      QrCodeStringArticle != undefined &&
                      QrCodeStringArticle != "" ? (
                      <div className="d-flex justify-content-center">
                        <button
                          type="submit"
                          className="btn btn-warning  m-r-5 m-b-5 "
                          onClick={printQrcodeArticle}
                        >
                          Print
                        </button>
                        <button
                          type="submit"
                          className="btn btn-warning m-b-5 m-r-5 "
                          onClick={downloadQRCodeArticle}
                        >
                          Download
                        </button>

                        <button
                          type="submit"
                          className="btn btn-warning m-r-5 m-b-5"
                          onClick={() => {
                            toggleToEmail();
                          }}
                        >
                          Send
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="dash-box">
                  <h4 className="mb-3">Create production QR code</h4>
                  <div className="d-flex align-items-center justify-content-center ">
                    <label className=" m-r-5 col-form-label">Enter qty :</label>
                    <input
                      type="text"
                      className="form-control qtyinputbox"
                      placeholder="5625"
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={(e) => {
                        OnchangedQrCodeQty(e);
                      }}
                      value={QrcodeQty}
                    />
                  </div>
                  <div className="mt-3">
                    <div className="row justify-content-center">
                      {/* <button type="submit" className="btn btn-warning btn-sm col-md-3  m-r-5 m-b-10 ">Unique</button> */}
                      <button
                        type="submit"
                        className="btn btn-success m-b-10 shadow-add"
                        //onClick={DuplicateQrcodeCreate}
                        onClick={async (e) => {
                          try {
                            let response = await CheckBulkQRcodecount();
                            if (response === true || response === "true") {
                              DuplicateQrcodeCreate();
                            } else {
                              swal(
                                "oops!",
                                "Sorry! to increase your Bulk qrcode .",
                                "warning"
                              );
                            }
                          } catch (error) {
                            console.log("error!", error);
                          }
                        }}
                      >
                        Create production QR Code
                      </button>
                    </div>
                    {DuplicateQrcodeList.length > 0 ? (
                      <div style={{ height: "300px", overflow: "auto" }}>
                        <h5 className="text-center">Production QR Codes</h5>
                        <div className="m-b-20">
                          {DuplicateQrcodeList.map((item, i) => {
                            return (
                              <QRCode
                                value={item}
                                id={"qrCodeElDuplicate" + i}
                                key={i}
                                size={70}
                                style={{
                                  marginLeft: "8px",
                                  marginRight: "8px",
                                  marginBottom: "5px",
                                }}
                              />
                            );
                          })}
                        </div>
                      </div>
                    ) : (
                      <> </>
                    )}

                    <div className="my-2">
                      {DuplicateQrcodeList.length > 0 ? (
                        <div className="d-flex justify-content-center">
                          <button
                            type="submit"
                            className="btn btn-warning  m-r-5 m-b-5 btn-sm"
                            onClick={(e) => {
                              printQRDuplicate();
                            }}
                          >
                            Print{" "}
                          </button>
                          <button
                            type="submit"
                            className="btn btn-warning m-b-5 btn-sm"
                            onClick={downloadQRDuplicate}
                          >
                            Download
                          </button>
                          {/* <button type="submit" className="btn btn-warning m-l-5 m-b-5  btn-sm" onClick={(e) => { sendpdfEmail() }}>Send
                                                </button> */}
                          <button
                            type="submit"
                            className="btn btn-warning m-l-5 m-b-5  btn-sm"
                            onClick={() => {
                              toggleDuplicateSendEmail();
                            }}
                          >
                            Send
                          </button>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {/* <button type="submit" className="btn btn-primary shadow-add my-3 m-l-10 m-r-10">Save Changes</button> */}
              <button
                type="submit"
                className="btn btn-danger shadow-add my-3 "
                onClick={ModelClosed}
              >
                Discard
              </button>
              {/* <button type="submit" className="btn btn-primary shadow-add my-3 m-l-10 m-r-10">Create QR code</button> */}
              {selectCombinationID != "" &&
                selectCombinationID != undefined &&
                selectCombinationID != null ? (
                //  ||
                // (VendorID != '' &&
                //     VendorID != undefined &&
                //     VendorID != null) ||
                // (BatchNumber != '' &&
                //     BatchNumber != undefined &&
                //     BatchNumber != null) ||
                // (ManufactureDate !== null &&
                //     ManufactureDate !== '' &&
                //     ManufactureDate !== undefined
                <button
                  type="button"
                  onClick={async () => {
                    let response =
                      await CheckCheckAPDynamicQrCodeCountenabled();
                    if (response === true) {
                      Qrcodegenerator();
                    } else {
                      swal(
                        "oops!",
                        "Sorry! to increase your dynamic qrcode count.",
                        "warning"
                      );
                    }
                  }}
                  className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                >
                  Create Pre-Production QR Code Attribute
                </button>
              ) : (
                <button
                  type="button"
                  onClick={async () => {
                    let response =
                      await CheckCheckAPDynamicQrCodeCountenabled();
                    if (response === true) {
                      QrcodegeneratorArticle();
                    } else {
                      swal(
                        "oops!",
                        "Sorry! to increase your dynamic qrcode count.",
                        "warning"
                      );
                    }
                  }}
                  className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                >
                  Create Pre-Production QR Code
                </button>
              )}

            </div>
          </ModalBody>
        </Modal>
        <Panel>
          <PanelHeader>
            <h4 className="mb-0 text-light">Product Type</h4>
            <div className="form-group row m-b-0 mr-3">
              <div className="col-md-12">
                <div className="checkbox checkbox-css checkbox-inline pt-0">
                  <input
                    type="checkbox"
                    checked={IsArticleTypeDisplay}
                    onChange={(e) => {
                      IsArticleTypehandleSubmit(e);
                    }}
                    id="inlineCssCheckboxb3"
                  />
                  <label htmlFor="inlineCssCheckboxb3">Publish</label>
                </div>
              </div>
            </div>
          </PanelHeader>
          <PanelBody>
            <div className="row">
              <div className="col-xl-4">
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">
                    Select Product Type{" "}
                  </label>
                  <div className="d-flex">
                    <select
                      className="default-select2  form-control"
                      value={ArticlesTypeId}
                      onChange={(e) => {
                        onChangeProductdroptype(e);
                      }}
                    >
                      <option value="" selected>
                        --- Select Product Type ---
                      </option>
                      {ArticlesTypeList.map((item) => (
                        <option value={item.value}>{item.text}</option>
                      ))}
                    </select>
                    {ArticleTypeError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {ArticleTypeError}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              {isAttributeshow === true ? (
                <div className="col-xl-8">
                  <div className="form-group">
                    <label htmlFor="exampleInputPassword1">
                      Add Product Attribute{" "}
                    </label>
                    <div className="d-flex">
                      <ReactTags
                        placeholderText="Enter Product Attribute Maximum Five"
                        ref={reactTags}
                        tags={selectedAttributeList}
                        suggestions={ArticleAttributeList}
                        onDelete={onDelete}
                        onAddition={onAddition}
                        allowNew={true}
                        autoresize={true}
                        maxSuggestionsLength={5}
                        editable={true}
                        clearAll={true}
                        inline={false}
                        clearInputOnDelete={false}
                        allowBackspace={false}
                        className="form-control row flex-wrap"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
            {isAttributeshow === true ? (
              <div className="mt-5">
                <h5 className="m-b-15">Add Attribute Variant</h5>
                <div className="col-xl-12 Containerborder">
                  <div class="form-group row">
                    {selectedAttributeList.map((subscriber, index) => (
                      <div className="w-100 m-b-10 row">
                        <div className="col-md-2 col-sm-12">
                          <label className="col-form-label">
                            {subscriber.name}
                          </label>
                        </div>

                        <div className="col-md-5 col-sm-12">
                          {
                            <ReactTagInput
                              tags={subscriber.otherList}
                              onChange={(newTags) =>
                                onChangeAttributeVariant(index, newTags)
                              }
                              placeholder="Type and press enter"
                              editable={true}
                              readOnly={false}
                              removeOnBackspace={false}
                              validator={(value) => {
                                const retval = subscriber.otherList.find(
                                  (x) => x == value
                                );
                                if (
                                  retval === undefined ||
                                  retval === "" ||
                                  retval === null
                                ) {
                                  return true;
                                } else {
                                  //alert("Please enter Unique Variant");
                                  return false;
                                }
                              }}
                            />
                          }
                          {/* <input type="text" className="form-control" value={selectedAttributeList[index].other} onChange={(e) => onChangeAttributeVariant(index, e)}></input> */}
                        </div>
                      </div>
                    ))}
                    <div className="col-md-12 text-center">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          CreateAttributegenratemapping();
                        }}
                      >
                        Generate Variant Mapping
                      </button>
                    </div>
                  </div>
                  <h5 className="">Variant Combination</h5>
                  <div class="table-responsive">
                    <table class="table table-bordered m-b-0">
                      <thead>
                        <tr>
                          <th>Variant</th>
                          <th>Price</th>
                          {/* <th>Quantity</th> */}
                          <th>SKU</th>
                          <th>Image</th>
                        </tr>
                      </thead>
                      <tbody>
                        {CombinationList.map((subscriber, index) => (
                          <tr>
                            <td>
                              {subscriber.attributeValue1}

                              {subscriber.attributeValue2 !== "" &&
                                subscriber.attributeValue2 != null
                                ? " / " + subscriber.attributeValue2
                                : ""}

                              {subscriber.attributeValue3 !== "" &&
                                subscriber.attributeValue3 != null
                                ? " / " + subscriber.attributeValue3
                                : ""}

                              {subscriber.attributeValue4 !== "" &&
                                subscriber.attributeValue4 != null
                                ? " / " + subscriber.attributeValue4
                                : ""}

                              {subscriber.attributeValue5 !== "" &&
                                subscriber.attributeValue5 != null
                                ? " / " + subscriber.attributeValue5
                                : ""}
                            </td>
                            <td>

                              <NumericFormat
                                thousandSeparator={true}
                                className="form-control form col-xl-6 col-xs-11 m-l-10"
                                placeholder="Price"
                                decimalScale={2}
                                fixedDecimalScale={false}
                                value={subscriber.price}
                                onChange={(e) => {
                                  onchangeGenrateAttributePrice(index, e);
                                }}
                              />
                            </td>

                            <td>
                              <input
                                type="text"
                                value={subscriber.sku}
                                className="form-control"
                                onChange={(e) => {
                                  onchangeGenrateAttributeSku(index, e);
                                }}
                              />{" "}
                            </td>
                            <td>
                              <input
                                type="file"
                                className="form-control"
                                onChange={(e) => {
                                  onchangeAttributeimage(index, e);
                                }}
                              />
                              {subscriber.attributeImagePath != null &&
                                subscriber.attributeImagePath != "" ? (
                                <div class="variantimagecontainer">
                                  {subscriber.profileImage !== null &&
                                    subscriber.profileImage != "" &&
                                    subscriber.profileImage !== undefined ? (
                                    <img
                                      src={subscriber.attributeImagePath}
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/new-images/images.png";
                                      }}
                                      // style={{ height: "90px", width: "90px" }}
                                      style={{ height: "40px" }}
                                    ></img>
                                  ) : (
                                    <img
                                      src={
                                        Config.contentUrl +
                                        subscriber.attributeImagePath
                                      }
                                      onError={({ currentTarget }) => {
                                        currentTarget.onerror = null; // prevents looping
                                        currentTarget.src =
                                          "../assets/img/new-images/images.png";
                                      }}
                                      style={{ height: "40px" }}
                                    // style={{ height: "90px", width: "90px" }}
                                    ></img>
                                  )}
                                  {subscriber.profileImage !== null &&
                                    subscriber.profileImage != "" &&
                                    subscriber.profileImage !== undefined ? (
                                    <div class="posDelete">
                                      <button
                                        class="btn btn-danger shadow-add btndelete"
                                        onClick={(e) => {
                                          deletenewimage(index);
                                        }}
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                  ) : (
                                    <div class="posDelete">
                                      <button
                                        class="btn btn-danger shadow-add btndelete"
                                        onClick={(e) => {
                                          deletOldimage(
                                            index,
                                            subscriber.attributeImageId
                                          );
                                        }}
                                      >
                                        <i class="fas fa-trash"></i>
                                      </button>
                                    </div>
                                  )}
                                </div>
                              ) : (
                                <img
                                  src="../assets/img/new-images/images.png"
                                  className="img-upload-size"
                                  style={{ height: "40px" }}
                                ></img>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}

            {isAttributeshow === true ? (
              <button
                type="button"
                onClick={() => {
                  CreateAttributegenrateVariant();
                }}
                className="btn btn-primary shadow-add m-r-10"
              >
                {Attributeisloding && (
                  <i class="fa fa-spinner fa-spin m-r-10"></i>
                )}
                Save Changes
              </button>
            ) : (
              <button
                type="button"
                onClick={() => {
                  CreateArticleType();
                }}
                className="btn btn-primary shadow-add m-r-10"
              >
                {Attributeisloding && (
                  <i class="fa fa-spinner fa-spin m-r-10"></i>
                )}
                Save Changes
              </button>
            )}
            {/* <button type="button" onClick={() => { CreateAttributegenrateVariant() }} className="btn btn-primary shadow-add m-r-10">Save Changes</button> */}
            {/* <button type="submit" className="btn btn-danger shadow-add">Reset</button> */}
          </PanelBody>
        </Panel>

        {ArticleID != null && ArticleID != "" && ArticleID != undefined ? (
          <Panel className="border " theme="dark-red">
            <PanelHeader className="align-items-center">
              <div className="d-md-flex align-items-center">
                <h4 className="mb-0 text-light">
                  Product Segment Descriptions
                </h4>
                <div>
                  <button
                    onClick={(e) => {
                      toggleSegmentModal();
                    }}
                    type="submit"
                    className="btn btn-primary add-new btn-sm shadow-add ml-md-2 ml-sm-0 mt-md-0 mt-sm-2 "
                  >
                    Add New Segment
                  </button>

                  {/* <button onClick={this.toggleSignup6} type="submit" className="btn btn-primary add-new btn-sm shadow-add m-l-10">List of Segments</button> */}
                </div>
              </div>
              <div className="form-group row m-b-0 mr-3">
                <div className="col-md-12">
                  <div className="checkbox checkbox-css checkbox-inline pt-0">
                    <input
                      type="checkbox"
                      id="inlineCssCheckboxd1"
                      checked={IsArticleDescriptionDisplay}
                      onChange={IsArticleDescriptionDisplyUpdate}
                    />
                    <label htmlFor="inlineCssCheckboxd1">Publish</label>
                  </div>
                </div>
              </div>
            </PanelHeader>
            <PanelBody className="bg-purple-600">
              {articleSegmentList.length > 0 ? (
                <Nav className="mb-3 justify-content-between nav1 ">
                  {/* <NavItem className="navitemdesign">
                                                {displayPosts}
                                            </NavItem>
                                            <button onClick={toggleSegmentModalEdit} type="submit" className="btn btn-purple  shadow-add m-t-10 py-2">Edit Segments List</button> */}
                  <div className="row">
                    <NavItem className="navitemdesign p-0">
                      <NavLink className="mb-2"> {displayPosts}</NavLink>
                    </NavItem>
                  </div>
                  <div>
                    <button
                      onClick={(e) => {
                        toggleSegmentModalEdit(e);
                      }}
                      type="submit"
                      className="btn btn-purple  shadow-add m-t-10 py-2"
                    >
                      Edit Segments List
                    </button>
                  </div>
                </Nav>
              ) : (
                ""
              )}
              <TabContent className="p-15 rounded bg-white mb-4">
                {articleSegmentList.length > 0 ? (
                  <TabPane>
                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="mb-0 text-light">Images</h4>
                        <div className="form-group row m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentImageDisplay}
                                id="inlineCssCheckboxd3"
                                onChange={(e) => {
                                  IsArticleSegmentImagehandleSubmit(e);
                                }}
                              />
                              <label htmlFor="inlineCssCheckboxd3">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <div class="text-inverse m-b-10">
                          <button
                            type="submit"
                            className="btn btn-primary btn-sm shadow-add start m-b-15"
                          >
                            <span>Order to Display</span>
                          </button>
                          <div className="col-md-12 pl-0">
                            {ArticleSegmentImageLists !== null ? (
                              <div className="d-flex wrapText">
                                {ArticleSegmentImageLists.map(
                                  (subscriber, index) => (
                                    <div className="mb-3 ">
                                      <div className="posRelative">
                                        <img
                                          src={
                                            Config.contentUrl +
                                            subscriber.filePath
                                          }
                                          className="image-article imageUpload"
                                        />
                                        <div className="posDelete">
                                          <a
                                            className="btn btn-danger shadow-add btndelete"
                                            onClick={() =>
                                              ArticlesegmentImagedelete(
                                                subscriber._id
                                              )
                                            }
                                          >
                                            <i class="fas fa-trash"></i>
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : null}
                          </div>
                          <div class="dropzone needsclick overflow-hidden">
                            <Dropzone
                              // getUploadParams={getArticleUploadParamsSegmentImages}
                              onChangeStatus={
                                handleChangeArticleUploadSegmentImagesStatus
                              }
                              onSubmit={CreateArticleSegmentImages}
                              //accept="image/*,audio/*,video/*"
                              accept="image/*"
                              inputContent={(files, extra) =>
                                extra.reject
                                  ? "Image files only"
                                  : "Drop Image files only here click to upload"
                              }
                              styles={{
                                dropzone: {
                                  overflow: "hidden",
                                  border: "none",
                                },
                                dropzoneReject: {
                                  borderColor: "red",
                                  backgroundColor: "#DAA",
                                },
                                inputLabel: (files, extra) =>
                                  extra.reject ? { color: "red" } : {},
                              }}
                            />
                          </div>
                          {ArticleUploadSegmentImagesError.length > 0 && (
                            <span style={{ color: "red", marginLeft: 6 }}>
                              {ArticleUploadSegmentImagesError}
                            </span>
                          )}
                        </div>
                      </PanelBody>
                    </Panel>
                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="mb-0 text-light">
                          Description (Add Text below)
                        </h4>
                        <div className="form-group row m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentDescriptionDisplay}
                                id="inlineCssCheckboxd5"
                                onChange={(e) => {
                                  IsArticleSegmentDescriptionhandleSubmit(e);
                                }}
                              />
                              <label htmlFor="inlineCssCheckboxd5">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <div class="panel-body p-0">
                          {/* <CKEditor
                            data={SegmentDescription}
                            editor={ClassicEditor}
                            config={{
                              ckfinder: {
                                uploadUrl: Config.apiUrl + "UserCompany/upload",
                                // uploadUrl:
                                //   "https://localhost:44389/api/UserCompany/upload",
                              },
                              mediaEmbed: {
                                previewsInData: true,
                              },
                            }}
                            onReady={(editor) => {
                              // console.log('Editor is ready to use!', editor);
                            }}
                            onBlur={(event, editor) => {
                              // console.log('Blur.', editor);
                            }}
                            onFocus={(event, editor) => {
                              // console.log('Focus.', editor);
                            }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              onChangeSegmentDescription(data);
                              //console.log({ event, editor, data });
                            }}
                            className="ckedit"
                          /> */}
                          <CKEditor
                            editor={Editor}
                            config={editorConfiguration}
                            data={SegmentDescription}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              onChangeSegmentDescription(data);
                              //console.log({ event, editor, data });
                            }}
                            onBlur={(event, editor) => {
                              console.log("Blur.", editor);
                            }}
                            onFocus={(event, editor) => {
                              console.log("Focus.", editor);
                            }}
                            onReady={(editor) => {
                              editor.ui.getEditableElement().parentElement.insertBefore(
                                editor.ui.view.toolbar.element,
                                editor.ui.getEditableElement()
                              );
                            }}

                          />
                        </div>

                        <div className="m-t-10">
                          <button
                            type="button"
                            onClick={() => {
                              createdeSegmentDescription();
                            }}
                            className="btn btn-primary shadow-add m-r-10"
                          >
                            Save Changes
                          </button>
                        </div>
                      </PanelBody>
                    </Panel>
                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="mb-0 text-light">
                          Upload Videos (Know more)
                        </h4>
                        <div className="form-group row m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentVideoDisplay}
                                id="inlineCssCheckboxd8"
                                onChange={(e) => {
                                  IsArticleSegmentVideoUpdate(e);
                                }}
                              />
                              <label htmlFor="inlineCssCheckboxd8">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        {/* <button type="submit" className="btn btn-primary btn-sm shadow-add start m-b-15">

                                                            <span>Order to Display</span>
                                                        </button> */}
                        <div className="col-md-12 pl-0">
                          {VideosegmentList !== null ? (
                            <div className="d-flex wrapText text-break">
                              {VideosegmentList.map((subscriber, index) =>
                                subscriber.isYouTubeLink === false ? (
                                  <div className="mb-3 ">
                                    <div className="posRelative">
                                      <VideoTag
                                        src={
                                          Config.contentUrl +
                                          subscriber.filePath
                                        }
                                        className="image-article imageUpload"
                                      />
                                      <div className="posDelete">
                                        <a
                                          className="btn btn-danger shadow-add btndelete"
                                          onClick={() =>
                                            ArticlesegmentVideodelete(
                                              subscriber._id
                                            )
                                          }
                                        >
                                          <i class="fas fa-trash"></i>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="mb-3 posRelativeWidth">
                                    <div className="posRelative">
                                      <img
                                        src={`https://i.ytimg.com/vi/${reyurnperamiter(
                                          subscriber?.youTubeLink
                                        )}/hqdefault.jpg`}
                                        className="image-article imageUpload m-auto"
                                      />
                                      <div className="posDelete">
                                        <a
                                          className="btn btn-danger shadow-add btndelete"
                                          onClick={() =>
                                            ArticlesegmentVideodelete(
                                              subscriber._id
                                            )
                                          }
                                        >
                                          <i className="fas fa-trash"></i>
                                        </a>
                                      </div>
                                      <p className="mx-2 text2line">
                                        {subscriber?.youTubeLink}
                                      </p>
                                    </div>
                                  </div>
                                )
                              )}
                            </div>
                          ) : null}
                        </div>
                        <div class=" text-inverse">
                          <div class="dropzone needsclick overflow-hidden">
                            <Dropzone
                              // getUploadParams={getArticleUploadParamsVideos}
                              onChangeStatus={
                                handleChangeArticleSegmentVideoUploadStatus
                              }
                              onSubmit={CreateArticleSegmentVideo}
                              //accept="image/*,audio/*,video/*,.pdf"
                              //accept="video/*"
                              accept=".mp4"
                              maxSizeBytes={Config.MaximumVideoFileSize}
                              styles={{
                                dropzone: {
                                  overflow: "hidden",
                                  border: "none",
                                },
                              }}
                              inputContent="Drop video files only here click to upload"
                              submitButtonContent={"Submit"}
                            />
                          </div>

                          {/* <div className="mt-3">
                                                    <button type="button" onClick={() => { CreateArticleSegmentVideo() }} className="btn btn-primary shadow-add m-r-10">Save Changes</button>
                                                    <button type="button" className="btn btn-danger shadow-add">Reset</button>
                                                </div> */}
                        </div>
                        <div className="row mt-3">
                          <div className="col-xl-9">
                            <div className="form-group row m-b-15 align-items-center">
                              <label className="col-md-4 col-form-label">
                                Enter youtube video link
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter youtube video link"
                                  value={youTubleVideoLink}
                                  onChange={onChangeyouTubleVideoLink}
                                />
                              </div>
                              <div className="col-md-2">
                                <button
                                  type="button"
                                  onClick={() => {
                                    createyouTubeVideoLink();
                                  }}
                                  className="btn btn-primary shadow-add m-r-10 my-2 my-2"
                                >
                                  Add
                                </button>
                              </div>
                              <label className="col-md-3 col-form-label"></label>
                            </div>
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>

                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="mb-0 text-light">
                          Upload documents ( Read further)
                        </h4>

                        <div className="form-group row m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentDocumentDisplay}
                                onChange={(e) =>
                                  IsArticleSegmentDocumentUpdate(e)
                                }
                                id="inlineCssCheckboxd59"
                              />
                              <label htmlFor="inlineCssCheckboxd59">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <button
                          type="submit"
                          className="btn btn-primary btn-sm shadow-add start m-b-15"
                        >
                          <span>Order to Display</span>
                        </button>
                        <div className="col-md-12 pl-0">
                          <Modal
                            isOpen={ArticleSegmentDocumentEditNameisOpen}
                            toggle={ArticleSegmentDocumentEditNameisOpen}
                            className=""
                            onHide={() =>
                              toggleArticleSegmentDocumentEditName()
                            }
                          >
                            <ModalHeader
                              toggle={toggleArticleSegmentDocumentEditName}
                              className="modalheader"
                            >
                              <h4 className="text-white mb-0">
                                Edit Article Document
                              </h4>
                            </ModalHeader>
                            <ModalBody>
                              <div className="form-group ">
                                <label
                                  htmlFor="exampleInputEmail1 "
                                  className=""
                                >
                                  Edit Article Document
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Article Document"
                                  value={DocumentName}
                                  onChange={(e) => {
                                    onChangeDocumentName(e);
                                  }}
                                />
                              </div>
                            </ModalBody>
                            <ModalFooter>
                              <button
                                type="button"
                                onClick={() => {
                                  UpdateArticleDocumentFile();
                                }}
                                className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                              >
                                Save
                              </button>
                              <button
                                type="button"
                                onClick={() =>
                                  toggleArticleSegmentDocumentEditName()
                                }
                                className="btn btn-danger shadow-add my-3 "
                              >
                                Discard
                              </button>
                            </ModalFooter>
                          </Modal>
                          {ArticleSegmentDocumentlist !== null ? (
                            <div className="d-flex wrapText text-break">
                              {ArticleSegmentDocumentlist.map(
                                (subscriber, index) => (
                                  <div className="mt-2 mr-3 posRelativeWidth">
                                    <div className="posRelative">
                                      <a
                                        href="javascript:void(0)"
                                        className="alignTextCenter "
                                        onClick={() =>
                                          downloadEmployeeData(
                                            subscriber.filePath
                                          )
                                        }
                                        download
                                      >
                                        <img
                                          src="https://deeryamerican.com/wp-content/uploads/2016/12/IMG_9275.ico"
                                          className="img-upload-size"
                                        ></img>
                                      </a>
                                      <div className="posDeletePdf">
                                        <button
                                          className="btn btn-danger shadow-add btndelete"
                                          onClick={() =>
                                            ArticlesegmentDocumentdelete(
                                              subscriber._id
                                            )
                                          }
                                        >
                                          <i class="fas fa-trash"></i>
                                        </button>
                                      </div>
                                      <p>{subscriber?.originalFileName}</p>
                                    </div>

                                    {/* <p href="javascript:void(0)" className="d-flex"><span className="mt-2 text-dark width80">{subscriber.fileName}</span><a href="javascript:void(0)" className="ml-2 btnEdit"><i class="far fa-edit" onClick={() => { onClickDocumentEdit(subscriber) }}></i></a></p> */}
                                  </div>
                                )
                              )}
                            </div>
                          ) : null}
                        </div>
                        <div class="text-inverse">
                          <div class="dropzone needsclick overflow-hidden">
                            <Dropzone
                              // getUploadParams={getArticleUploadParamsDocument}
                              onChangeStatus={
                                handleChangeArticleUploadDocumentStatus
                              }
                              onSubmit={CreateArticleDocument}
                              //accept="image/*,audio/*,video/*,.pdf"
                              accept=".pdf"
                              styles={{
                                dropzone: {
                                  overflow: "hidden",
                                  border: "none",
                                },
                              }}
                              inputContent="Drop pdf files only here click to upload"
                              submitButtonContent={"Submit"}
                            />
                          </div>

                          {/* <div className="mt-3">
                                                    <button type="button" onClick={() => { CreateArticleDocument() }} className="btn btn-primary shadow-add m-r-10">Save Changes</button>
                                                    <button type="button" className="btn btn-danger shadow-add">Reset</button>
                                                </div> */}
                        </div>
                      </PanelBody>
                    </Panel>
                    <Panel className="border" theme="success">
                      <PanelHeader>
                        <h4 className="mb-0 text-light">
                          External web site link
                        </h4>
                        <div className="form-group row m-b-0 mr-3">
                          <div className="col-md-12">
                            <div className="checkbox checkbox-css checkbox-inline pt-0">
                              <input
                                type="checkbox"
                                checked={IsArticleSegmentWebLinkDisplay}
                                id="inlineCssCheckboxd51"
                                onChange={(e) => {
                                  IsArticleSegmentWebLinkupdate(e);
                                }}
                              />
                              <label htmlFor="inlineCssCheckboxd51">
                                Publish
                              </label>
                            </div>
                          </div>
                        </div>
                      </PanelHeader>
                      <PanelBody>
                        <div className="row">
                          <div className="col-xl-9">
                            <div className="form-group row m-b-15">
                              <label className="col-md-4 col-form-label">
                                Name
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  maxLength={30}
                                  placeholder="Enter website link name"
                                  value={websitelinkname}
                                  onChange={onChangewebsitelinkname}
                                />
                                <p
                                  style={{
                                    textAlign: "right",
                                    fontSize: 12,
                                    color: "red",
                                  }}
                                >
                                  {websitelinkname.length}/30
                                </p>
                                {/* {websitelinknameError.length > 0 &&
                                                                            <span style={{ color: 'red', marginLeft: 6 }}>{websitelinknameError}</span>} */}
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-9">
                            <div className="form-group row m-b-15 align-items-center">
                              <label className="col-md-4 col-form-label">
                                Enter website link
                              </label>
                              <div className="col-md-6">
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter website link"
                                  value={webLink}
                                  onChange={onChangeWebLink}
                                />
                                {WebLinkError.length > 0 && (
                                  <span style={{ color: "red", marginLeft: 6 }}>
                                    {WebLinkError}
                                  </span>
                                )}
                              </div>
                              <div className="col-md-2">
                                <button
                                  type="button"
                                  onClick={() => {
                                    createWebLink();
                                  }}
                                  className="btn btn-primary shadow-add m-r-10 my-2"
                                >
                                  Add
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="container-fluid">
                          <div className="row justify-content-center">
                            <div className="table-responsive col-lg-11 pl-2">
                              <table
                                id="data-table-buttons"
                                className="table table-striped table-bordered table-td-valign-middle"
                              >
                                <thead>
                                  <tr className="odd gradeA ">
                                    <th className="text-nowrap">Name</th>
                                    <th className="text-nowrap">WebLink</th>

                                    <th className="text-nowrap">Action</th>
                                  </tr>
                                </thead>
                                {articleSegmentWebLinkList !== null ? (
                                  <tbody>
                                    {articleSegmentWebLinkList.map(
                                      (subscriber, index) => (
                                        <tr>
                                          <td className="text-break">
                                            <p className="breakword">
                                              {subscriber.name}
                                            </p>
                                          </td>
                                          <td className="text-break ">
                                            <p className="breakword">
                                              {subscriber.linkURL}
                                            </p>
                                          </td>

                                          <td>
                                            <a
                                              href="javascript:void(0)"
                                              className="btn btn-danger"
                                              onClick={() => {
                                                ArticleWeblinkdelete(
                                                  subscriber._id
                                                );
                                              }}
                                            >
                                              <i class="fas fa-trash"></i>
                                            </a>
                                          </td>
                                        </tr>
                                      )
                                    )}
                                  </tbody>
                                ) : null}
                              </table>
                            </div>
                          </div>
                        </div>
                      </PanelBody>
                    </Panel>
                  </TabPane>
                ) : (
                  ""
                )}
                {/* New Segment modal */}
                <Modal
                  isOpen={SegmentModalisOpen}
                  toggle={SegmentModalisOpen}
                  className=""
                  onHide={() => {
                    toggleSegmentModal();
                  }}
                >
                  <ModalHeader
                    toggle={toggleSegmentModal}
                    className="modalheader"
                  >
                    <h4 className="text-white mb-0">Add New Segment</h4>
                  </ModalHeader>
                  <ModalBody>
                    <div className="form-group ">
                      <label htmlFor="exampleInputEmail1 " className="">
                        New Segment Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter New Segment Name"
                        value={Title}
                        maxLength={30}
                        onChange={(e) => {
                          onChangeArticlesegmentName(e);
                        }}
                      />
                      {/* {TitleError.length > 0 ? <span style={{ color: "red" }}>{TitleError}</span> : ''} */}
                      <p
                        style={{
                          textAlign: "right",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {Title.length}/30
                      </p>
                      {TitleError.length > 0 ? (
                        <span style={{ color: "red" }}>{TitleError}</span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="d-flex justify-content-center">
                      <button
                        type="button"
                        onClick={() => {
                          createArticleSegmentName();
                        }}
                        className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                      >
                        Add
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          toggleSegmentModal();
                        }}
                        className="btn btn-danger shadow-add my-3 "
                      >
                        Cancel
                      </button>
                    </div>
                  </ModalBody>
                </Modal>
                {/* Edit Segment List modal */}
                <Modal
                  isOpen={SegmentEditisOpen}
                  toggle={SegmentEditisOpen}
                  className=""
                  onHide={(e) => {
                    toggleSegmentModalEdit(e);
                  }}
                >
                  <ModalHeader
                    toggle={toggleSegmentModalEdit}
                    className="modalheader"
                  >
                    <h4 className="text-white mb-0">List of Segment</h4>
                  </ModalHeader>
                  <ModalBody>
                    <div className="panel-body col-md-12 pl-2">
                      {articleSegmentList !== null ? (
                        <div>
                          {articleSegmentList.map((subscriber, index) => (
                            <div className="segmentlistbox">
                              <h5 className="mb-0">{subscriber?.title}</h5>

                              <div>
                                <div className="d-flex">
                                  <a
                                    href="javascript:void(0)"
                                    className="mr-2 btnEdit NewBtnEdit"
                                  >
                                    <i
                                      class="fas fa-pen"
                                      onClick={() =>
                                        onClickArticleSegmentNameEdit(subscriber)
                                      }
                                    ></i>
                                  </a>
                                  <a
                                    href="javascript:void(0)"
                                    className="btn btn-danger"
                                    onClick={() =>
                                      ArticlesegmentNamedelete(subscriber._id)
                                    }
                                  >
                                    <i class="fas fa-trash"></i>
                                  </a>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}
                    </div>
                  </ModalBody>
                </Modal>
                {/* Edit Segment modal */}
                <Modal
                  isOpen={SegmentEditDetailsisOpen}
                  toggle={SegmentEditDetailsisOpen}
                  className=""
                  onHide={() => toggleSegmentEditDetails()}
                >
                  <ModalHeader
                    toggle={toggleSegmentEditDetails}
                    className="modalheader"
                  >
                    <h4 className="text-white mb-0">Edit Segment</h4>
                  </ModalHeader>
                  <ModalBody>
                    <div className="form-group ">
                      <label htmlFor="exampleInputEmail1 " className="">
                        Edit Segment Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter New Segment Name"
                        value={Title}
                        maxLength={30}
                        onChange={(e) => {
                          onChangeArticlesegmentName(e);
                        }}
                      />
                      {/* {TitleError.length > 0 ? <span style={{ color: "red" }}>{TitleError}</span> : ''} */}
                      <p
                        style={{
                          textAlign: "right",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {Title.length}/30
                      </p>
                      {TitleError.length > 0 ? (
                        <span style={{ color: "red" }}>{TitleError}</span>
                      ) : (
                        ""
                      )}
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <button
                      type="button"
                      onClick={() => {
                        UpdateArticleSegmentName();
                      }}
                      className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        toggleSegmentEditDetails();
                      }}
                      className="btn btn-danger shadow-add my-3 "
                    >
                      Discard
                    </button>
                  </ModalFooter>
                </Modal>
              </TabContent>
            </PanelBody>

          </Panel>
        ) : (
          <></>
        )}
        <div className="my-5 d-flex justify-content-center">
          <button
            type="button"
            className="btn btn-primary shadow-add btn-lg"
            onClick={(e) => {
              toggleQrcode();
            }}
          >
            Create QR Code
          </button>
          <button className={"btn btn-white btn-shadow p-2 border ml-3"}>
            <img
              src="../assets/img/user/QR.png"
              style={{ height: "40px", width: "40px" }}
            ></img>
          </button>
        </div>
        <div className="row">
          <div className="col-xl-7 h-100">
            <Panel>
              <PanelHeader>
                <h4 className="mb-0 text-light">Certificates</h4>
                <div className="form-group row m-b-0 mr-3">
                  <div className="col-md-12">
                    <div className="checkbox checkbox-css checkbox-inline pt-0">
                      <input
                        type="checkbox"
                        checked={IsCertificateDisplay}
                        onChange={(e) => {
                          IsCertificateshandleSubmit(e);
                        }}
                        id="CertificatesCheckboxb1"
                      />
                      <label htmlFor="CertificatesCheckboxb1">Publish</label>
                    </div>
                  </div>
                </div>
              </PanelHeader>
              <PanelBody>
                <div className="row">
                  <div className="col-md-12">
                    <div className="row align-items-center ">
                      <div className="col-sm-6">
                        <label className="col-form-label">
                          Click to display the Certificates for this Product
                        </label>
                      </div>
                      <div className="col-sm-6">
                        {/* <button type="button" className="btn btn-primary shadow-add m-r-10">Click</button> */}
                        <button
                          type="button"
                          onClick={toggleSignupAdd}
                          className="btn btn-primary shadow-add m-r-10"
                        >
                          Add new Certificate
                        </button>
                      </div>
                    </div>
                    <div className="row align-items-center py-3">
                      <div className="col-sm-12">
                        <div className="table-responsive">
                          <table className="scrolltable table table-bordered table-striped text-center table-img">
                            <thead>
                              <tr className="text-center">
                                <th className="align-middle">Sr.No</th>
                                <th className="align-middle">Select</th>
                                <th className="align-middle">Certificates</th>
                                <th className="align-middle">Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {CertificateList.length > 0 ? (
                                CertificateList.map((item, index) => (
                                  <tr className="text-center" key={index}>
                                    <td className="align-middle">
                                      {index + 1}
                                    </td>
                                    <td className="align-middle">
                                      <div className=" checkbox checkbox-css checkbox-inline checkbox-5 pt-0">
                                        <input
                                          type="checkbox"
                                          checked={item.isCertificateselect}
                                          value=""
                                          id={"CssCheckboxae1" + index}
                                          onChange={(e) => {
                                            isCertificateselectupdate(item);
                                          }}
                                        />
                                        <label
                                          htmlFor={"CssCheckboxae1" + index}
                                        ></label>
                                      </div>
                                    </td>
                                    <td className="align-middle">
                                      {/* <img src="../assets/img/user/user-1.jpg" style={{ height: 60 }} /> */}
                                      <img
                                        src={Config.contentUrl + item._LogoPath}
                                        style={{ height: "50px" }}
                                        onError={({ currentTarget }) => {
                                          currentTarget.onerror = null; // prevents looping
                                          currentTarget.src =
                                            "../assets/img/new-images/images.png";
                                        }}
                                      ></img>
                                    </td>
                                    <td className="align-middle">
                                      {item.name}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <></>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    UpdateArticleCertificate();
                  }}
                  className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                >
                  {Certificatesisloding && (
                    <i class="fa fa-spinner fa-spin m-r-10"></i>
                  )}
                  Save Changes
                </button>
                {/* <button type="button" className="btn btn-danger shadow-add my-3 ">Discard</button> */}

                <Modal isOpen={modalSignupAdd} toggle={toggleSignupAdd}>
                  <ModalHeader toggle={toggleSignupAdd} className="modalheader">
                    <h4 className="text-white mb-0">Add Certificates</h4>
                  </ModalHeader>
                  <ModalBody className="m-0">
                    <div className="form-group row m-b-15">
                      <label className="col-md-3 col-form-label">
                        Certificates Name
                      </label>
                      <div className="col-md-9">
                        <input
                          type="text"
                          maxLength={40}
                          className="form-control"
                          placeholder="Enter Name"
                          value={CertificateName}
                          onChange={onChangeCertificateName}
                        />
                        <p
                          style={{
                            textAlign: "right",
                            fontSize: 12,
                            color: "red",
                          }}
                        >
                          {CertificateName.length}/40
                        </p>
                      </div>
                      {CertificateNameError.length > 0 ? (
                        <span style={{ color: "red" }}>
                          {CertificateNameError}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className=" row m-b-15">
                      <div className="col-md-3 ">Logo</div>
                      <div className="col-md-9">
                        <div class="custom-file file-upload-height">
                          <input
                            type="file"
                            onChange={(e) => CertificatesetFile(e)}
                            className="custom-file-input file-upload-height"
                            id="customFile"
                          />
                          <label
                            className=" file-upload-1 file-upload-height"
                            for="customFile "
                          >
                            {CertificateLogoPath ? (
                              <img
                                src={CertificateLogoPath}
                                alt="img"
                                className="img-upload-size-1"
                              />
                            ) : (
                              <p className="mb-0">Add Image</p>
                            )}
                            {/* <img
                              src={CertificateLogoPath}
                              alt="img"
                              className="img-upload-size-1"
                            /> */}
                            <div className="file-upload-3 ">
                              <i className="ion ion-md-camera  fa-sm"></i>
                            </div>
                          </label>
                        </div>
                      </div>
                      {CertificateLogoFileError.length > 0 ? (
                        <span style={{ color: "red" }}>
                          {CertificateLogoFileError}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group row m-b-15">
                      <label className="col-md-3 col-form-label">
                        Document
                      </label>
                      <div className="col-md-9">
                        <div class="custom-file ">
                          <input
                            type="file"
                            onChange={(e) => CertificatesetFileDocument(e)}
                            className="custom-file-input "
                            id="customFile"
                            accept="application/pdf"
                          />
                          <label
                            className="custom-file-label file-upload"
                            for="customFile "
                          >
                            Upload
                          </label>
                        </div>
                      </div>
                      {DocumentFileError.length > 0 ? (
                        <span style={{ color: "red" }}>
                          {DocumentFileError}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>

                    {CertificateDocumentpath.map((subscriber, index) => (
                      <div className="form-group row m-b-15 align-items-center">
                        <div
                          className="offset-3 col-md-2"
                          key={index}
                          onClick={() =>
                            downloadDocumentData(subscriber.FileUrl)
                          }
                        >
                          <img
                            src="../assets/img/new-Images/Pdf.png"
                            style={{ height: "60px" }}
                          ></img>
                        </div>
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Name"
                            value={subscriber.FileName}
                            onChange={(e) => {
                              DcoumnetNameEdit(e, index);
                            }}
                          />
                        </div>
                        <div className="col-md-2">
                          <button
                            type="button"
                            className="btn btn-sm btn-danger shadow-add  "
                            onClick={(e) => {
                              ondeleteDocumentFile(subscriber._id, index);
                            }}
                          >
                            <i className="fas fa-lg fa-fw  fa-trash-alt"></i>
                          </button>
                        </div>
                      </div>
                    ))}
                    <div className="form-group row m-b-15">
                      <label className="col-form-label col-md-3">Website</label>
                      <div className="col-md-9">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter website address"
                          value={CertificateWebsite}
                          onChange={onChangeWebsiteName}
                        />
                      </div>
                      {CertificateWebsiteError.length > 0 ? (
                        <span style={{ color: "red" }}>
                          {CertificateWebsiteError}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </ModalBody>
                  <ModalFooter>
                    <button
                      type="button"
                      onClick={() => {
                        createDocument();
                      }}
                      className="btn btn-primary shadow-add"
                    >
                      Save
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        toggleSignupAdd();
                      }}
                      className="btn btn-danger shadow-add  m-r-10"
                    >
                      Discard
                    </button>
                  </ModalFooter>
                </Modal>
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader>
                <h4 className="mb-0 text-light">Price</h4>
                <div className="form-group row m-b-0 mr-3">
                  <div className="col-md-12">
                    <div className="checkbox checkbox-css checkbox-inline pt-0">
                      <input
                        type="checkbox"
                        checked={IsPriceDisplay}
                        onChange={(e) => {
                          ProductIsPricehandleSubmit(e);
                        }}
                        id="inlineCssCheckboxa1"
                      />
                      <label htmlFor="inlineCssCheckboxa1">Publish</label>
                    </div>
                  </div>
                </div>
              </PanelHeader>
              <PanelBody>
                {/* <div>
                                <h5 className="m-b-15">Price</h5>
                            </div> */}
                <div className="form-group">
                  <label>Select Currency </label>
                  <div className="row">
                    <select
                      className="default-select2 form form-control col-xl-6 col-xs-11 m-l-10"
                      value={CurrencyId}
                      onChange={(e) => {
                        onChangeCurrencydropdown(e);
                      }}
                    >
                      <option value="" selected>
                        --- Select Currency ---
                      </option>
                      {CurrencyDetailsList.map((item) => (
                        <option value={item.value}>{item.text}</option>
                      ))}
                    </select>
                    {CurrencyError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {CurrencyError}
                      </span>
                    )}
                  </div>
                </div>
                <div className="form-group ">
                  <label htmlFor="exampleInputEmail1 " className="">
                    Regular Price{" "}
                  </label>
                  <div className="row">
                    {/* <input type="text"
                                            className="form-control form col-xl-6 col-xs-11 m-l-10"
                                            placeholder="Regular Price"
                                            value={RegularPrice}
                                            pattern="^\$\d{1,3}(,\d{3})*(\.\d+)?$"
                                            onChange={(e) => { onChangeRegularPrice(e) }}
                                        /> */}
                    <NumericFormat
                      thousandSeparator={true}
                      className="form-control form col-xl-6 col-xs-11 m-l-10"
                      placeholder="Regular Price"
                      decimalScale={2}
                      fixedDecimalScale={false}
                      value={RegularPrice}
                      // onBlur={onChangeRegularPrice}
                      // onFocus={onChangeRegularPrice}
                      onValueChange={onChangeRegularPrice}
                    // format={'##.##'}
                    />
                  </div>
                  {RegularPriceError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {RegularPriceError}
                    </span>
                  )}
                </div>
                <div className="form-group ">
                  <label htmlFor="exampleInputEmail1 " className="">
                    Sale Price{" "}
                  </label>
                  <div className="row">
                    {/* <input type="text"
                                            className="form-control form col-xl-6 col-xs-11 m-l-10"
                                            placeholder="Sale Price"
                                            value={SellPrice}
                                            onChange={(e) => { onChangeSellPrice(e) }}
                                        /> */}
                    <NumericFormat
                      thousandSeparator={true}
                      className="form-control form col-xl-6 col-xs-11 m-l-10"
                      placeholder="Regular Price"
                      decimalScale={2}
                      fixedDecimalScale={false}
                      value={SellPrice}
                      // onBlur={onChangeSellPrice}
                      // onFocus={onChangeSellPrice}
                      onValueChange={onChangeSellPrice}
                    // format={'##.##'}
                    />
                  </div>
                  {SellPriceError.length > 0 && (
                    <span style={{ color: "red", marginLeft: 6 }}>
                      {SellPriceError}
                    </span>
                  )}
                </div>
                {/*
                            <div className="mt-5"> </div>
                            <div className="mt-5"> </div>
                            <div className="mt-4"> </div> */}

                <button
                  type="button"
                  onClick={() => {
                    createPrice();
                  }}
                  className="btn btn-primary shadow-add m-r-10 m-t-30"
                >
                  Save Changes
                </button>
                {/* <button type="button" className="btn btn-danger shadow-add  m-t-30">Reset</button> */}
              </PanelBody>
            </Panel>
          </div>
          <div className="col-xl-5">
            <Panel>
              <PanelHeader>
                <h4 className="mb-0 text-light">Size Table</h4>
                <div className="form-group row m-b-0 mr-3">
                  <div className="col-md-12">
                    <div className="checkbox checkbox-css checkbox-inline pt-0">
                      <input
                        type="checkbox"
                        checked={IsSizeTabelDisplay}
                        onChange={(e) => {
                          IsSizeTabelhandleSubmit(e);
                        }}
                        id="inlineCssCheckboxa41"
                      />

                      <label htmlFor="inlineCssCheckboxa41">Publish</label>
                    </div>
                  </div>
                </div>
              </PanelHeader>
              <PanelBody>
                <div className="form-group row m-b-15">
                  <label className="col-md-3 col-form-label">Size Table</label>

                  <form className="col-md-9">
                    <div className="form-group">
                      {/* <input type="file" className="form-control" /> */}
                      <div class="custom-file ">
                        <input
                          type="file"
                          ref={ref}
                          onChange={(e) => {
                            SizetableuploadSingleFile(e);
                          }}
                          className="custom-file-input "
                          id="sizetable"
                        />
                        <label
                          className="custom-file-label file-upload"
                          for="sizetable "
                        >
                          Upload
                        </label>
                      </div>
                      {SizetablefilePath.length > 0 ? (
                        // <img src={SizetablefilePath} className="img-upload-size" />

                        <div className="sizetbleimg">
                          <img
                            src={SizetablefilePath}
                            style={{ height: "100px", width: "100px" }}
                            onError={({ currentTarget }) => {
                              currentTarget.onerror = null; // prevents looping
                              currentTarget.src =
                                "../assets/img/new-images/images.png";
                            }}
                          ></img>
                          <button
                            type="button"
                            className="deletebtn rounded-circle shadow-add"
                            onClick={() => {
                              DeleteSizeTable();
                            }}
                          >
                            <i className="fas fa-lg fa-trash-alt text-denger"></i>
                          </button>
                        </div>
                      ) : (
                        <img
                          src="../assets/img/new-images/images.png"
                          className="img-upload-size"
                        ></img>
                      )}
                    </div>

                    <button
                      type="button"
                      className="btn btn-primary shadow-add m-r-10"
                      onClick={() => {
                        CreateSizeTablePics();
                      }}
                    >
                      Upload
                    </button>

                    {/* <button type="button" className="btn btn-danger shadow-add">Reset</button> */}
                  </form>
                </div>
              </PanelBody>
            </Panel>

            <Panel>
              <PanelHeader>
                <h4 className="mb-0 text-light">Select Label</h4>
                {/* <div className="form-group row m-b-0 mr-3">

                                <div className="col-md-12">
                                    <div className="checkbox checkbox-css checkbox-inline pt-0">
                                        <input type="checkbox"
                                            checked={IsLabelDisplay}
                                            onChange={(e) => { ProductIsLabelhandleSubmit(e) }}
                                            id="inlineCssCheckboxa3" />
                                        <label htmlFor="inlineCssCheckboxa3">Publish</label>
                                    </div>

                                </div>
                            </div> */}
              </PanelHeader>
              <PanelBody>
                <div className="form-group">
                  <label htmlFor="exampleInputPassword1">Label / Brand</label>
                  <div className="row align-items-center">
                    <select
                      className="default-select2 form  form-control m-r-10 m-l-10  col-md-8 col-xs-7"
                      value={LabelId}
                      onChange={(e) => {
                        onChangeLabeldrop(e);
                      }}
                    >
                      <option value="" selected>
                        --- Select Label ---
                      </option>
                      {LabelList.map((item) => (
                        <option value={item.value}>{item.text}</option>
                      ))}
                    </select>
                    {LabelError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {LabelError}
                      </span>
                    )}

                    <button
                      onClick={toggleLableModel}
                      type="submit"
                      className="btn btn-sm btn-purple add-new shadow-add m-r-5 col-md-3 col-xs-4 my-2"
                    >
                      Add New Label{" "}
                    </button>
                  </div>
                  <label htmlFor="">{OldLabelName}</label>
                </div>
                <button
                  type="button"
                  onClick={() => {
                    CreateLabelbrandnds();
                  }}
                  className="btn btn-primary shadow-add m-r-10"
                >
                  Save Changes
                </button>
                {/* <button type="button" className="btn btn-danger shadow-add">Reset</button> */}
              </PanelBody>
              {/* Lable Modal*/}
              <Modal
                isOpen={LableModelisOpen}
                toggle={LableModelisOpen}
                onHide={() => toggleLableModel()}
              >
                <ModalHeader toggle={toggleLableModel} className="modalheader">
                  <h4 className="text-white mb-0">Add New Label</h4>
                </ModalHeader>
                <ModalBody>
                  <div className="form-group row m-b-15">
                    <label className="col-md-3 col-form-label">Name</label>
                    <div className="col-md-9">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Name"
                        value={LabelName}
                        maxLength={40}
                        onChange={(e) => {
                          onChangeLableName(e);
                        }}
                      />
                      <p
                        style={{
                          textAlign: "right",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {LabelName.length}/40
                      </p>
                    </div>
                    {LabelNamError.length > 0 && (
                      <span style={{ color: "red", marginLeft: 6 }}>
                        {LabelNamError}
                      </span>
                    )}
                  </div>

                  <div className=" row m-b-15">
                    <div className="col-md-3 ">Logo</div>
                    <div className="col-md-9">
                      <div class="custom-file file-upload-height">
                        <input
                          type="file"
                          onChange={(e) => setLableFile(e)}
                          className="custom-file-input file-upload-height"
                          id="customFile"
                        />
                        <label
                          className=" file-upload-1 file-upload-height"
                          for="customFile "
                        >
                          {LogoPath.length > 0 ? (
                            <img src={LogoPath} className="img-upload-size-1" />
                          ) : (
                            <img
                              src="../assets/img/new-images/images.png"
                              className="img-upload-size-1"
                            ></img>
                          )}

                          <div className="file-upload-3 ">
                            <i className="ion ion-md-camera  fa-sm"></i>
                          </div>
                        </label>
                        {LogoPathError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {LogoPathError}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="form-group row m-b-15">
                    <label className="col-form-label col-md-3">
                      Description
                    </label>
                    <div className="col-md-9">
                      <textarea
                        className="form-control"
                        value={LableDescription}
                        rows="3"
                        maxLength={300}
                        placeholder="Enter Description"
                        onChange={(e) => {
                          onChangeLableDescription(e);
                        }}
                      ></textarea>
                      <p
                        style={{
                          textAlign: "right",
                          fontSize: 12,
                          color: "red",
                        }}
                      >
                        {LableDescription.length}/300
                      </p>
                      {DescriptionError.length > 0 && (
                        <span style={{ color: "red", marginLeft: 6 }}>
                          {DescriptionError}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="form-group row m-b-15">
                    <label className="col-form-label col-md-3"></label>
                    <div className="col-md-9">
                      <button
                        type="button"
                        onClick={() => {
                          createLabelbrand();
                        }}
                        className="btn btn-primary shadow-add m-r-10"
                      >
                        Save
                      </button>
                      <button
                        type="button"
                        onClick={() => {
                          toggleLableModel();
                        }}
                        className="btn btn-danger shadow-add  "
                      >
                        Discard
                      </button>
                    </div>
                  </div>
                </ModalBody>
              </Modal>
            </Panel>
            <Panel>
              <PanelHeader>
                <h4 className="mb-0 text-light">SKU</h4>
                {/* <div className="form-group row m-b-0 mr-3">
                                <div className="col-md-12">
                                    <div className="checkbox checkbox-css checkbox-inline pt-0">

                                        <input type="checkbox"
                                            checked={IsSKUDisplay}
                                            onChange={(e) => { ProductIsSKUhandleSubmit(e) }}
                                            id="inlineCssCheckboxb1" />
                                        <label htmlFor="inlineCssCheckboxb1">Publish</label>
                                    </div>

                                </div>
                            </div> */}
              </PanelHeader>
              <PanelBody>
                <form action="javascript:void(0);" method="POST">
                  <fieldset>
                    <div className="form-group row m-b-15">
                      <label className="col-md-3 col-form-label">
                        Entre Product SKU
                      </label>
                      <div className="col-md-6">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Product SKU"
                          value={ArticleSKU}
                          onChange={(e) => {
                            onChangeProductSKU(e);
                          }}
                        />

                        {ArticleSKUError.length > 0 && (
                          <span style={{ color: "red", marginLeft: 6 }}>
                            {ArticleSKUError}
                          </span>
                        )}
                        {OldArticleSKU && (
                          <div className="row m-b-15">
                            <label className="col-xl-6 col-xs-8 m-b-2">
                              {OldArticleSKU}
                            </label>
                            <div className="col-xl-6 col-xs-8 m-t-2">
                              <a
                                className="btn btn-danger shadow-add btndelete"
                                onClick={(e) => {
                                  Deletesku(ArticleID);
                                }}
                              >
                                <i className="fas fa-trash"></i>
                              </a>
                            </div>
                          </div>
                        )}
                      </div>
                      <div className="col-md-3">
                        <button
                          type="button"
                          onClick={() => {
                            createSku();
                          }}
                          className="btn btn-primary shadow-add m-r-10"
                        >
                          Save
                        </button>
                        {/* <button type="button" className="btn btn-danger shadow-add">Reset</button> */}
                      </div>
                    </div>
                  </fieldset>
                </form>
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader>
                <h4 className="mb-0 text-light">Product chat</h4>
              </PanelHeader>
              <PanelBody>
                <div className="container">
                  <div className="form-group row m-b-10  align-items-center">
                    <div className="checkbox checkbox-css checkbox-inline checkbox-5 pt-0">
                      <input
                        type="checkbox"
                        id="distanceCheckboxae1"
                        checked={IsArticlechat}
                        onChange={(e) => {
                          IsArticlechathandleSubmit(e);
                        }}
                      />
                      <label htmlFor="distanceCheckboxae1"></label>
                    </div>
                    <label className="col-form-label product-lable">
                      Product chat enable
                    </label>
                  </div>
                </div>
              </PanelBody>
            </Panel>
            <Panel>
              <PanelHeader>
                <h4 className="mb-0 text-light">Related product</h4>
              </PanelHeader>
              <PanelBody>
                <div className="container">
                  <div className="form-group row m-b-10  align-items-center">
                    <div className="checkbox checkbox-css checkbox-inline checkbox-5 pt-0">
                      <input
                        type="checkbox"
                        value=""
                        id="RelatedCheckboxae1"
                        checked={Isrelatedproduct}
                        onChange={(e) => {
                          IsrelatedproducthandleSubmit(e);
                        }}
                      />
                      <label htmlFor="RelatedCheckboxae1"></label>
                    </div>
                    <label className="col-form-label product-lable">
                      Related product display
                    </label>
                  </div>
                </div>
              </PanelBody>
            </Panel>

          </div>
        </div>

        <div className="row align-items-stretch">
          <div className="col-xl-5"></div>
        </div>
        <div className="my-5 d-flex justify-content-center">
          <button
            type="button"
            className="btn btn-primary shadow-add btn-lg"
            onClick={(e) => {
              toggleQrcode();
            }}
          >
            Create QR Code
          </button>
          <button className={"btn btn-white btn-shadow p-2 border ml-3"}>
            <img
              src="../assets/img/user/QR.png"
              style={{ height: "40px", width: "40px" }}
            ></img>
          </button>
        </div>
        <Modal
          isOpen={modalvendor}
          toggle={vendoraddtoggle}
          className="modal-size"
        >
          <ModalHeader toggle={vendoraddtoggle} className="modalheader">
            <h5 className="text-white mb-0">Add Vendors</h5>
          </ModalHeader>

          <ModalBody className="p-0">
            <div className="form-group row mb-0 profile-box p-0 mx-0 ">
              <label className="col-xl-2 col-form-label left-border">
                Vendors Name
              </label>
              <div className="col-xl-5 py-3">
                <input
                  type="text"
                  className="form-control input-design-1"
                  placeholder="Enter New Vendors Name"
                  value={VendorsName}
                  onChange={onChangeVendorsName}
                />
                {VendorsNameError.length > 0 && (
                  <p style={{ color: "red", fontSize: 13, marginLeft: 6 }}>
                    {VendorsNameError}
                  </p>
                )}
              </div>
            </div>

            <div className=" row mb-0 profile-box p-0 mx-0 ">
              <div className="col-xl-2 col-form-label left-border">Logo</div>
              <div className="col-xl-5 d-block py-3">
                <div class="custom-file file-upload-height mb-2">
                  <input
                    type="file"
                    onChange={(e) => VendorsuploadSingleFile(e)}
                    className="custom-file-input file-upload-height"
                    id="customFile"
                  />
                  <label
                    className=" file-upload-1 file-upload-height"
                    for="customFile "
                  >
                    <div>
                      <img
                        src={VendorsLogoPath}
                        style={{ height: "60px" }}
                      ></img>
                    </div>
                    <div className="file-upload-2 ">
                      <i className="ion ion-md-camera "></i>
                    </div>
                  </label>
                </div>
                {VendorsLogoError.length > 0 && (
                  <p style={{ color: "red", fontSize: 13, marginLeft: 6 }}>
                    {VendorsLogoError}
                  </p>
                )}
              </div>
            </div>
            <div className="form-group mb-0 row profile-box p-0 mx-0 ">
              <label className="col-xl-2 col-form-label left-border ">
                Contact Email{" "}
              </label>
              <div className="col-xl-5 py-3">
                <input
                  type="text"
                  className="form-control input-design-1"
                  placeholder="Enter Vendors Email"
                  value={Email}
                  onChange={onChangeVendorsEmail}
                />
                {EmailError.length > 0 && (
                  <span style={{ color: "red", fontSize: 13, marginLeft: 6 }}>
                    {EmailError}
                  </span>
                )}
              </div>
            </div>
            <div className="form-group mb-0 row profile-box p-0 mx-0 ">
              <label className="col-xl-2 col-form-label left-border ">
                Contact number{" "}
              </label>
              <div className="col-xl-5 py-3">
                <input
                  type="tel"
                  className="form-control input-design-1"
                  placeholder="Enter Contact number"
                  value={ContactNo}
                  onChange={onChangeVendorsContactNo}
                />
                {ContactNoError.length > 0 && (
                  <span style={{ color: "red", fontSize: 13, marginLeft: 6 }}>
                    {ContactNoError}
                  </span>
                )}
              </div>
            </div>
            <div className="form-group mb-0 row profile-box p-0 mx-0 ">
              <label className="col-xl-2 col-form-label left-border ">
                Website
              </label>
              <div className="col-xl-5 py-3">
                <input
                  type="text"
                  className="form-control input-design-1"
                  placeholder="Enter Website"
                  value={vendorWebsite}
                  onChange={onChangeVendorsWebsite}
                />
                {vendorWebsiteError.length > 0 && (
                  <span style={{ color: "red", fontSize: 13, marginLeft: 6 }}>
                    {vendorWebsiteError}
                  </span>
                )}
              </div>
            </div>
            <div className="form-group row mb-0 mx-0  profile-box p-0">
              <label className="col-xl-2   col-form-label left-border">
                Address{" "}
              </label>
              <div className="col-xl-10 py-3 ">
                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="exampleInputEmail1">Street</label>
                    <input
                      type="tel"
                      className="form-control input-design-1"
                      placeholder="Please Enter Street"
                      value={VendorStreet}
                      onChange={onChangeVendorsStreet}
                    />
                    {VendorStreetError.length > 0 && (
                      <span
                        style={{ color: "red", fontSize: 13, marginLeft: 6 }}
                      >
                        {VendorStreetError}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-3">
                    <label htmlFor="exampleInputEmail1">House Number</label>
                    <input
                      type="tel"
                      className="form-control input-design-1"
                      placeholder="Please Enter House Number"
                      value={HouseNo}
                      onChange={onChangeVendorsHouseNo}
                    />
                    {HouseNoError.length > 0 && (
                      <span
                        style={{ color: "red", fontSize: 13, marginLeft: 6 }}
                      >
                        {HouseNoError}
                      </span>
                    )}
                  </div>

                  <div className="form-group col-md-3">
                    <label htmlFor="exampleInputEmail1">PLZ / Post Code</label>
                    <input
                      type="tel"
                      className="form-control input-design-1"
                      placeholder="Please Enter Postcode"
                      value={Postcode}
                      onChange={onChangeVendorsPostcode}
                    />
                    {PostcodeError.length > 0 && (
                      <span
                        style={{ color: "red", fontSize: 13, marginLeft: 6 }}
                      >
                        {PostcodeError}
                      </span>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label htmlFor="exampleInputEmail1">City</label>
                    <input
                      type="tel"
                      className="form-control input-design-1"
                      placeholder="Please Enter City"
                      value={City}
                      onChange={onChangeVendorsCity}
                    />
                    {CityError.length > 0 && (
                      <span
                        style={{ color: "red", fontSize: 13, marginLeft: 6 }}
                      >
                        {CityError}
                      </span>
                    )}
                  </div>
                  <div className="form-group col-md-6">
                    <label htmlFor="exampleInputEmail1">Country</label>
                    <div className="d-flex">
                      <select
                        className="default-select2  form-control"
                        value={CountryId}
                        onChange={onChangeParamdetaildropdown}
                      >
                        <option value="" selected>
                          --- Select Country ---
                        </option>
                        {CountrydetailList.map((item) => (
                          <option value={item.value}>{item.text}</option>
                        ))}
                      </select>
                    </div>
                    {CountryIdError.length > 0 && (
                      <span
                        style={{ color: "red", fontSize: 13, marginLeft: 6 }}
                      >
                        {CountryIdError}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group mb-0 row profile-box p-0 mx-0 ">
              <label className="col-xl-2 col-form-label left-border">
                Description{" "}
              </label>
              <div className="col-xl-5 py-3">
                <textarea
                  className="form-control"
                  value={VendorsDescription}
                  rows="3"
                  maxLength={300}
                  placeholder="Enter Vendors Description"
                  onChange={onChangeVendorsdescription}
                ></textarea>

                {VendorsDescriptionError.length > 0 && (
                  <span style={{ color: "red", fontSize: 13, marginLeft: 6 }}>
                    {VendorsDescriptionError}
                  </span>
                )}
                <span
                  style={{
                    color: "red",
                    fontSize: 13,
                    marginLeft: 6,
                    float: "right",
                  }}
                >
                  {VendorsDescription.length}/300
                </span>
              </div>
            </div>
            <div className="row justify-content-between">
              <div className="col-md-4">
                <button
                  type="button"
                  className="btn btn-primary shadow-add my-3 m-l-10 m-r-10"
                  onClick={() => {
                    CreateUserProfileVendors();
                  }}
                >
                  Save
                </button>
                <button
                  type="button"
                  className="btn btn-danger shadow-add my-3"
                  onClick={() => {
                    DiscardUserProfileVendors();
                  }}
                >
                  Discard
                </button>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={isToEamil} toggle={toggleToEmail}>
          <ModalHeader toggle={toggleToEmail} className="modalheader">
            <h5 className="text-white mb-0">To Email</h5>
          </ModalHeader>
          <ModalBody>
            <div className="col-md-12">
              <label
                htmlFor="exampleInputPassword1"
                className="mt-2 d-flex align-items-center"
              >
                <h5 className="mb-0">Add To Email</h5>
                <button
                  type="button"
                  className="m-l-10 btn btn-link"
                  onClick={SubToEmailaddClick}
                >
                  <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
                </button>
              </label>
            </div>
            <div className="form-group">
              {createSubToEmailUI()}
              {isToemailMaltiple === true ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {"Email id dublicate"}
                </span>
              ) : (
                <></>
              )}
              {ToemailEmptyError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {ToemailEmptyError}
                </span>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={() => {
                  QRCodeArticleSend();
                }}
                className="btn btn-sm btn-primary m-r-5 shadow-add "
              >
                Send Email
              </button>
              <button
                type="button"
                onClick={() => {
                  toggleToEmail();
                }}
                className="btn btn-sm btn-danger shadow-add "
              >
                Cancel
              </button>
            </div>
          </ModalBody>
        </Modal>

        <Modal
          isOpen={isToEamilAttribute}
          toggle={toggleToEmailAttributecreate}
        >
          <ModalHeader
            toggle={toggleToEmailAttributecreate}
            className="modalheader"
          >
            <h5 className="text-white mb-0">To Email</h5>
          </ModalHeader>
          <ModalBody>
            <div className="col-md-12">
              <label
                htmlFor="exampleInputPassword1"
                className="mt-2 d-flex align-items-center"
              >
                <h5 className="mb-0">Add To Email</h5>
                <button
                  type="button"
                  className="m-l-10 btn btn-link"
                  onClick={SubToEmailaddClick}
                >
                  <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
                </button>
              </label>
            </div>
            <div className="form-group">
              {createSubToEmailUI()}
              {isToemailMaltiple === true ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {"Email id dublicate"}
                </span>
              ) : (
                <></>
              )}
              {ToemailEmptyError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {ToemailEmptyError}
                </span>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={() => {
                  QRCodeArticleSendAttributecreate();
                }}
                className="btn btn-sm btn-primary m-r-5 shadow-add "
              >
                Send Email
              </button>
              <button
                type="button"
                onClick={() => {
                  toggleToEmailAttributecreate();
                }}
                className="btn btn-sm btn-danger shadow-add "
              >
                Cancel
              </button>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={isDuplicateToEamil} toggle={toggleDuplicateSendEmail}>
          <ModalHeader
            toggle={toggleDuplicateSendEmail}
            className="modalheader"
          >
            <h5 className="text-white mb-0">To Email</h5>
          </ModalHeader>
          <ModalBody>
            <div className="col-md-12">
              <label
                htmlFor="exampleInputPassword1"
                className="mt-2 d-flex align-items-center"
              >
                <h5 className="mb-0">Add To Email</h5>
                <button
                  type="button"
                  className="m-l-10 btn btn-link"
                  onClick={SubToEmailaddClick}
                >
                  <i className="fas fa-lg fa-fw fa-plus-circle text-success"></i>
                </button>
              </label>
            </div>
            <div className="form-group">
              {createSubToEmailUI()}
              {isToemailMaltiple === true ? (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {"Email id dublicate"}
                </span>
              ) : (
                <></>
              )}
              {ToemailEmptyError.length > 0 && (
                <span style={{ color: "red", marginLeft: 6 }}>
                  {ToemailEmptyError}
                </span>
              )}
            </div>
            <div className="d-flex justify-content-center">
              <button
                type="button"
                onClick={() => {
                  sendpdfEmail();
                }}
                className="btn btn-sm btn-primary m-r-5 shadow-add "
              >
                Send Email
              </button>
              <button
                type="button"
                onClick={() => {
                  toggleDuplicateSendEmail();
                }}
                className="btn btn-sm btn-danger shadow-add "
              >
                Cancel
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
}

export default Addnew;